/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 81);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = vendor_lib;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(0);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(49);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInvalidID = isInvalidID;
exports.buildQueryString = buildQueryString;
exports.getCountryCode = getCountryCode;
exports.isPublic = isPublic;
exports.isPublicHost = isPublicHost;
exports.getNuiBaseUrlFromHost = getNuiBaseUrlFromHost;
exports.getAppCenterPathName = getAppCenterPathName;
exports.getNuiLanguage = getNuiLanguage;
exports.mapCountryToPublicLang = mapCountryToPublicLang;
exports.getCanonicalLink = getCanonicalLink;
exports.getHreflangLinks = getHreflangLinks;
exports.sendPublicView = sendPublicView;
exports.escapeHTML = escapeHTML;
exports.getAPIEndpoint = exports.canUseDOM = exports.isClient = exports.HOME = void 0;

var _config = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HOME = 'home';
exports.HOME = HOME;
var isClient = typeof document !== 'undefined';
exports.isClient = isClient;

var canUseDOM = function canUseDOM() {
  return typeof window !== 'undefined' && window.document && window.document.createElement;
};
/**
 * Determines if the given ID is invalid, to prevent JS injection
 * @param {string} id id of the listing
 * @returns {string} true if invalid, false if valid
 * @throws will throw if the given url is empty
 */


exports.canUseDOM = canUseDOM;

function isInvalidID(id) {
  if (id === undefined) throw new Error('must provide an ID');
  var re = new RegExp('[^-A-Za-z0-9+&@#/%?=~_$|!:,.;()]');
  return re.test(id);
}

var getAPIEndpoint = function getAPIEndpoint() {
  if (canUseDOM()) {
    return "".concat(_config.default.appcenterAPIBase.client, "/api/");
  }

  return "".concat(_config.default.appcenterAPIBase.server, "/api/");
};

exports.getAPIEndpoint = getAPIEndpoint;

function buildQueryString(parameters) {
  // TODO: remove this function once node 7.3+ becomes ubiquitous
  var ObjectToArray = function ObjectToArray(x) {
    return Object.keys(x).reduce(function (y, z) {
      return y.push([z, x[z]]) && y;
    }, []);
  };

  var qs = ObjectToArray(parameters).reduce(function (acc, curr) {
    var _curr = _slicedToArray(curr, 2),
        key = _curr[0],
        value = _curr[1];

    if (Object.hasOwnProperty.call(parameters, key)) {
      if (value) {
        return "".concat(acc).concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value), "&");
      }
    }

    return acc;
  }, '');

  if (qs.length > 0) {
    return "?".concat(qs.substring(0, qs.length - 1)); // chop off last "&"
  }

  return '';
}
/**
 * Determines the Country Code that should be used for a given domain
 * @param {string} url the url the request originates from
 * @returns {string} a Country Code
 * @throws will throw if the given url is empty
 */


function getCountryCode(url) {
  if (!url && url !== '') throw new Error('must provide a url');
  var lowerURL = url.toLowerCase();
  var urlToLang = new Map([['concur.co.jp', 'JP'], ['concur.co.uk', 'GB'], ['concur.com.au', 'AU'], ['concur.de', 'DE'], ['concur.com', 'US'], ['concur.ca', 'CA'], ['concur.com.mx', 'MX'], ['concur.cn', 'CN']]);
  if (urlToLang.has(lowerURL)) return urlToLang.get(lowerURL); // wasn't an exact match, look for partial match (e.g. concur.com.nonprod.cnqr.tech)

  var match = _toConsumableArray(urlToLang.entries()).find(function (elem) {
    return lowerURL.includes(elem[0]);
  });

  return match ? match[1] : 'US';
}
/**
 * Determines if the given path represents a public version of appcenter
 * @param {string} path the current path e.g. /app-center, /nui/appcenter
 * @returns {boolean} true if public, false if not
 */


function isPublic(path) {
  return /app-center|app-centre/.test(path);
}
/**
 * Determines if the given host is a public appcenter domain
 * @param {string} host e.g. concur.com, concursolutions.com
 * @returns {boolean} true if public, false if not
 * @throws will throw if the given host is empty
 */


function isPublicHost(host) {
  if (!host && host !== '') throw new Error('must provide host');
  var publicDomains = ['concur.co.jp', 'concur.co.uk', 'concur.com.au', 'concur.de', 'concur.com', 'concur.ca', 'concur.com.mx', 'concur.cn'];
  return publicDomains.some(function (domain) {
    return host.toLowerCase().includes(domain);
  });
}

function getNuiBaseUrlFromHost(host) {
  return isPublicHost(host) ? 'app-center' : _config.default.nui.baseUrl;
}
/**
 * Determines the base path to use for building links
 * @param {string} path the current path e.g. /nui/appcenter/listing/1
 * @returns {string} a base to use for building links e.g. /nui/appcenter
 * @throws will throw if the given path does not match
 */


function getAppCenterPathName(path) {
  var publicRegex = new RegExp(/app-center|app-centre/);
  var privateRegex = new RegExp(/nui\/appcenter/);
  var errorRegex = new RegExp(/404/);
  if (publicRegex.test(path)) return "/".concat(path.match(publicRegex)[0]);
  if (privateRegex.test(path)) return _config.default.nui.baseUrl;
  if (errorRegex.test(path)) return '/404';
  throw new Error("given pathname \"".concat(path, "\" not supported"));
}
/**
 * Determines the language FOR NUI to use for different public appcenter domains
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'jp'
 * @throws will throw if the given domain is empty
 */


function getNuiLanguage(domain) {
  if (!domain && domain !== '') throw new Error('must provide domain');
  var lowerDomain = domain.toLowerCase();
  var domainToLang = new Map([['concur.co.jp', 'ja'], ['concur.co.uk', 'en-gb'], ['concur.com.au', 'en-gb'], ['concur.com', 'en'], ['concur.de', 'de'], ['concur.ca', 'en'], ['concur.com.mx', 'es-la'], ['concur.cn', 'zh-cn']]);
  if (domainToLang.has(lowerDomain)) return domainToLang.get(lowerDomain); // wasn't an exact match, look for partial match (e.g. concur.com.nonprod.cnqr.tech)

  var match = _toConsumableArray(domainToLang.entries()).find(function (elem) {
    return lowerDomain.includes(elem[0]);
  });

  return match ? match[1] : 'en';
}
/**
 * Determines the language FOR PUBLIC WRAPPER to use
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'ja-jp'
 * @throws will throw if the given country is empty
 */


function mapCountryToPublicLang(country) {
  if (!country) throw new Error('must provide country');
  var langMap = {
    DE: 'de-de',
    AU: 'en-au',
    CA: 'en-ca',
    GB: 'en-uk',
    US: 'en-us',
    JP: 'ja-jp',
    SP: 'sp-mx',
    CN: 'zh-hans-cn'
  };
  return langMap[country.toUpperCase()] || 'en-us';
}
/**
 * Determines the public appcenter canonical link should be used based on the host and mapping
 * @param {string} path the current path
 * @return {string} canonical link should use in canonical link tag
 */


function getCanonicalLink(host, location) {
  if (!host) throw new Error('must provide host');
  var appCentreDomains = ['concur.co.uk', 'concur.com.au', 'concur.ca'];
  var appCenterLocation = location.replace('app-centre', 'app-center');
  var appCentereLocation = location.replace('app-center', 'app-centre');
  return appCentreDomains.some(function (domain) {
    return host.toLowerCase().includes(domain);
  }) ? "https://".concat(host).concat(appCentereLocation) : "https://".concat(host).concat(appCenterLocation);
}
/**
 * In order to do international SEO for public appcenter, we need to push all the public appcenter sites with hreflang tag
 * @param {object[]} path the current path
 * @return {object[]} canonical link should use in canonical link tag
 */


function getHreflangLinks(links) {
  var useEnGB = ['https://www.concur.com.au', 'https://www.concur.co.uk', 'https://www.concur.ca'];
  var hrefs = {
    'https://www.concur.co.jp': 'ja',
    'https://www.concur.co.uk': 'en-gb',
    'https://www.concur.com.au': 'en-au',
    'https://www.concur.com': 'en-us',
    'https://www.concur.de': 'de-de',
    'https://www.concur.ca': 'en-ca'
  };

  for (var href in hrefs) {
    var path = '/app-center/';

    if (useEnGB.includes(href)) {
      path = '/app-centre/';
    }

    links.push({
      rel: 'alternate',
      href: href + path,
      hreflang: hrefs[href]
    });
  }
}
/**
 * Sets page_name and triggers a view metric for public logging (concur.com)
 */


function sendPublicView() {
  if (canUseDOM() && window.getPagePath) {
    var pageName = window.getPagePath('page_name');
    window.utag_data.page_name = pageName;
    window.utag.view({
      page_name: pageName
    });
  }
}
/**
 * Strips out HTML tag characters from provided string
 * @param {string} text the potentially unsafe text to sanitize
 * @returns {string} string with dangerous characters removed
 */


function escapeHTML(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
  };
  return text.replace(/[&<>"]/g, function (m) {
    return map[m];
  });
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(339);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLocalizedRegions = fetchLocalizedRegions;
exports.fetchLocalizedCountries = fetchLocalizedCountries;
exports.fetchListing = fetchListing;
exports.shouldFetchListing = shouldFetchListing;
exports.fetchListingIfNeeded = fetchListingIfNeeded;
exports.queryBuilder = queryBuilder;
exports.connectWithLoyaltyNumber = connectWithLoyaltyNumber;
exports.toggleNeedAnAccountClicked = toggleNeedAnAccountClicked;
exports.checkForConnection = checkForConnection;
exports.connectListing = connectListing;
exports.disconnectListing = disconnectListing;
exports.updateLoyaltyNum = updateLoyaltyNum;
exports.inquireListing = inquireListing;
exports.default = listing;
exports.initialState = exports.disconnectFromListing = exports.toggleModal = exports.setListings = exports.fetchListItems = exports.CONFIRMATION_MODAL = exports.DISCONNECT_MODAL = exports.UNENROLL_MODAL = exports.ENROLL_MODAL = exports.POPUP_IS_CLOSED = exports.POPUP_IS_OPEN = exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = exports.UPDATE_CONNECTION_PENDING = exports.SET_IS_CONNECTING_TO_FALSE = exports.CONNECTION_STATUS_CHECKED_SUCCESS = exports.CONNECTION_STATUS_CHECKING = exports.TOGGLE_MODAL = exports.UPDATE_LOYALTY_NUM = exports.COUNTRIES_FETCH_FAILED = exports.REGIONS_FETCH_FAILED = exports.COUNTRIES_FETCHED = exports.REGIONS_FETCHED = exports.COUNTRIES_FETCHING = exports.REGIONS_FETCHING = exports.INQUIRE_LISTING = exports.DISCONNECT_LISTING = exports.UNENROLL_LISTING = exports.CONNECT_LISTING = exports.SET_LISTINGS = exports.LISTING_SHOULD_FETCH = exports.LISTING_FETCH_FAILED = exports.LISTING_NOT_FOUND = exports.LISTING_FETCHED = exports.LISTING_FETCHING = exports.LISTING_INVALID = void 0;

var _isomorphicFetch = _interopRequireDefault(__webpack_require__(54));

var _merge13 = _interopRequireDefault(__webpack_require__(23));

var _reduce2 = _interopRequireDefault(__webpack_require__(107));

var _filter2 = _interopRequireDefault(__webpack_require__(110));

var _keys2 = _interopRequireDefault(__webpack_require__(111));

var _has2 = _interopRequireDefault(__webpack_require__(25));

var _get2 = _interopRequireDefault(__webpack_require__(22));

var _config = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(4);

var _listingsModule = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APIEndpoint = (0, _utils.getAPIEndpoint)(); // Constants

var LISTING_INVALID = '@@listingModule/LISTING_INVALID';
exports.LISTING_INVALID = LISTING_INVALID;
var LISTING_FETCHING = '@@listingModule/LISTING_FETCHING';
exports.LISTING_FETCHING = LISTING_FETCHING;
var LISTING_FETCHED = '@@listingModule/LISTING_FETCHED';
exports.LISTING_FETCHED = LISTING_FETCHED;
var LISTING_NOT_FOUND = '@@listingModule/LISTING_NOT_FOUND';
exports.LISTING_NOT_FOUND = LISTING_NOT_FOUND;
var LISTING_FETCH_FAILED = '@@listingModule/LISTING_FETCH_FAILED';
exports.LISTING_FETCH_FAILED = LISTING_FETCH_FAILED;
var LISTING_SHOULD_FETCH = '@@listingModule/LISTING_SHOULD_FETCH';
exports.LISTING_SHOULD_FETCH = LISTING_SHOULD_FETCH;
var SET_LISTINGS = '@@listingModule/SET_LISTINGS';
exports.SET_LISTINGS = SET_LISTINGS;
var CONNECT_LISTING = '@@listingModule/CONNECT_LISTING';
exports.CONNECT_LISTING = CONNECT_LISTING;
var UNENROLL_LISTING = '@@listingModule/UNENROLL_LISTING';
exports.UNENROLL_LISTING = UNENROLL_LISTING;
var DISCONNECT_LISTING = '@@listingModule/DISCONNECT_LISTING';
exports.DISCONNECT_LISTING = DISCONNECT_LISTING;
var INQUIRE_LISTING = '@@listingModule/INQUIRE_LISTING';
exports.INQUIRE_LISTING = INQUIRE_LISTING;
var REGIONS_FETCHING = '@@listingModule/REGIONS_FETCHING';
exports.REGIONS_FETCHING = REGIONS_FETCHING;
var COUNTRIES_FETCHING = '@@listingModule/COUNTRIES_FETCHING';
exports.COUNTRIES_FETCHING = COUNTRIES_FETCHING;
var REGIONS_FETCHED = '@@listingModule/REGIONS_FETCHED';
exports.REGIONS_FETCHED = REGIONS_FETCHED;
var COUNTRIES_FETCHED = '@@listingModule/COUNTRIES_FETCHED';
exports.COUNTRIES_FETCHED = COUNTRIES_FETCHED;
var REGIONS_FETCH_FAILED = '@@listingModule/REGIONS_FETCH_FAILED';
exports.REGIONS_FETCH_FAILED = REGIONS_FETCH_FAILED;
var COUNTRIES_FETCH_FAILED = '@@listingModule/COUNTRIES_FETCH_FAILED';
exports.COUNTRIES_FETCH_FAILED = COUNTRIES_FETCH_FAILED;
var UPDATE_LOYALTY_NUM = '@@listingModule/UPDATE_LOYALTY_NUM';
exports.UPDATE_LOYALTY_NUM = UPDATE_LOYALTY_NUM;
var TOGGLE_MODAL = '@@listingModule/TOGGLE_MODAL';
exports.TOGGLE_MODAL = TOGGLE_MODAL;
var CONNECTION_STATUS_CHECKING = '@@listingModule/CONNECTION_STATUS_CHECKING';
exports.CONNECTION_STATUS_CHECKING = CONNECTION_STATUS_CHECKING;
var CONNECTION_STATUS_CHECKED_SUCCESS = '@@listingModule/CONNECTION_STATUS_CHECKED_SUCCESS';
exports.CONNECTION_STATUS_CHECKED_SUCCESS = CONNECTION_STATUS_CHECKED_SUCCESS;
var SET_IS_CONNECTING_TO_FALSE = '@@listingModule/SET_IS_CONNECTING_TO_FALSE';
exports.SET_IS_CONNECTING_TO_FALSE = SET_IS_CONNECTING_TO_FALSE;
var UPDATE_CONNECTION_PENDING = '@@lisingModule/UPDATE_CONNECTION_PENDING';
exports.UPDATE_CONNECTION_PENDING = UPDATE_CONNECTION_PENDING;
var TOGGLE_NEED_AN_ACCOUNT_CLICKED = '@@listingModule/TOGGLE_NEED_AN_ACCOUNT_CLICKED';
exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = TOGGLE_NEED_AN_ACCOUNT_CLICKED;
var POPUP_IS_OPEN = '@@lisingModule/POPUP_IS_OPEN';
exports.POPUP_IS_OPEN = POPUP_IS_OPEN;
var POPUP_IS_CLOSED = '@@lisingModule/POPUP_IS_CLOSED'; // Modal Names

exports.POPUP_IS_CLOSED = POPUP_IS_CLOSED;
var ENROLL_MODAL = '@@listingModule/ENROLL_MODAL';
exports.ENROLL_MODAL = ENROLL_MODAL;
var UNENROLL_MODAL = '@@listingModule/UNENROLL_MODAL';
exports.UNENROLL_MODAL = UNENROLL_MODAL;
var DISCONNECT_MODAL = '@@listingModule/DISCONNECT_MODAL';
exports.DISCONNECT_MODAL = DISCONNECT_MODAL;
var CONFIRMATION_MODAL = '@@listingModule/CONFIRMATION_MODAL'; // Helper

exports.CONFIRMATION_MODAL = CONFIRMATION_MODAL;

var fetchListItems = function fetchListItems(lang, item) {
  var endpoint, options, response, json;
  return regeneratorRuntime.async(function fetchListItems$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          endpoint = "".concat(APIEndpoint, "listitems/").concat(item, "?lang=").concat(lang);
          options = {
            method: 'GET',
            headers: {}
          };
          _context.next = 4;
          return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

        case 4:
          response = _context.sent;
          _context.next = 7;
          return regeneratorRuntime.awrap(response.json());

        case 7:
          json = _context.sent;
          return _context.abrupt("return", json);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  });
}; // Actions


exports.fetchListItems = fetchListItems;

var setListings = function setListings(listings) {
  var mergedListings = {};
  listings.forEach(function (listing) {
    var _newEntry;

    var newListing = {
      readyState: LISTING_FETCHED,
      data: _objectSpread({}, listing, {
        loyaltyNumber: ''
      })
    };
    var newEntry = (_newEntry = {}, _defineProperty(_newEntry, listing.ID, newListing), _defineProperty(_newEntry, listing.core.v1ID, newListing), _newEntry);
    (0, _merge13.default)(mergedListings, newEntry);
  });
  return {
    type: SET_LISTINGS,
    listings: mergedListings
  };
};

exports.setListings = setListings;

function fetchLocalizedRegions() {
  return function fetchLocalizedRegionsAsync(dispatch, getState) {
    var _getState, _getState$userPrefs, _getState$userPrefs$l, _getState$userPrefs$l2, lang, json;

    return regeneratorRuntime.async(function fetchLocalizedRegionsAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getState = getState(), _getState$userPrefs = _getState.userPrefs;
            _getState$userPrefs = _getState$userPrefs === void 0 ? {} : _getState$userPrefs;
            _getState$userPrefs$l = _getState$userPrefs.localeData;
            _getState$userPrefs$l = _getState$userPrefs$l === void 0 ? {} : _getState$userPrefs$l;
            _getState$userPrefs$l2 = _getState$userPrefs$l.lang, lang = _getState$userPrefs$l2 === void 0 ? 'en-us' : _getState$userPrefs$l2;
            dispatch({
              type: REGIONS_FETCHING
            });
            _context2.prev = 6;
            _context2.next = 9;
            return regeneratorRuntime.awrap(fetchListItems(lang, 'regions'));

          case 9:
            json = _context2.sent;
            dispatch({
              type: REGIONS_FETCHED,
              json: json
            });
            return _context2.abrupt("return", json);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](6);
            dispatch({
              type: REGIONS_FETCH_FAILED
            });

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[6, 14]]);
  };
}

function fetchLocalizedCountries() {
  return function fetchLocalizedCountriesAsync(dispatch, getState) {
    var _getState2, _getState2$userPrefs, _getState2$userPrefs$, _getState2$userPrefs$2, lang, json;

    return regeneratorRuntime.async(function fetchLocalizedCountriesAsync$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), _getState2$userPrefs = _getState2.userPrefs;
            _getState2$userPrefs = _getState2$userPrefs === void 0 ? {} : _getState2$userPrefs;
            _getState2$userPrefs$ = _getState2$userPrefs.localeData;
            _getState2$userPrefs$ = _getState2$userPrefs$ === void 0 ? {} : _getState2$userPrefs$;
            _getState2$userPrefs$2 = _getState2$userPrefs$.lang, lang = _getState2$userPrefs$2 === void 0 ? 'en-us' : _getState2$userPrefs$2;
            dispatch({
              type: COUNTRIES_FETCHING
            });
            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap(fetchListItems(lang, 'countries'));

          case 9:
            json = _context3.sent;
            dispatch({
              type: COUNTRIES_FETCHED,
              json: json
            });
            return _context3.abrupt("return", json);

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](6);
            dispatch({
              type: COUNTRIES_FETCH_FAILED
            });

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 14]]);
  };
}

function fetchListing(listingId) {
  return function fetchListingAsync(dispatch, getState) {
    var _getState3, _getState3$JWT, _getState3$JWT$token, token, _getState3$userPrefs, _getState3$userPrefs$, _getState3$userPrefs$2, lang, endpoint, options, response, result, action;

    return regeneratorRuntime.async(function fetchListingAsync$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(listingId === undefined)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", Promise.reject('missing listingId from function argument'));

          case 2:
            _getState3 = getState(), _getState3$JWT = _getState3.JWT;
            _getState3$JWT = _getState3$JWT === void 0 ? {} : _getState3$JWT;
            _getState3$JWT$token = _getState3$JWT.token, token = _getState3$JWT$token === void 0 ? '' : _getState3$JWT$token, _getState3$userPrefs = _getState3.userPrefs;
            _getState3$userPrefs = _getState3$userPrefs === void 0 ? {} : _getState3$userPrefs;
            _getState3$userPrefs$ = _getState3$userPrefs.localeData;
            _getState3$userPrefs$ = _getState3$userPrefs$ === void 0 ? {} : _getState3$userPrefs$;
            _getState3$userPrefs$2 = _getState3$userPrefs$.lang, lang = _getState3$userPrefs$2 === void 0 ? 'en-us' : _getState3$userPrefs$2;
            endpoint = "".concat(APIEndpoint, "listings/").concat(listingId, "?lang=").concat(lang, "&returnalways=true");
            dispatch({
              type: LISTING_FETCHING,
              listingId: listingId
            });
            options = {
              method: 'GET',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context4.prev = 13;
            _context4.next = 16;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

          case 16:
            response = _context4.sent;
            _context4.next = 19;
            return regeneratorRuntime.awrap(response.json());

          case 19:
            result = _context4.sent;
            action = response.status !== 404 ? {
              type: LISTING_FETCHED,
              listingId: listingId,
              result: result
            } : {
              type: LISTING_NOT_FOUND,
              listingId: listingId,
              result: result.message
            };
            dispatch(action);
            _context4.next = 27;
            break;

          case 24:
            _context4.prev = 24;
            _context4.t0 = _context4["catch"](13);
            return _context4.abrupt("return", dispatch({
              type: LISTING_FETCH_FAILED,
              listingId: listingId,
              error: _context4.t0
            }));

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, [[13, 24]]);
  };
}

function shouldFetchListing(state, listingId) {
  if (!state.listing) throw new Error('Invalid State. Must have `.listing` field');
  var listingInState = state.listing[listingId];
  var listingData = (0, _get2.default)(listingInState, 'data', false);

  if (!listingData || listingInState.readyState === LISTING_FETCH_FAILED || listingInState.readyState === LISTING_INVALID) {
    return true;
  }

  return false;
} // fire and forget. return value doesn't matter and is a no-op if not needed


function fetchListingIfNeeded(listingId) {
  return function (dispatch, getState) {
    if (!listingId) return Promise.reject('missing listingId from function argument');

    if (shouldFetchListing(getState(), listingId)) {
      dispatch({
        type: LISTING_SHOULD_FETCH,
        value: true
      });
      return dispatch(fetchListing(listingId));
    }

    dispatch({
      type: LISTING_SHOULD_FETCH,
      value: false
    }); // keep a consistent interface (promise)

    return Promise.resolve();
  };
}

function queryBuilder(options) {
  var parameterDefinitions = {
    clientId: 'client_id',
    connectURL: 'redirect_uri'
  };
  var keysArr = (0, _keys2.default)(options);
  var nonEmptyOptionsKeys = (0, _filter2.default)(keysArr, function (key) {
    return options[key] !== '' && options[key] !== undefined;
  });
  var querystring = (0, _reduce2.default)(nonEmptyOptionsKeys, function (memo, option) {
    var paramString;

    if (parameterDefinitions[option] !== undefined) {
      paramString = "".concat(parameterDefinitions[option], "=").concat(encodeURIComponent(options[option]));
    } else {
      paramString = "".concat(option, "=").concat(encodeURIComponent(options[option]));
    }

    return memo === '' ? "?".concat(paramString) : "".concat(memo, "&").concat(paramString);
  }, '');
  return querystring;
}

function openWindowSync(redirectURL, width, height) {
  return function (dispatch) {
    // Centering popup within open parent window
    var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var windowTop = window.screenTop ? window.screenTop : window.screenY;
    var left = windowLeft + window.innerWidth / 2 - width / 2;
    var top = windowTop + window.innerHeight / 2 - height / 2;
    var windowFeatures = "scrollbars=1,resizable=1,width=".concat(width, ", height=").concat(height, ", top=").concat(top, ", left=").concat(left);
    var popup = window.open(redirectURL, 'Connect', windowFeatures);
    dispatch({
      type: POPUP_IS_OPEN
    });
    return popup;
  };
}

var makeXMLHttpRequest = function makeXMLHttpRequest(requestUrl, method) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open(method || 'GET', requestUrl);

    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };

    request.send();
  });
};

function disconnectTripIt(csrfToken) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open('POST', "".concat(_config.default.CTEUrl, "/net2/TripIt/UnlinkFromTripIt.ashx"));
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };

    request.send("csrf_token=".concat(csrfToken));
  });
}

var updateConnectionPending = function updateConnectionPending(listingId) {
  return {
    type: UPDATE_CONNECTION_PENDING,
    listingId: listingId
  };
};
/**
 * This function is never called on production because no listings have
 * 'CONREQFLOW' as their oAuthWorkflowType.
 */


function connectWithLoyaltyNumber(ID) {
  return function connectWithLoyaltyNumberAsync(dispatch, getState) {
    var state, _state$listing$ID$dat, loyaltyNumber, triplinkLoyaltyNumber, _state$JWT, _state$JWT$token, token, options, loyaltyNum;

    return regeneratorRuntime.async(function connectWithLoyaltyNumberAsync$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            state = getState();
            _state$listing$ID$dat = state.listing[ID].data, loyaltyNumber = _state$listing$ID$dat.loyaltyNumber, triplinkLoyaltyNumber = _state$listing$ID$dat.core.triplinkLoyaltyNumber;
            _state$JWT = state.JWT;
            _state$JWT = _state$JWT === void 0 ? {} : _state$JWT;
            _state$JWT$token = _state$JWT.token, token = _state$JWT$token === void 0 ? '' : _state$JWT$token;
            options = {
              method: 'PUT',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            loyaltyNum = !triplinkLoyaltyNumber ? loyaltyNumber : '';
            _context5.prev = 8;
            _context5.next = 11;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)("".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections?loyaltyNumber=").concat(loyaltyNum), options));

          case 11:
            dispatch(updateConnectionPending(ID));
            _context5.next = 17;
            break;

          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](8);
            console.error(_context5.t0);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, [[8, 14]]);
  };
}

function connectWithLoyaltyNumberLegacy(ID) {
  return function (dispatch, getState) {
    var _getState$listing$ID$ = getState().listing[ID].data,
        loyaltyNumber = _getState$listing$ID$.loyaltyNumber,
        _getState$listing$ID$2 = _getState$listing$ID$.core,
        triplinkSupplierID = _getState$listing$ID$2.triplinkSupplierID,
        triplinkLoyaltyNumber = _getState$listing$ID$2.triplinkLoyaltyNumber;
    var addLoyaltyUrl = "".concat(_config.default.CTEUrl, "/UI/appcenter/AddLoyaltyNumber?supplierId=").concat(triplinkSupplierID, "&loyaltyNumber=").concat(loyaltyNumber);
    var autoConnectUrl = "".concat(_config.default.CTEUrl, "/UI/appcenter/AutoConnectToSupplier?supplierId=").concat(triplinkSupplierID);
    var options = {
      method: 'GET',
      headers: {}
    };

    if (!triplinkLoyaltyNumber) {
      makeXMLHttpRequest(addLoyaltyUrl).then(function () {
        makeXMLHttpRequest(autoConnectUrl);
      }).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    } else {
      makeXMLHttpRequest(autoConnectUrl).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    }
  };
}

function toggleNeedAnAccountClicked(wasClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_NEED_AN_ACCOUNT_CLICKED,
      wasClicked: wasClicked
    });
  };
}

var connectionStatusChecking = function connectionStatusChecking() {
  return {
    type: CONNECTION_STATUS_CHECKING
  };
};

function checkForConnection(listingId, v1ListingId, popupWindow) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        _getState4$JWT = _getState4.JWT;

    _getState4$JWT = _getState4$JWT === void 0 ? {} : _getState4$JWT;
    var _getState4$JWT$token = _getState4$JWT.token,
        token = _getState4$JWT$token === void 0 ? '' : _getState4$JWT$token,
        _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang,
        lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
    var ID = (0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
    dispatch(connectionStatusChecking());
    var popupClosedCounter = 0;
    var intervalID = window.setInterval(function _callee() {
      var options, endpoint, response, json;
      return regeneratorRuntime.async(function _callee$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (popupWindow && popupWindow.closed && popupClosedCounter < 3) {
                popupClosedCounter += 1;

                if (popupClosedCounter === 2) {
                  dispatch({
                    type: SET_IS_CONNECTING_TO_FALSE
                  });
                  dispatch(toggleNeedAnAccountClicked(false));
                  window.clearInterval(intervalID);
                }
              }

              options = {
                method: 'GET',
                headers: {}
              };
              if (token) options.headers.Authorization = "Bearer ".concat(token);
              endpoint = "".concat(APIEndpoint, "listings/").concat(ID, "?lang=").concat(lang, "&returnalways=true");
              _context6.prev = 4;
              _context6.next = 7;
              return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

            case 7:
              response = _context6.sent;
              _context6.next = 10;
              return regeneratorRuntime.awrap(response.json());

            case 10:
              json = _context6.sent;

              if (json.core.isUserConnected) {
                dispatch({
                  type: CONNECTION_STATUS_CHECKED_SUCCESS,
                  ID: ID
                });
                dispatch((0, _listingsModule.updateConnectedStatus)(ID, true));
                window.clearInterval(intervalID);
              }

              _context6.next = 17;
              break;

            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](4);
              dispatch({
                type: LISTING_FETCH_FAILED,
                ID: ID,
                error: _context6.t0
              });

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, [[4, 14]]);
    }, 2000);
  };
}

var getKeyAndID = function getKeyAndID(listingId, v1ListingId, state) {
  var consumerKeyOrAppId;
  var ID;

  if ((0, _has2.default)(state, "listing[".concat(listingId, "].data.core"))) {
    ID = listingId;
    consumerKeyOrAppId = state.listing[ID].data.core.partnerAppConsumerKey !== '' ? state.listing[ID].data.core.partnerAppConsumerKey : state.listing[ID].data.core.partnerAppId;
  } else {
    ID = v1ListingId;
    consumerKeyOrAppId = state.listing[ID].data.core.partnerAppConsumerKey !== '' ? state.listing[ID].data.core.partnerAppConsumerKey : state.listing[ID].data.core.partnerAppId;
  }

  return {
    consumerKeyOrAppId: consumerKeyOrAppId,
    ID: ID
  };
};

function connectListing(listingId, v1ListingId) {
  return function connectListingAsync(dispatch, getState) {
    var state, ID, _state$listing$ID$dat2, loyaltyNumber, _state$listing$ID$dat3, oAuthWorkflowType, triplinkSupplierID, triplinkLoyaltyNumber, _state$JWT2, _state$JWT2$token, token, _state$listing, needAnAccountClicked, isConnecting, options, popupWindow, response, json;

    return regeneratorRuntime.async(function connectListingAsync$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            state = getState();
            ID = (0, _has2.default)(state, "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
            _state$listing$ID$dat2 = state.listing[ID].data, loyaltyNumber = _state$listing$ID$dat2.loyaltyNumber, _state$listing$ID$dat3 = _state$listing$ID$dat2.core, oAuthWorkflowType = _state$listing$ID$dat3.oAuthWorkflowType, triplinkSupplierID = _state$listing$ID$dat3.triplinkSupplierID, triplinkLoyaltyNumber = _state$listing$ID$dat3.triplinkLoyaltyNumber;
            _state$JWT2 = state.JWT;
            _state$JWT2 = _state$JWT2 === void 0 ? {} : _state$JWT2;
            _state$JWT2$token = _state$JWT2.token, token = _state$JWT2$token === void 0 ? '' : _state$JWT2$token, _state$listing = state.listing, needAnAccountClicked = _state$listing.needAnAccountClicked, isConnecting = _state$listing.isConnecting;

            if (!isConnecting) {
              dispatch(connectionStatusChecking());
            }

            dispatch({
              type: CONNECT_LISTING
            });

            if (!(oAuthWorkflowType === 'AUTOCONFLOW' && !needAnAccountClicked)) {
              _context7.next = 12;
              break;
            }

            dispatch(connectWithLoyaltyNumberLegacy(ID));
            _context7.next = 34;
            break;

          case 12:
            if (!(oAuthWorkflowType === 'CONREQFLOW')) {
              _context7.next = 16;
              break;
            }

            /**
             * This branch is never executed on production because no listings have
             * 'CONREQFLOW' as their oAuthWorkflowType.
             */
            dispatch(connectWithLoyaltyNumber(ID));
            _context7.next = 34;
            break;

          case 16:
            options = {
              method: 'PUT',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            popupWindow = dispatch(openWindowSync('', 800, 650)); // after putting this in async/await, it throws a chrome security error
            // popupWindow.document.write('Calculating Inverse Probability Matrices...');

            _context7.prev = 19;
            _context7.next = 22;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)("".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections"), options));

          case 22:
            response = _context7.sent;
            _context7.next = 25;
            return regeneratorRuntime.awrap(response.json());

          case 25:
            json = _context7.sent;
            popupWindow.location.href = oAuthWorkflowType === 'APPCNTRFLOW' ? "https://".concat(window.location.hostname).concat(json.redirectUrl) : json.redirectUrl;
            dispatch(checkForConnection(listingId, v1ListingId, popupWindow));
            _context7.next = 34;
            break;

          case 30:
            _context7.prev = 30;
            _context7.t0 = _context7["catch"](19);
            popupWindow.close();
            console.error(_context7.t0);

          case 34:
          case "end":
            return _context7.stop();
        }
      }
    }, null, null, [[19, 30]]);
  };
}

var toggleModal = function toggleModal(modalName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: TOGGLE_MODAL,
    modalName: modalName,
    options: options
  };
};

exports.toggleModal = toggleModal;

var disconnectFromListing = function disconnectFromListing(listingId) {
  return {
    type: DISCONNECT_LISTING,
    listingId: listingId
  };
};

exports.disconnectFromListing = disconnectFromListing;

function disconnectListing(listingId, v1ListingId) {
  return function disconnectListingAsync(dispatch, getState) {
    var state, _state$JWT3, _state$JWT3$token, token, _getKeyAndID, ID, confirmOrDeny, connectURL, _state$listing$ID$dat4, listingType, oAuthWorkflowType, success, endpoint, _success, options, disconnectEndpoint, response;

    return regeneratorRuntime.async(function disconnectListingAsync$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            state = getState();
            _state$JWT3 = state.JWT;
            _state$JWT3 = _state$JWT3 === void 0 ? {} : _state$JWT3;
            _state$JWT3$token = _state$JWT3.token, token = _state$JWT3$token === void 0 ? '' : _state$JWT3$token;
            _getKeyAndID = getKeyAndID(listingId, v1ListingId, state), ID = _getKeyAndID.ID;

            confirmOrDeny = function confirmOrDeny(wasSuccess, listingType) {
              if (wasSuccess) {
                dispatch(disconnectFromListing(ID));
                dispatch((0, _listingsModule.updateConnectedStatus)(ID, false));
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: true,
                  listingType: listingType
                }));
              } else {
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: false,
                  listingType: listingType
                }));
              }
            };

            connectURL = state.listing[ID].data.localized.connectURL || '';
            _state$listing$ID$dat4 = state.listing[ID].data.core, listingType = _state$listing$ID$dat4.listingType, oAuthWorkflowType = _state$listing$ID$dat4.oAuthWorkflowType;

            if (!(connectURL.indexOf('/signup_tripit.asp') !== -1)) {
              _context8.next = 15;
              break;
            }

            _context8.next = 11;
            return regeneratorRuntime.awrap(disconnectTripIt(state.userPrefs.csrf_token));

          case 11:
            success = _context8.sent;
            confirmOrDeny(success, listingType);
            _context8.next = 38;
            break;

          case 15:
            if (!(listingType === 'ACONCT')) {
              _context8.next = 23;
              break;
            }

            endpoint = "".concat(_config.default.CTEUrl, "/ui/appcenter/ChangeAutoConnectPreference?enroll=false&_=").concat(new Date().getTime());
            _context8.next = 19;
            return regeneratorRuntime.awrap(makeXMLHttpRequest(endpoint));

          case 19:
            _success = _context8.sent;
            confirmOrDeny(_success, listingType);
            _context8.next = 38;
            break;

          case 23:
            options = {
              method: 'DELETE',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            disconnectEndpoint = listingType === 'AUTOCONFLOW' ? "".concat(APIEndpoint, "connections/").concat(ID) : "".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections");
            _context8.prev = 26;
            _context8.next = 29;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(disconnectEndpoint, options));

          case 29:
            response = _context8.sent;
            confirmOrDeny(response.ok);

            if (response.ok) {
              _context8.next = 33;
              break;
            }

            throw response;

          case 33:
            _context8.next = 38;
            break;

          case 35:
            _context8.prev = 35;
            _context8.t0 = _context8["catch"](26);
            console.error(_context8.t0);

          case 38:
          case "end":
            return _context8.stop();
        }
      }
    }, null, null, [[26, 35]]);
  };
}

function updateLoyaltyNum(listingId, loyaltyNum) {
  return {
    type: UPDATE_LOYALTY_NUM,
    listingId: listingId,
    loyaltyNum: loyaltyNum
  };
}

function inquireListing() {
  return {
    type: INQUIRE_LISTING
  };
} // Reducer


var initialState = {
  isEnrollModalOpen: false,
  isDisconnectModalOpen: false,
  isConfirmationModalOpen: false,
  isUnenrollModalOpen: false,
  isConnecting: false,
  isPopupOpen: false,
  needAnAccountClicked: false,
  modalOptions: {},
  modalNames: {
    enroll: ENROLL_MODAL,
    unenroll: UNENROLL_MODAL,
    disconnect: DISCONNECT_MODAL,
    confirmation: CONFIRMATION_MODAL
  }
}; // TODO: what is this for?

exports.initialState = initialState;

function listing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'dev/CHANGE_FIELD':
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: action.object
      }));

    case LISTING_FETCHING:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_FETCHING
      }));

    case LISTING_INVALID:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_INVALID
      }));

    case LISTING_FETCH_FAILED:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_FETCH_FAILED,
        error: action.error
      }));

    case LISTING_FETCHED:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        readyState: LISTING_FETCHED,
        data: _objectSpread({}, action.result, {
          loyaltyNumber: ''
        })
      }));

    case SET_LISTINGS:
      return (0, _merge13.default)({}, state, action.listings);

    case LISTING_NOT_FOUND:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_NOT_FOUND,
        data: action.result
      }));

    case CONNECT_LISTING:
      return state;

    case DISCONNECT_LISTING:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          core: {
            isUserConnected: false
          }
        }
      }));

    case CONNECTION_STATUS_CHECKING:
      return (0, _merge13.default)({}, state, {
        isConnecting: true
      });

    case SET_IS_CONNECTING_TO_FALSE:
      return (0, _merge13.default)({}, state, {
        isConnecting: false
      });

    case CONNECTION_STATUS_CHECKED_SUCCESS:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.ID, {
        data: {
          core: {
            isUserConnected: true
          }
        }
      }));

    case UPDATE_CONNECTION_PENDING:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        data: {
          core: {
            isConnectionPending: true
          }
        }
      }));

    case REGIONS_FETCHED:
      return (0, _merge13.default)({}, state, {
        localizedRegions: action.json
      });

    case COUNTRIES_FETCHED:
      return (0, _merge13.default)({}, state, {
        localizedCountries: action.json
      });

    case TOGGLE_MODAL:
      {
        var _merge11;

        var modalKey;

        switch (action.modalName) {
          case ENROLL_MODAL:
            modalKey = 'isEnrollModalOpen';
            break;

          case UNENROLL_MODAL:
            modalKey = 'isUnenrollModalOpen';
            break;

          case DISCONNECT_MODAL:
            modalKey = 'isDisconnectModalOpen';
            break;

          case CONFIRMATION_MODAL:
            modalKey = 'isConfirmationModalOpen';
            break;

          default:
            console.error('toggle requires a modal constant found in listingModule.js');
            break;
        }

        return (0, _merge13.default)({}, state, (_merge11 = {}, _defineProperty(_merge11, modalKey, !state[modalKey]), _defineProperty(_merge11, "modalOptions", _objectSpread({}, state.modalOptions, {}, action.options)), _merge11));
      }

    case UPDATE_LOYALTY_NUM:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          loyaltyNumber: action.loyaltyNum
        }
      }));

    case TOGGLE_NEED_AN_ACCOUNT_CLICKED:
      return (0, _merge13.default)({}, state, {
        needAnAccountClicked: action.wasClicked
      });

    case POPUP_IS_OPEN:
      return (0, _merge13.default)({}, state, {
        isPopupOpen: true
      });

    case POPUP_IS_CLOSED:
      return (0, _merge13.default)({}, state, {
        isPopupOpen: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(7);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(66);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAppContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _AppContext = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var withAppContext = function withAppContext(Component) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this = this;

          return _react.default.createElement(_AppContext.AppContext.Consumer, null, function (context) {
            return _react.default.createElement(Component, _extends({}, _this.props, {
              context: context
            }));
          });
        }
      }]);

      return _class;
    }(_react.default.Component)
  );
};

exports.withAppContext = withAppContext;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearch = setSearch;
exports.filterListingsByAll = filterListingsByAll;
exports.wait = wait;
exports.updateConnectedStatus = updateConnectedStatus;
exports.setAndFilter = setAndFilter;
exports.fetchListings = fetchListings;
exports.filterByCategory = filterByCategory;
exports.setCategory = setCategory;
exports.fetchCategoriesIfNeeded = fetchCategoriesIfNeeded;
exports.setAndFilterByCategory = setAndFilterByCategory;
exports.setCategorySlug = setCategorySlug;
exports.shouldFetchListings = shouldFetchListings;
exports.fetchListingsIfNeeded = fetchListingsIfNeeded;
exports.filterByField = filterByField;
exports.default = listings;
exports.unionByID = exports.initialState = exports.clearSearch = exports.FILTER_BY_CATEGORY = exports.SET_CATEGORY_SLUG = exports.SET_CATEGORY = exports.CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCHED = exports.FETCH_CATEGORIES = exports.UPDATE_CONNECTED_STATUS = exports.WAIT = exports.FILTER_LISTINGS_BY_ALL = exports.CLEAR_SEARCH = exports.LISTINGS_SET_SEARCH = exports.LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCHED = exports.LISTINGS_FETCHING = exports.LISTINGS_INVALID = void 0;

var _objectAssign = _interopRequireDefault(__webpack_require__(93));

var _get2 = _interopRequireDefault(__webpack_require__(22));

var _uniqBy2 = _interopRequireDefault(__webpack_require__(94));

var _some2 = _interopRequireDefault(__webpack_require__(99));

var _merge2 = _interopRequireDefault(__webpack_require__(23));

var _intersection2 = _interopRequireDefault(__webpack_require__(103));

var _isomorphicFetch = _interopRequireDefault(__webpack_require__(54));

var _config = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(4);

var userProfileActions = _interopRequireWildcard(__webpack_require__(24));

var listingActions = _interopRequireWildcard(__webpack_require__(6));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Constants
var LISTINGS_INVALID = '@@listings/LISTINGS_INVALID';
exports.LISTINGS_INVALID = LISTINGS_INVALID;
var LISTINGS_FETCHING = '@@listings/LISTINGS_FETCHING';
exports.LISTINGS_FETCHING = LISTINGS_FETCHING;
var LISTINGS_FETCHED = '@@listings/LISTINGS_FETCHED';
exports.LISTINGS_FETCHED = LISTINGS_FETCHED;
var LISTINGS_FETCH_FAILED = '@@listings/LISTINGS_FETCH_FAILED';
exports.LISTINGS_FETCH_FAILED = LISTINGS_FETCH_FAILED;
var LISTINGS_SET_SEARCH = '@@listings/LISTINGS_SET_SEARCH';
exports.LISTINGS_SET_SEARCH = LISTINGS_SET_SEARCH;
var CLEAR_SEARCH = '@@listings/CLEAR_SEARCH';
exports.CLEAR_SEARCH = CLEAR_SEARCH;
var FILTER_LISTINGS_BY_ALL = '@@listings/FILTER_LISTINGS_BY_ALL';
exports.FILTER_LISTINGS_BY_ALL = FILTER_LISTINGS_BY_ALL;
var WAIT = '@@listings/WAIT';
exports.WAIT = WAIT;
var UPDATE_CONNECTED_STATUS = '@@listings/UPDATE_CONNECTED_STATUS';
exports.UPDATE_CONNECTED_STATUS = UPDATE_CONNECTED_STATUS;
var FETCH_CATEGORIES = '@@listings/FETCH_CATEGORIES';
exports.FETCH_CATEGORIES = FETCH_CATEGORIES;
var CATEGORIES_FETCHED = '@@listings/CATEGORIES_FETCHED';
exports.CATEGORIES_FETCHED = CATEGORIES_FETCHED;
var CATEGORIES_FETCH_FAILED = '@@listings/CATEGORIES_FETCH_FAILED';
exports.CATEGORIES_FETCH_FAILED = CATEGORIES_FETCH_FAILED;
var SET_CATEGORY = '@@listings/SET_CATEGORY';
exports.SET_CATEGORY = SET_CATEGORY;
var SET_CATEGORY_SLUG = '@@listings/SET_CATEGORY_SLUG';
exports.SET_CATEGORY_SLUG = SET_CATEGORY_SLUG;
var FILTER_BY_CATEGORY = '@@listings/FILTER_BY_CATEGORY';
exports.FILTER_BY_CATEGORY = FILTER_BY_CATEGORY;
var APIEndpoint;

if ((0, _utils.canUseDOM)()) {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/api/listings");
} else {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/api/listings");
} // Actions


function setSearch(value) {
  return {
    type: LISTINGS_SET_SEARCH,
    value: value
  };
}

function filterListingsByAll() {
  return {
    type: FILTER_LISTINGS_BY_ALL
  };
} // this is only to introduce artificial delay, (don't test it)


function wait(time) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(dispatch({
          type: WAIT
        }));
      }, time);
    });
  };
}

function updateConnectedStatus(listingId, status) {
  return function (dispatch, getState) {
    var _getState$listings = getState().listings,
        list = _getState$listings.list,
        filtered = _getState$listings.filtered;

    var updateList = function updateList(listToUpdate) {
      return listToUpdate.map(function (el) {
        if (el.ID === listingId) {
          return (0, _merge2.default)({}, el, {
            isConnecting: false,
            core: {
              isUserConnected: status
            }
          });
        }

        return el;
      });
    };

    if (list.length > 0 || filtered.length > 0) {
      var newList = updateList(list);
      var newFilteredList = updateList(filtered);
      dispatch({
        type: UPDATE_CONNECTED_STATUS,
        newList: newList,
        newFilteredList: newFilteredList
      });
    }
  };
}

function setAndFilter(value) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(setSearch(value));
      resolve(dispatch(filterListingsByAll()));
    });
  };
}

function fetchListings() {
  return function asyncFetchListings(dispatch, getState) {
    var _getState, _getState$userPrefs$l, lang, userProfile, _getState$JWT, _getState$JWT$token, token, listings, meta, parameters, extraCountries, endpoint, fetchListingsCall, listingsResponse, approvedAndVisible, _getState2, _getState2$listings, categorySlug, list, search;

    return regeneratorRuntime.async(function asyncFetchListings$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchListingsCall = function _ref() {
              var options, response;
              return regeneratorRuntime.async(function fetchListingsCall$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      options = {
                        method: 'GET',
                        headers: {}
                      };
                      if (token) options.headers.Authorization = "Bearer ".concat(token);
                      _context.next = 4;
                      return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

                    case 4:
                      response = _context.sent;
                      return _context.abrupt("return", response.json());

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              });
            };

            _context2.next = 3;
            return regeneratorRuntime.awrap(dispatch(userProfileActions.fetchUserProfileIfNeeded()));

          case 3:
            dispatch({
              type: LISTINGS_FETCHING
            });
            _getState = getState(), _getState$userPrefs$l = _getState.userPrefs.localeData.lang, lang = _getState$userPrefs$l === void 0 ? 'en-us' : _getState$userPrefs$l, userProfile = _getState.userProfile, _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token, listings = _getState.listings, meta = _getState.meta;
            parameters = {
              category: (0, _get2.default)(listings, 'category.slug', ''),
              lang: lang
            }; // The Public US site should show listings for ALL countries.
            // This is an exception. Other countries should still limit the results.

            if (meta.isPublic && meta.country !== 'US' && meta.country !== 'CN') {
              parameters.country = meta.country;
            } // Request HK, TW, CN listings when in public china


            extraCountries = meta.isPublic && meta.country === 'CN' ? '&country=CN,TW,HK' : '';
            endpoint = "".concat(APIEndpoint).concat((0, _utils.buildQueryString)(parameters)).concat(extraCountries);
            _context2.prev = 11;
            _context2.next = 14;
            return regeneratorRuntime.awrap(fetchListingsCall());

          case 14:
            listingsResponse = _context2.sent;
            approvedAndVisible = listingsResponse.items.filter(function (item) {
              // in public show only if localized content is available
              var fixedLang = lang === 'en' ? 'en-us' : lang;

              if (meta.isPublic && item.localized && item.localized.lang !== fixedLang) {
                return false;
              }

              if (userProfile && userProfile.profile && userProfile.profile.betas['appmgmt-246 - hideApps']) {
                if (item.core.isVisible && item.core.approvalStatus === 'APPROVED' && !item.core.listingDisabled) {
                  if (token && item.core.clientOptInType === 'USER') {
                    return (0, _intersection2.default)(item.core.offerings, userProfile.offeringsEnabled).length > 0;
                  }

                  return true;
                }
              } else if (item.core.isVisible && item.core.approvalStatus === 'APPROVED') {
                if (token && item.core.clientOptInType === 'USER') {
                  return (0, _intersection2.default)(item.core.offerings, userProfile.offeringsEnabled).length > 0;
                }

                return true;
              }
            });
            dispatch(listingActions.setListings(approvedAndVisible));
            dispatch({
              type: LISTINGS_FETCHED,
              result: approvedAndVisible
            });
            dispatch({
              type: FILTER_LISTINGS_BY_ALL
            });
            _getState2 = getState(), _getState2$listings = _getState2.listings, categorySlug = _getState2$listings.categorySlug, list = _getState2$listings.list, search = _getState2$listings.search;

            if (categorySlug && list.length && search === '') {
              dispatch(setCategory());
            }

            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](11);
            dispatch({
              type: LISTINGS_FETCH_FAILED,
              error: _context2.t0
            });

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[11, 23]]);
  };
}

function flattenCategories(list) {
  var flattened = {};
  list.forEach(function (category) {
    flattened[category.slug] = category;

    if (category.subcategories.length > 0) {
      category.subcategories.forEach(function (subCategory) {
        return flattened[subCategory.slug] = subCategory;
      });
    }
  });
  return flattened;
}

function filterByCategory() {
  return {
    type: FILTER_BY_CATEGORY
  };
}

function setCategory(givenCatgory) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$listings$c = _getState3.listings.categories,
        categories = _getState3$listings$c === void 0 ? [] : _getState3$listings$c;

    if (givenCatgory) {
      dispatch({
        type: SET_CATEGORY,
        category: givenCatgory
      });
      dispatch(filterByCategory());
    } else if (categories.length) {
      var flatMapCategories = flattenCategories(categories);
      var theChosenOne = flatMapCategories[getState().listings.categorySlug];
      dispatch({
        type: SET_CATEGORY,
        category: theChosenOne
      });
      dispatch(filterByCategory());
    }

    if (!categories.length) {
      dispatch(fetchCategoriesIfNeeded());
    }
  };
}

function fetchCategoriesIfNeeded() {
  return function asyncFetchCategories(dispatch, getState) {
    var _getState4, categories, _getState4$userPrefs$, lang, path, categoriesAPIEndpoint, options, response, categoriesResponse;

    return regeneratorRuntime.async(function asyncFetchCategories$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState4 = getState(), categories = _getState4.listings.categories, _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;

            if (!(!categories || categories.length === 0)) {
              _context3.next = 20;
              break;
            }

            path = "api/listitems/categories?lang=".concat(lang);

            if ((0, _utils.canUseDOM)()) {
              categoriesAPIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/").concat(path);
            } else {
              categoriesAPIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/").concat(path);
            }

            dispatch({
              type: FETCH_CATEGORIES
            });
            options = {
              method: 'GET',
              headers: {}
            };
            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(categoriesAPIEndpoint, options));

          case 9:
            response = _context3.sent;
            _context3.next = 12;
            return regeneratorRuntime.awrap(response.json());

          case 12:
            categoriesResponse = _context3.sent;
            dispatch({
              type: CATEGORIES_FETCHED,
              result: categoriesResponse
            });
            return _context3.abrupt("return", categoriesResponse);

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](6);
            dispatch({
              type: CATEGORIES_FETCH_FAILED,
              error: _context3.t0
            });

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 17]]);
  };
}

function setAndFilterByCategory(value) {
  return function (dispatch) {
    dispatch(setCategory(value));
    dispatch(filterByCategory());
  };
}

function setCategorySlug(slug) {
  return {
    type: SET_CATEGORY_SLUG,
    slug: slug
  };
}

function shouldFetchListings(state, isKeywordEntered) {
  var currentListings = state.listings;

  if (currentListings.list === null || currentListings.list.length === 0 || currentListings.listingsReadyState === LISTINGS_FETCH_FAILED || currentListings.listingsReadyState === LISTINGS_INVALID || isKeywordEntered) {
    return true;
  }

  return false;
}

function fetchListingsIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchListings(getState(), getState().listings.search.length > 0)) {
      return dispatch(fetchListings());
    }
  };
}

var clearSearch = function clearSearch() {
  return {
    type: CLEAR_SEARCH
  };
}; // Reducer


exports.clearSearch = clearSearch;
var initialState = {
  listingsReadyState: LISTINGS_INVALID,
  list: [],
  search: '',
  filtered: [],
  category: undefined,
  categories: [],
  categorySlug: undefined
};
exports.initialState = initialState;

function filterByField(_ref2, field) {
  var search = _ref2.search,
      list = _ref2.list;
  return list.filter(function (listing) {
    var localized = listing.localized;

    if (!localized || !localized[field]) {
      return false;
    }

    var lowCaseSearch = search.toLowerCase();

    if (field === 'keywords') {
      var words = localized[field];
      return (0, _some2.default)(words, function (value) {
        return value.toLowerCase().includes(lowCaseSearch) || lowCaseSearch.includes(value.toLowerCase());
      });
    }

    var lowCaseField = localized[field].toLowerCase();
    return lowCaseField.includes(lowCaseSearch) || lowCaseSearch.includes(lowCaseField);
  });
}

function filterByCategoryReducer(state) {
  return state.list.filter(function (listing) {
    return listing.core.categories.includes(state.category.code);
  });
}

var unionByID = function unionByID(sets) {
  var result = (0, _uniqBy2.default)(sets, 'ID');
  return result;
};

exports.unionByID = unionByID;

function listings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LISTINGS_FETCHING:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHING
      });

    case LISTINGS_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCH_FAILED,
        error: action.error
      });

    case LISTINGS_FETCHED:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHED,
        list: action.result,
        filtered: action.result
      });

    case LISTINGS_SET_SEARCH:
      return (0, _objectAssign.default)({}, state, {
        search: action.value,
        categorySlug: 'all',
        category: {
          code: 'ALL_APPS',
          description: 'All Apps',
          parentCategory: null,
          slug: 'all'
        }
      });

    case CLEAR_SEARCH:
      return (0, _objectAssign.default)({}, state, {
        search: ''
      });

    case UPDATE_CONNECTED_STATUS:
      return (0, _merge2.default)({}, state, {
        list: action.newList,
        filtered: action.newFilteredList
      });

    case FILTER_LISTINGS_BY_ALL:
      {
        var flattened = [].concat(_toConsumableArray(filterByField(state, 'title')), _toConsumableArray(filterByField(state, 'publisher')), _toConsumableArray(filterByField(state, 'keywords')), _toConsumableArray(filterByField(state, 'name')));
        return (0, _objectAssign.default)({}, state, {
          filtered: state.search === '' ? state.list : unionByID(flattened)
        });
      }

    case FILTER_BY_CATEGORY:
      return (0, _objectAssign.default)({}, state, {
        filtered: state.category && state.category.slug !== 'all' ? filterByCategoryReducer(state) : state.list
      });

    case FETCH_CATEGORIES:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: FETCH_CATEGORIES
      });

    case CATEGORIES_FETCHED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCHED,
        categories: action.result
      });

    case CATEGORIES_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCH_FAILED,
        error: action.error
      });

    case SET_CATEGORY:
      return (0, _objectAssign.default)({}, state, {
        category: action.category,
        search: ''
      });

    case SET_CATEGORY_SLUG:
      return (0, _objectAssign.default)({}, state, {
        categorySlug: action.slug
      });

    default:
      return state;
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tracked = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function trackClickHOC(Component) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNLABELED';
  var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var composed =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Composed, _React$Component);

    function Composed() {
      _classCallCheck(this, Composed);

      return _possibleConstructorReturn(this, _getPrototypeOf(Composed).apply(this, arguments));
    }

    _createClass(Composed, [{
      key: "handleClick",
      value: function handleClick() {
        var initialState = window.__INITIAL_STATE__ || {};
        var _initialState$userPre = initialState.userPrefs,
            userPrefs = _initialState$userPre === void 0 ? {} : _initialState$userPre;

        if (typeof caLogger !== 'undefined') {
          caLogger.track(event, _objectSpread({}, additional, {
            userUUID: userPrefs.ConcurId,
            companyUUID: userPrefs.companyUUID
          }));
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("span", {
          style: this.props.style,
          onClick: this.handleClick
        }, Component);
      }
    }]);

    return Composed;
  }(_react.default.Component);

  composed.propTypes = {
    style: _propTypes.default.object
  };
  return composed;
}

var Tracked =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Tracked, _React$Component2);

  function Tracked() {
    _classCallCheck(this, Tracked);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tracked).apply(this, arguments));
  }

  _createClass(Tracked, [{
    key: "handleClick",
    value: function handleClick() {
      var initialState = window.__INITIAL_STATE__ || {};
      var _this$props = this.props,
          event = _this$props.event,
          additional = _this$props.additional;
      var _initialState$userPre2 = initialState.userPrefs,
          userPrefs = _initialState$userPre2 === void 0 ? {} : _initialState$userPre2;

      if (typeof caLogger !== 'undefined') {
        caLogger.track(event, _objectSpread({}, additional, {
          userUUID: userPrefs.ConcurId,
          companyUUID: userPrefs.companyUUID
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("span", {
        style: this.props.style,
        onClick: this.handleClick.bind(this)
      }, this.props.children);
    }
  }]);

  return Tracked;
}(_react.default.Component);

exports.Tracked = Tracked;
Tracked.propTypes = {
  style: _propTypes.default.object,
  event: _propTypes.default.string,
  additional: _propTypes.default.object,
  children: _propTypes.default.node
};
var _default = trackClickHOC;
exports.default = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryDropdown = exports.listingConst = exports.connectWithoutTAndC = exports.launchTAndC = exports.ReqInfo = exports.learnMoreSharedInfoLink = exports.needAnAccountLink = exports.connectLoyaltyNumber = exports.modal = exports.button = exports.termsAndConditions = exports.actionList = exports.elementList = exports.APPLICATION_NAME = exports.VALUES = exports.CONTEXTS = exports.TYPES = exports.EVENTS = void 0;
var EVENTS = {
  CLICK: 'CLICK'
};
exports.EVENTS = EVENTS;
var TYPES = {
  LISTING: 'LISTING',
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
exports.TYPES = TYPES;
var CONTEXTS = {
  HOME: 'HOME',
  LISTING_DETAILS: 'LISTING_DETAILS'
};
exports.CONTEXTS = CONTEXTS;
var VALUES = {
  CATEGORY: 'CATEGORY'
};
exports.VALUES = VALUES;
var APPLICATION_NAME = 'appcenter';
exports.APPLICATION_NAME = APPLICATION_NAME;
var elementList = {
  button: 'button',
  link: 'link',
  menuItem: 'menuitem'
};
exports.elementList = elementList;
var actionList = {
  click: 'click'
};
exports.actionList = actionList;
var termsAndConditions = 'Terms and Conditions Panel';
exports.termsAndConditions = termsAndConditions;
var button = {
  accept: 'accept',
  cancel: 'cancel',
  connect: 'connect',
  disconnect: 'disconnect',
  enroll: 'enroll',
  unenroll: 'unenroll',
  yes: 'yes',
  no: 'no',
  x: 'close'
};
exports.button = button;
var modal = {
  enroll: 'enroll modal',
  unenroll: 'unenroll modal',
  disconnect: 'disconnect modal'
};
exports.modal = modal;
var connectLoyaltyNumber = 'Connect Loyalty Number section';
exports.connectLoyaltyNumber = connectLoyaltyNumber;
var needAnAccountLink = 'Need an Account Link';
exports.needAnAccountLink = needAnAccountLink;
var learnMoreSharedInfoLink = 'Learn more about the services and fields exposed.';
exports.learnMoreSharedInfoLink = learnMoreSharedInfoLink;
var ReqInfo = 'Request Information';
exports.ReqInfo = ReqInfo;
var launchTAndC = 'Launch Terms and Conditions Panel';
exports.launchTAndC = launchTAndC;
var connectWithoutTAndC = 'Connect without launching Terms and Conditions Panel';
exports.connectWithoutTAndC = connectWithoutTAndC;
var listingConst = 'listing';
exports.listingConst = listingConst;
var categoryDropdown = 'Category Dropdown Menu Option';
exports.categoryDropdown = categoryDropdown;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = void 0;

var _nuiConfig = _interopRequireDefault(__webpack_require__(106));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://concur.gitbooks.io/nui/content/nui-config/introduction.html
var configDefaults = {
  nui: {
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://msprqa3.concurtech.net',
    clientExposed: true
  },
  enrollModalBase: {
    value: 'http://localhost',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  }
};
exports.configDefaults = configDefaults;

var _default = (0, _nuiConfig.default)(configDefaults);

exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLOAStatus = fetchLOAStatus;
exports.fetchLOAContent = fetchLOAContent;
exports.fetchTermsStatus = fetchTermsStatus;
exports.fetchTermsContent = fetchTermsContent;
exports.fetchSharedInfoContent = fetchSharedInfoContent;
exports.updateTerms = updateTerms;
exports.toggleTaCModal = toggleTaCModal;
exports.launchTaCModal = launchTaCModal;
exports.updateCurrentlyAccepted = updateCurrentlyAccepted;
exports.default = terms;
exports.initialState = exports.LOA_CONTENT_FAILED = exports.LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FETCHING = exports.LOA_STATUS_FAILED = exports.LOA_STATUS_FETCHED = exports.LOA_STATUS_FETCHING = exports.SHARED_INFO_FETCHED = exports.SHARED_INFO_FETCHING = exports.TERMS_UPDATED = exports.TERMS_UPDATING = exports.TERMS_STATUS_FETCHED = exports.TERMS_STATUS_FETCHING = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.TERMS_FETCHED = exports.TERMS_FETCHING = exports.TOGGLE_TAC_MODAL = void 0;

var _merge4 = _interopRequireDefault(__webpack_require__(23));

var _has2 = _interopRequireDefault(__webpack_require__(25));

var _get2 = _interopRequireDefault(__webpack_require__(22));

var listingActions = _interopRequireWildcard(__webpack_require__(6));

var _utils = __webpack_require__(4);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APIEndpoint = (0, _utils.getAPIEndpoint)();
var TOGGLE_TAC_MODAL = '@@termsModule/TOGGLE_TAC_MODAL';
exports.TOGGLE_TAC_MODAL = TOGGLE_TAC_MODAL;
var TERMS_FETCHING = '@@termsModule/TERMS_FETCHING';
exports.TERMS_FETCHING = TERMS_FETCHING;
var TERMS_FETCHED = '@@termsModule/TERMS_FETCHED';
exports.TERMS_FETCHED = TERMS_FETCHED;
var UPDATE_PREVIOUSLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_PREVIOUSLY_ACCEPTED_STATUS';
exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = UPDATE_PREVIOUSLY_ACCEPTED_STATUS;
var UPDATE_CURRENTLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_CURRENTLY_ACCEPTED_STATUS';
exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = UPDATE_CURRENTLY_ACCEPTED_STATUS;
var TERMS_STATUS_FETCHING = '@@termsModule/TERMS_STATUS_FETCHING';
exports.TERMS_STATUS_FETCHING = TERMS_STATUS_FETCHING;
var TERMS_STATUS_FETCHED = '@@termsModule/TERMS_STATUS_FETCHED';
exports.TERMS_STATUS_FETCHED = TERMS_STATUS_FETCHED;
var TERMS_UPDATING = '@@termsModule/TERMS_UPDATING';
exports.TERMS_UPDATING = TERMS_UPDATING;
var TERMS_UPDATED = '@@termsModule/TERMS_UPDATED';
exports.TERMS_UPDATED = TERMS_UPDATED;
var SHARED_INFO_FETCHING = '@@termsModule/SHARED_INFO_FETCHING';
exports.SHARED_INFO_FETCHING = SHARED_INFO_FETCHING;
var SHARED_INFO_FETCHED = '@@termsModule/SHARED_INFO_FETCHED';
exports.SHARED_INFO_FETCHED = SHARED_INFO_FETCHED;
var LOA_STATUS_FETCHING = '@@termsModule/LOA_STATUS_FETCHING';
exports.LOA_STATUS_FETCHING = LOA_STATUS_FETCHING;
var LOA_STATUS_FETCHED = '@@termsModule/LOA_STATUS_FETCHED';
exports.LOA_STATUS_FETCHED = LOA_STATUS_FETCHED;
var LOA_STATUS_FAILED = '@@termsModule/LOA_STATUS_FAILED';
exports.LOA_STATUS_FAILED = LOA_STATUS_FAILED;
var LOA_CONTENT_FETCHING = '@@termsModule/LOA_CONTENT_FETCHING';
exports.LOA_CONTENT_FETCHING = LOA_CONTENT_FETCHING;
var LOA_CONTENT_FETCHED = '@@termsModule/LOA_CONTENT_FETCHED';
exports.LOA_CONTENT_FETCHED = LOA_CONTENT_FETCHED;
var LOA_CONTENT_FAILED = '@@termsModule/LOA_CONTENT_FAILED';
exports.LOA_CONTENT_FAILED = LOA_CONTENT_FAILED;

function fetchLOAStatus(userId) {
  return function asyncFetchLOAStatus(dispatch, getState) {
    var stateId, _getState, _getState$JWT, _getState$JWT$token, token, options, response, status;

    return regeneratorRuntime.async(function asyncFetchLOAStatus$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // there are two places to get userId, we should consolidate.
            // one comes from us encoding what we have from session, the other from an api call
            stateId = (0, _get2.default)(getState(), 'userProfile.profile.UserID', false);

            if (!(!userId && !stateId)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(new Error('could not find a userId in fetchLOAStatus call or state')));

          case 3:
            dispatch({
              type: LOA_STATUS_FETCHING
            });
            _getState = getState(), _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token;
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context.prev = 9;
            _context.next = 12;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/loa/status"), options));

          case 12:
            response = _context.sent;
            _context.next = 15;
            return regeneratorRuntime.awrap(response.json());

          case 15:
            status = _context.sent;
            dispatch({
              type: LOA_STATUS_FETCHED,
              term: "".concat(status.type, "Status"),
              status: status.accepted
            });
            return _context.abrupt("return", status);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](9);
            dispatch({
              type: LOA_STATUS_FAILED,
              message: 'request failed'
            });
            return _context.abrupt("return", Promise.reject('request failed'));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[9, 20]]);
  };
}

function fetchLOAContent() {
  return function asyncFetchLOAContent(dispatch, getState) {
    var state, _state$userPrefs$loca, lang, options, response, html;

    return regeneratorRuntime.async(function asyncFetchLOAContent$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();

            if (!((0, _has2.default)(state, 'terms.loa.content.html') && state.terms.loa.content.html)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", Promise.resolve((0, _get2.default)(state, 'terms.loa.content.html')));

          case 3:
            _state$userPrefs$loca = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca === void 0 ? 'en-us' : _state$userPrefs$loca;
            options = {
              method: 'GET'
            };
            dispatch({
              type: LOA_CONTENT_FETCHING
            });
            _context2.prev = 6;
            _context2.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/loa?lang=").concat(lang), options));

          case 9:
            response = _context2.sent;
            _context2.next = 12;
            return regeneratorRuntime.awrap(response.text());

          case 12:
            html = _context2.sent;
            dispatch({
              type: LOA_CONTENT_FETCHED,
              html: html
            });
            _context2.next = 20;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](6);
            dispatch({
              type: LOA_CONTENT_FAILED,
              message: _context2.t0.message
            });
            return _context2.abrupt("return", Promise.reject('request failed'));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[6, 16]]);
  };
}

function fetchTermsStatus() {
  return function asyncFetchTermsStatus(dispatch, getState) {
    var _getState2, _getState2$JWT, _getState2$JWT$token, token, options, termsStatusReponse, termsJSON, pass;

    return regeneratorRuntime.async(function asyncFetchTermsStatus$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), _getState2$JWT = _getState2.JWT;
            _getState2$JWT = _getState2$JWT === void 0 ? {} : _getState2$JWT;
            _getState2$JWT$token = _getState2$JWT.token, token = _getState2$JWT$token === void 0 ? '' : _getState2$JWT$token;
            dispatch({
              type: TERMS_STATUS_FETCHING
            });
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token); // Get term status, update their status in the store. If either
            // has not abeen accepted, return false, else return true

            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/appcenter/status"), options));

          case 9:
            termsStatusReponse = _context3.sent;
            _context3.next = 12;
            return regeneratorRuntime.awrap(termsStatusReponse.json());

          case 12:
            termsJSON = _context3.sent;
            pass = true;

            if (!termsJSON.accepted) {
              pass = termsJSON.accepted;
            }

            dispatch({
              type: UPDATE_PREVIOUSLY_ACCEPTED_STATUS,
              term: "".concat(termsJSON.type, "Status"),
              status: termsJSON.accepted
            });
            dispatch({
              type: TERMS_STATUS_FETCHED
            });
            return _context3.abrupt("return", pass);

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](6);
            throw _context3.t0;

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 20]]);
  };
}

function fetchTermsContent() {
  return function asyncFetchTermsContent(dispatch, getState) {
    var _getState3, appcenterTerms, options, response, data;

    return regeneratorRuntime.async(function asyncFetchTermsContent$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _getState3 = getState(), appcenterTerms = _getState3.terms.appcenterTerms;

            if (!appcenterTerms) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return");

          case 3:
            dispatch({
              type: TERMS_FETCHING
            });
            options = {
              method: 'GET',
              headers: {}
            };
            _context4.next = 7;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/"), options));

          case 7:
            response = _context4.sent;
            _context4.next = 10;
            return regeneratorRuntime.awrap(response.json());

          case 10:
            data = _context4.sent;
            dispatch({
              type: TERMS_FETCHED,
              terms: data
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    });
  };
}

function fetchSharedInfoContent(listingId, v1ListingId) {
  return function asyncFetchSharedInfoContent(dispatch, getState) {
    var _getState4, _getState4$userPrefs$, lang, ID, options, response, json, data;

    return regeneratorRuntime.async(function asyncFetchSharedInfoContent$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _getState4 = getState(), _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
            dispatch({
              type: SHARED_INFO_FETCHING
            });

            if ((0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core"))) {
              ID = listingId;
            } else {
              ID = v1ListingId;
            }

            options = {
              method: 'GET',
              headers: {}
            };
            _context5.prev = 4;
            _context5.next = 7;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/listings/").concat(ID, "/scopes?lang=").concat(lang), options));

          case 7:
            response = _context5.sent;
            _context5.next = 10;
            return regeneratorRuntime.awrap(response.json());

          case 10:
            json = _context5.sent;
            // TODO: what is this?
            data = json.map(function (i) {
              return i.description;
            });
            return _context5.abrupt("return", dispatch({
              type: SHARED_INFO_FETCHED,
              data: data
            }));

          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](4);
            return _context5.abrupt("return", Promise.reject(_context5.t0));

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, [[4, 15]]);
  };
}

function updateTerms(userId) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appcenter';
  return function asyncUpdateTerms(dispatch, getState) {
    var _getState5, _getState5$JWT, _getState5$JWT$token, token, options;

    return regeneratorRuntime.async(function asyncUpdateTerms$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _getState5 = getState(), _getState5$JWT = _getState5.JWT;
            _getState5$JWT = _getState5$JWT === void 0 ? {} : _getState5$JWT;
            _getState5$JWT$token = _getState5$JWT.token, token = _getState5$JWT$token === void 0 ? '' : _getState5$JWT$token;
            dispatch({
              type: TERMS_UPDATING
            });
            options = {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context6.prev = 6;
            _context6.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/").concat(type, "/status"), options));

          case 9:
            return _context6.abrupt("return", _context6.sent);

          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](6);
            return _context6.abrupt("return", Promise.reject(_context6.t0));

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, null, null, [[6, 12]]);
  };
}

function toggleTaCModal(tAndCLinkClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_TAC_MODAL,
      tAndCLinkClicked: tAndCLinkClicked
    });
  };
}

function launchTaCModal(_ref) {
  var tAndCLinkClicked = _ref.tAndCLinkClicked,
      _ref$flow = _ref.flow,
      flow = _ref$flow === void 0 ? '' : _ref$flow,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      _ref$needAnAccountCli = _ref.needAnAccountClicked,
      needAnAccountClicked = _ref$needAnAccountCli === void 0 ? {
    needAnAccountClicked: false
  } : _ref$needAnAccountCli;
  return function (dispatch, getState) {
    var _getState6 = getState(),
        _getState6$terms = _getState6.terms,
        appcenterTerms = _getState6$terms.appcenterTerms,
        appcenterStatus = _getState6$terms.appcenterStatus;

    if (needAnAccountClicked) {
      dispatch(listingActions.toggleNeedAnAccountClicked(true));
    }

    if (tAndCLinkClicked && !appcenterTerms) {
      dispatch(toggleTaCModal(tAndCLinkClicked));
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
      dispatch(fetchLOAContent);
    } else {
      var ACTermsOK = appcenterStatus.previouslyAccepted || appcenterStatus.currentlyAccepted;

      if (flow === 'WEBFLOW' && ACTermsOK) {
        dispatch(listingActions.connectListing(listingId, v1ListingId));
        return;
      }

      dispatch(toggleTaCModal());
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
    }
  };
}

function updateCurrentlyAccepted(field, value) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_CURRENTLY_ACCEPTED_STATUS,
      field: field,
      value: value
    });
  };
}

var initialState = {
  isTaCModalOpen: false,
  tAndCLinkClicked: false,
  appcenterStatus: {
    previouslyAccepted: false,
    currentlyAccepted: false
  },
  loa: {
    status: {
      previouslyAccepted: false,
      currentlyAccepted: false
    },
    content: {
      html: ''
    }
  },
  ereceiptStatus: {
    previouslyAccepted: false,
    currentlyAccepted: false
  },
  sharedInfoStatus: {
    currentlyAccepted: false
  },
  sharedInfo: [],
  content: [{
    type: 'appcenter',
    content: ''
  }]
}; // this reducer handles everything off of rootState.terms

exports.initialState = initialState;

function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case TOGGLE_TAC_MODAL:
      return (0, _merge4.default)({}, state, {
        isTaCModalOpen: !state.isTaCModalOpen,
        tAndCLinkClicked: action.tAndCLinkClicked
      });

    case UPDATE_PREVIOUSLY_ACCEPTED_STATUS:
      return (0, _merge4.default)({}, state, _defineProperty({}, action.term, {
        previouslyAccepted: action.status
      }));

    case UPDATE_CURRENTLY_ACCEPTED_STATUS:
      // loa has a different (newer, better) schema than appcenter and ereceipt
      if (action.field === 'loaStatus') {
        return (0, _merge4.default)({}, state, {
          loa: {
            status: {
              currentlyAccepted: action.value
            }
          }
        });
      }

      return (0, _merge4.default)({}, state, _defineProperty({}, action.field, {
        currentlyAccepted: action.value
      }));

    case TERMS_FETCHED:
      return _objectSpread({}, state, {
        content: action.terms
      });

    case SHARED_INFO_FETCHED:
      return _objectSpread({}, state, {
        sharedInfo: action.data
      });

    case LOA_STATUS_FETCHING:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FETCHING'
          }
        })
      });

    case LOA_STATUS_FETCHED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FETCHED',
            previouslyAccepted: action.status,
            currentlyAccepted: action.status
          }
        })
      });

    case LOA_STATUS_FAILED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });

    case LOA_CONTENT_FETCHING:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FETCHING'
          }
        })
      });

    case LOA_CONTENT_FETCHED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FETCHED',
            html: action.html
          }
        })
      });

    case LOA_CONTENT_FAILED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });

    default:
      return state;
  }
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(86);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonClickDispatch = buttonClickDispatch;
exports.linkClickDispatch = linkClickDispatch;
exports.interactionEventDispatch = interactionEventDispatch;

var Actions = _interopRequireWildcard(__webpack_require__(73));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * fetches requests
 * @returns {thunk} puts returned requests in state
 */
function buttonClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackButtonClick(payload));
  };
}

function linkClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackLinkClick(payload));
  };
}

function interactionEventDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackInteractionEvent(payload));
  };
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1724);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = shouldPureComponentUpdate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _shallowEqual = __webpack_require__(124);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function shouldPureComponentUpdate(nextProps, nextState) {
  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
}

module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(8);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(134);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1297);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(81);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(619);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserProfileIfNeeded = fetchUserProfileIfNeeded;
exports.isAppCenterEnabledCheck = isAppCenterEnabledCheck;
exports.default = userProfile;
exports.getOfferingsEnabled = exports.APPCENTER_ENABLED_CHECK_FAILED = exports.APPCENTER_ENABLED_CHECK_PASSED = exports.USER_PROFILE_FETCH_FAILED = exports.USER_PROFILE_FETCHED = exports.USER_PROFILE_FETCHING = void 0;

var _merge2 = _interopRequireDefault(__webpack_require__(23));

var _config = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USER_PROFILE_FETCHING = '@@userProfileModule/USER_PROFILE_FETCHING';
exports.USER_PROFILE_FETCHING = USER_PROFILE_FETCHING;
var USER_PROFILE_FETCHED = '@@userProfileModule/USER_PROFILE_FETCHED';
exports.USER_PROFILE_FETCHED = USER_PROFILE_FETCHED;
var USER_PROFILE_FETCH_FAILED = '@@userProfileModule/USER_PROFILE_FETCH_FAILED';
exports.USER_PROFILE_FETCH_FAILED = USER_PROFILE_FETCH_FAILED;
var APPCENTER_ENABLED_CHECK_PASSED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_PASSED';
exports.APPCENTER_ENABLED_CHECK_PASSED = APPCENTER_ENABLED_CHECK_PASSED;
var APPCENTER_ENABLED_CHECK_FAILED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_FAILED';
exports.APPCENTER_ENABLED_CHECK_FAILED = APPCENTER_ENABLED_CHECK_FAILED;
var APIEndpoint;
var CTEEndpoint = _config.default.CTEUrl;

if ((0, _utils.canUseDOM)()) {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/api/userprofile");
} else {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/api/userprofile");
}

var getOfferingsEnabled = function getOfferingsEnabled(profile) {
  var offeringsEnabled = [];

  if (profile.IsTripLinkUser) {
    offeringsEnabled.push('TRIPLINK');
  }

  if (profile.IsTravelUser) {
    offeringsEnabled.push('TRVSTD', 'TRVPRO');
  }

  if (profile.IsTravelUser && (profile.TravelOffering === 'PROFESSIONAL' || profile.TravelOffering === 'STANDARD')) {
    offeringsEnabled.push('TRQPRO');
  }

  if (profile.IsExpenseUser && (profile.ExpenseOffering === 'CTE' || profile.ExpenseOffering === 'HONG_KONG')) {
    offeringsEnabled.push('EXPSTD', 'INVSTD', 'INVPRO');
  }

  if (profile.IsExpenseUser && profile.ExpenseOffering === 'CTE') {
    offeringsEnabled.push('EXPPRO');
  }

  return offeringsEnabled;
};

exports.getOfferingsEnabled = getOfferingsEnabled;

function fetchUserProfileIfNeeded() {
  return function _callee(dispatch, getState) {
    var _getState, _getState$JWT, _getState$JWT$token, token, userProfile, options, url, response, user, offeringsEnabled;

    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token, userProfile = _getState.userProfile;

            if (!(token && userProfile && !userProfile.offeringsEnabled)) {
              _context.next = 24;
              break;
            }

            options = {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            };
            url = "".concat(APIEndpoint);
            _context.prev = 6;
            _context.next = 9;
            return regeneratorRuntime.awrap(fetch(url, options));

          case 9:
            response = _context.sent;
            _context.next = 12;
            return regeneratorRuntime.awrap(response.json());

          case 12:
            user = _context.sent;

            if (getState().userProfile.offeringsEnabled) {
              _context.next = 17;
              break;
            }

            dispatch({
              type: USER_PROFILE_FETCHING
            });
            offeringsEnabled = getOfferingsEnabled(user);
            return _context.abrupt("return", Promise.resolve(dispatch({
              type: USER_PROFILE_FETCHED,
              offeringsEnabled: offeringsEnabled,
              user: user
            })));

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](6);
            dispatch({
              type: USER_PROFILE_FETCH_FAILED,
              error: _context.t0
            });

          case 22:
            _context.next = 25;
            break;

          case 24:
            return _context.abrupt("return", Promise.resolve());

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[6, 19]]);
  };
}

function isAppCenterEnabledCheck() {
  return function _callee2(dispatch, getState) {
    var _getState2, profile;

    return regeneratorRuntime.async(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return regeneratorRuntime.awrap(dispatch(fetchUserProfileIfNeeded()));

          case 2:
            _getState2 = getState(), profile = _getState2.userProfile.profile;

            if (profile && !profile.IsAppCenterEnabled) {
              dispatch({
                type: APPCENTER_ENABLED_CHECK_FAILED
              });
              window.location = "".concat(CTEEndpoint, "/errors/securitybreach.asp?nolog=1");
            } else {
              dispatch({
                type: APPCENTER_ENABLED_CHECK_PASSED
              });
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
}

var initialState = {};

function userProfile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case USER_PROFILE_FETCHED:
      return _objectSpread({}, state, {
        offeringsEnabled: action.offeringsEnabled,
        profile: action.user
      });

    case USER_PROFILE_FETCH_FAILED:
      return _objectSpread({}, state, {
        error: action.error
      });

    case 'dev/user':
      return (0, _merge2.default)({}, state, action.newValue);

    default:
      return state;
  }
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1897);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(169), __esModule: true };

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactRouter = __webpack_require__(8);

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _trackClick = __webpack_require__(11);

var ListingsActions = _interopRequireWildcard(__webpack_require__(10));

var _AnalyticsModule = __webpack_require__(16);

var _SearchBar = _interopRequireDefault(__webpack_require__(242));

var _CategoryMenu = _interopRequireDefault(__webpack_require__(244));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(245) : void 0;

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Header = function Header(_ref) {
  var search = _ref.search,
      setSearch = _ref.setSearch,
      setSearchAndFilter = _ref.setSearchAndFilter,
      setCategory = _ref.setCategory,
      clearSearch = _ref.clearSearch,
      category = _ref.category,
      categories = _ref.categories,
      setAndFilterByCategory = _ref.setAndFilterByCategory,
      enableLiveSearch = _ref.enableLiveSearch,
      filterApps = _ref.filterApps,
      router = _ref.router,
      location = _ref.location,
      host = _ref.host,
      listingId = _ref.listingId,
      listings = _ref.listings,
      companyUUID = _ref.companyUUID,
      userId = _ref.userId,
      trackCategoryLinkClick = _ref.trackCategoryLinkClick,
      getTitle = _ref.getTitle,
      profile = _ref.profile;

  var handleHeaderClick = function handleHeaderClick() {
    if (router.location.pathname !== (0, _utils.getAppCenterPathName)(location.pathname)) {
      setCategory();
    }

    clearSearch();
    setSearch();
    setCategory();
    router.push((0, _utils.getAppCenterPathName)(location.pathname));
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12 col-sm-7 col-xs-12"
  }, _react.default.createElement(_trackClick.Tracked, {
    event: "CLICK",
    additional: {
      context: router.location.pathname === (0, _utils.getAppCenterPathName)(location.pathname) ? 'HOME' : 'LISTING_DETAILS',
      type: 'LINK',
      value: 'APPCENTER_HEADER',
      domain: {
        host: host
      }
    }
  }, _react.default.createElement("h2", {
    className: "appcenter-title",
    onClick: handleHeaderClick
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AppCenterHeader"
  })))), _react.default.createElement("div", {
    className: "col-xs-5 col-sm-5 col-xs-12"
  }, _react.default.createElement(_SearchBar.default, {
    search: search,
    onChange: enableLiveSearch ? setSearchAndFilter : setSearch,
    filterApps: filterApps
  }))), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12 col-sm-5"
  }, _react.default.createElement(_CategoryMenu.default, {
    display: !listingId && listings.length >= 20,
    category: category,
    categories: categories,
    companyUUID: companyUUID,
    userId: userId,
    setAndFilterByCategory: setAndFilterByCategory,
    trackCategoryLinkClick: trackCategoryLinkClick
  })), _react.default.createElement("div", {
    className: "col-sm-7 appcenter-help"
  }, listingId !== 'help' && _react.default.createElement(_reactRouter.Link, {
    to: "".concat((0, _utils.getAppCenterPathName)(location.pathname), "/help"),
    onClick: function onClick() {
      return document.title = getTitle('Help');
    }
  }, _react.default.createElement("span", null, "Need help?")))));
};

Header.propTypes = {
  search: _propTypes.default.string.isRequired,
  setSearch: _propTypes.default.func,
  setSearchAndFilter: _propTypes.default.func.isRequired,
  setCategory: _propTypes.default.func.isRequired,
  clearSearch: _propTypes.default.func.isRequired,
  filterApps: _propTypes.default.func.isRequired,
  setAndFilterByCategory: _propTypes.default.func.isRequired,
  categories: _propTypes.default.arrayOf(_propTypes.default.object),
  enableLiveSearch: _propTypes.default.bool,
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  host: _propTypes.default.string,
  trackCategoryLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  userId: _propTypes.default.string,
  profile: _propTypes.default.object
};

var HeaderWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(HeaderWrapper, _Component);

  function HeaderWrapper() {
    _classCallCheck(this, HeaderWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeaderWrapper).apply(this, arguments));
  }

  _createClass(HeaderWrapper, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(Header, _extends({}, this.props, {
        getTitle: this.props.context.getTitle
      })));
    }
  }]);

  return HeaderWrapper;
}(_react.Component);

function mapStateToProps(state) {
  return {
    listings: state.listings.list,
    search: state.listings.search,
    categories: state.listings.categories,
    category: state.listings.category,
    host: state.meta.host,
    companyUUID: state.userPrefs.companyUUID,
    userId: state.userPrefs.userId,
    profile: state.userProfile.profile
  };
}

var mappedHeader = (0, _reactRedux.connect)(mapStateToProps, {
  setSearch: ListingsActions.setSearch,
  setCategory: ListingsActions.setCategory,
  clearSearch: ListingsActions.clearSearch,
  setSearchAndFilter: ListingsActions.setAndFilter,
  filterApps: ListingsActions.filterListingsByAll,
  setAndFilterByCategory: ListingsActions.setAndFilterByCategory,
  trackCategoryLinkClick: _AnalyticsModule.linkClickDispatch
})(HeaderWrapper);

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)(mappedHeader));

exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(116);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(96);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(31),
    arrayIncludes = __webpack_require__(32),
    arrayIncludesWith = __webpack_require__(33),
    cacheHas = __webpack_require__(34),
    createSet = __webpack_require__(96),
    setToArray = __webpack_require__(50);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1624);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(95);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1628);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(273);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1612);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1603);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCountryCode = setCountryCode;
exports.setIsPublic = setIsPublic;
exports.default = meta;
exports.initialState = exports.SET_IS_PUBLIC = exports.SET_COUNTRY_CODE = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_COUNTRY_CODE = 'SET_COUNTRY_CODE';
exports.SET_COUNTRY_CODE = SET_COUNTRY_CODE;
var SET_IS_PUBLIC = 'SET_IS_PUBLIC';
exports.SET_IS_PUBLIC = SET_IS_PUBLIC;

function setCountryCode(code) {
  if (typeof code !== 'string') throw new Error("code is required and must be a string -- received: ".concat(code));
  return {
    type: SET_COUNTRY_CODE,
    code: code
  };
}

function setIsPublic(value) {
  if (typeof value !== 'boolean') throw new Error("value is required and must be a boolean -- received: ".concat(value));
  return {
    type: SET_IS_PUBLIC,
    value: value
  };
}

var initialState = {
  country: 'US'
};
exports.initialState = initialState;

function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_COUNTRY_CODE:
      return _objectSpread({}, state, {
        country: action.code
      });

    case SET_IS_PUBLIC:
      return _objectSpread({}, state, {
        isPublic: action.value
      });

    default:
      return state;
  }
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reduxDevtoolsInstrument = __webpack_require__(55);

Object.defineProperty(exports, 'instrument', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxDevtoolsInstrument).default;
  }
});
Object.defineProperty(exports, 'ActionCreators', {
  enumerable: true,
  get: function get() {
    return _reduxDevtoolsInstrument.ActionCreators;
  }
});
Object.defineProperty(exports, 'ActionTypes', {
  enumerable: true,
  get: function get() {
    return _reduxDevtoolsInstrument.ActionTypes;
  }
});

var _persistState = __webpack_require__(118);

Object.defineProperty(exports, 'persistState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_persistState).default;
  }
});

var _createDevTools = __webpack_require__(121);

Object.defineProperty(exports, 'createDevTools', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createDevTools).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(4);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(5);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(6);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(40);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(42);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONArrow = __webpack_require__(65);

var _JSONArrow2 = _interopRequireDefault(_JSONArrow);

var _getCollectionEntries = __webpack_require__(180);

var _getCollectionEntries2 = _interopRequireDefault(_getCollectionEntries);

var _JSONNode = __webpack_require__(63);

var _JSONNode2 = _interopRequireDefault(_JSONNode);

var _ItemRange = __webpack_require__(185);

var _ItemRange2 = _interopRequireDefault(_ItemRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Renders nested values (eg. objects, arrays, lists, etc.)
 */

function renderChildNodes(props, from, to) {
  var nodeType = props.nodeType,
      data = props.data,
      collectionLimit = props.collectionLimit,
      circularCache = props.circularCache,
      keyPath = props.keyPath,
      postprocessValue = props.postprocessValue,
      sortObjectKeys = props.sortObjectKeys;

  var childNodes = [];

  (0, _getCollectionEntries2['default'])(nodeType, data, sortObjectKeys, collectionLimit, from, to).forEach(function (entry) {
    if (entry.to) {
      childNodes.push(_react2['default'].createElement(_ItemRange2['default'], (0, _extends3['default'])({}, props, {
        key: 'ItemRange--' + entry.from + '-' + entry.to,
        from: entry.from,
        to: entry.to,
        renderChildNodes: renderChildNodes
      })));
    } else {
      var key = entry.key,
          value = entry.value;

      var isCircular = circularCache.indexOf(value) !== -1;

      var node = _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, props, { postprocessValue: postprocessValue, collectionLimit: collectionLimit }, {
        key: 'Node--' + key,
        keyPath: [key].concat(keyPath),
        value: postprocessValue(value),
        circularCache: [].concat(circularCache, [value]),
        isCircular: isCircular,
        hideRoot: false
      }));

      if (node !== false) {
        childNodes.push(node);
      }
    }
  });

  return childNodes;
}

function getStateFromProps(props) {
  // calculate individual node expansion if necessary
  var expanded = props.shouldExpandNode && !props.isCircular ? props.shouldExpandNode(props.keyPath, props.data, props.level) : false;
  return {
    expanded: expanded
  };
}

var JSONNestedNode = function (_React$Component) {
  (0, _inherits3['default'])(JSONNestedNode, _React$Component);

  function JSONNestedNode(props) {
    (0, _classCallCheck3['default'])(this, JSONNestedNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.handleClick = function () {
      if (_this.props.expandable) {
        _this.setState({ expanded: !_this.state.expanded });
      }
    };

    _this.state = getStateFromProps(props);
    return _this;
  }

  JSONNestedNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextState = getStateFromProps(nextProps);
    if (getStateFromProps(this.props).expanded !== nextState.expanded) {
      this.setState(nextState);
    }
  };

  JSONNestedNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this2 = this;

    return !!(0, _keys2['default'])(nextProps).find(function (key) {
      return key !== 'circularCache' && (key === 'keyPath' ? nextProps[key].join('/') !== _this2.props[key].join('/') : nextProps[key] !== _this2.props[key]);
    }) || nextState.expanded !== this.state.expanded;
  };

  JSONNestedNode.prototype.render = function render() {
    var _props = this.props,
        getItemString = _props.getItemString,
        nodeTypeIndicator = _props.nodeTypeIndicator,
        nodeType = _props.nodeType,
        data = _props.data,
        hideRoot = _props.hideRoot,
        createItemString = _props.createItemString,
        styling = _props.styling,
        collectionLimit = _props.collectionLimit,
        keyPath = _props.keyPath,
        labelRenderer = _props.labelRenderer,
        expandable = _props.expandable;
    var expanded = this.state.expanded;

    var renderedChildren = expanded || hideRoot && this.props.level === 0 ? renderChildNodes((0, _extends3['default'])({}, this.props, { level: this.props.level + 1 })) : null;

    var itemType = _react2['default'].createElement(
      'span',
      styling('nestedNodeItemType', expanded),
      nodeTypeIndicator
    );
    var renderedItemString = getItemString(nodeType, data, itemType, createItemString(data, collectionLimit));
    var stylingArgs = [keyPath, nodeType, expanded, expandable];

    return hideRoot ? _react2['default'].createElement(
      'li',
      styling.apply(undefined, ['rootNode'].concat(stylingArgs)),
      _react2['default'].createElement(
        'ul',
        styling.apply(undefined, ['rootNodeChildren'].concat(stylingArgs)),
        renderedChildren
      )
    ) : _react2['default'].createElement(
      'li',
      styling.apply(undefined, ['nestedNode'].concat(stylingArgs)),
      expandable && _react2['default'].createElement(_JSONArrow2['default'], {
        styling: styling,
        nodeType: nodeType,
        expanded: expanded,
        onClick: this.handleClick
      }),
      _react2['default'].createElement(
        'label',
        (0, _extends3['default'])({}, styling.apply(undefined, [['label', 'nestedNodeLabel']].concat(stylingArgs)), {
          onClick: this.handleClick
        }),
        labelRenderer.apply(undefined, stylingArgs)
      ),
      _react2['default'].createElement(
        'span',
        (0, _extends3['default'])({}, styling.apply(undefined, ['nestedNodeItemString'].concat(stylingArgs)), {
          onClick: this.handleClick
        }),
        renderedItemString
      ),
      _react2['default'].createElement(
        'ul',
        styling.apply(undefined, ['nestedNodeChildren'].concat(stylingArgs)),
        renderedChildren
      )
    );
  };

  return JSONNestedNode;
}(_react2['default'].Component);

JSONNestedNode.propTypes = {
  getItemString: _propTypes2['default'].func.isRequired,
  nodeTypeIndicator: _propTypes2['default'].any,
  nodeType: _propTypes2['default'].string.isRequired,
  data: _propTypes2['default'].any,
  hideRoot: _propTypes2['default'].bool.isRequired,
  createItemString: _propTypes2['default'].func.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  collectionLimit: _propTypes2['default'].number,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  shouldExpandNode: _propTypes2['default'].func,
  level: _propTypes2['default'].number.isRequired,
  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool]),
  isCircular: _propTypes2['default'].bool,
  expandable: _propTypes2['default'].bool
};
JSONNestedNode.defaultProps = {
  data: [],
  circularCache: [],
  level: 0,
  expandable: true
};
exports['default'] = JSONNestedNode;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports) {

function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

module.exports = clamp;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83);
__webpack_require__(84);
var path = __webpack_require__(85);

module.exports = path;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(521);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(63);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(154);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(639);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(678);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(62);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(629);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(153);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

exports.__esModule = true;
exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.liftAction = liftAction;
exports.liftReducerWith = liftReducerWith;
exports.unliftState = unliftState;
exports.unliftStore = unliftStore;
exports.default = instrument;

var _difference = __webpack_require__(113);

var _difference2 = _interopRequireDefault(_difference);

var _union = __webpack_require__(115);

var _union2 = _interopRequireDefault(_union);

var _isPlainObject = __webpack_require__(116);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(117);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = exports.ActionTypes = {
  PERFORM_ACTION: 'PERFORM_ACTION',
  RESET: 'RESET',
  ROLLBACK: 'ROLLBACK',
  COMMIT: 'COMMIT',
  SWEEP: 'SWEEP',
  TOGGLE_ACTION: 'TOGGLE_ACTION',
  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
  JUMP_TO_STATE: 'JUMP_TO_STATE',
  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
  REORDER_ACTION: 'REORDER_ACTION',
  IMPORT_STATE: 'IMPORT_STATE',
  LOCK_CHANGES: 'LOCK_CHANGES',
  PAUSE_RECORDING: 'PAUSE_RECORDING'
};

var isChrome = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer');

var isChromeOrNode = isChrome || typeof process !== 'undefined' && process.release && process.release.name === 'node';

/**
 * Action creators to change the History state.
 */
var ActionCreators = exports.ActionCreators = {
  performAction: function performAction(action, trace, traceLimit, toExcludeFromTrace) {
    if (!(0, _isPlainObject2.default)(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    var stack = void 0;
    if (trace) {
      var extraFrames = 0;
      if (typeof trace === 'function') {
        stack = trace(action);
      } else {
        var error = Error();
        var prevStackTraceLimit = void 0;
        if (Error.captureStackTrace && isChromeOrNode) {
          // avoid error-polyfill
          if (Error.stackTraceLimit < traceLimit) {
            prevStackTraceLimit = Error.stackTraceLimit;
            Error.stackTraceLimit = traceLimit;
          }
          Error.captureStackTrace(error, toExcludeFromTrace);
        } else {
          extraFrames = 3;
        }
        stack = error.stack;
        if (prevStackTraceLimit) Error.stackTraceLimit = prevStackTraceLimit;
        if (extraFrames || typeof Error.stackTraceLimit !== 'number' || Error.stackTraceLimit > traceLimit) {
          var frames = stack.split('\n');
          if (frames.length > traceLimit) {
            stack = frames.slice(0, traceLimit + extraFrames + (frames[0] === 'Error' ? 1 : 0)).join('\n');
          }
        }
      }
    }

    return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now(), stack: stack };
  },
  reset: function reset() {
    return { type: ActionTypes.RESET, timestamp: Date.now() };
  },
  rollback: function rollback() {
    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
  },
  commit: function commit() {
    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
  },
  sweep: function sweep() {
    return { type: ActionTypes.SWEEP };
  },
  toggleAction: function toggleAction(id) {
    return { type: ActionTypes.TOGGLE_ACTION, id: id };
  },
  setActionsActive: function setActionsActive(start, end) {
    var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
  },
  reorderAction: function reorderAction(actionId, beforeActionId) {
    return { type: ActionTypes.REORDER_ACTION, actionId: actionId, beforeActionId: beforeActionId };
  },
  jumpToState: function jumpToState(index) {
    return { type: ActionTypes.JUMP_TO_STATE, index: index };
  },
  jumpToAction: function jumpToAction(actionId) {
    return { type: ActionTypes.JUMP_TO_ACTION, actionId: actionId };
  },
  importState: function importState(nextLiftedState, noRecompute) {
    return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState, noRecompute: noRecompute };
  },
  lockChanges: function lockChanges(status) {
    return { type: ActionTypes.LOCK_CHANGES, status: status };
  },
  pauseRecording: function pauseRecording(status) {
    return { type: ActionTypes.PAUSE_RECORDING, status: status };
  }
};

var INIT_ACTION = exports.INIT_ACTION = { type: '@@INIT' };

/**
 * Computes the next entry with exceptions catching.
 */
function computeWithTryCatch(reducer, action, state) {
  var nextState = state;
  var nextError = void 0;
  try {
    nextState = reducer(state, action);
  } catch (err) {
    nextError = err.toString();
    if (isChrome) {
      // In Chrome, rethrowing provides better source map support
      setTimeout(function () {
        throw err;
      });
    } else {
      console.error(err);
    }
  }

  return {
    state: nextState,
    error: nextError
  };
}

/**
 * Computes the next entry in the log by applying an action.
 */
function computeNextEntry(reducer, action, state, shouldCatchErrors) {
  if (!shouldCatchErrors) {
    return { state: reducer(state, action) };
  }
  return computeWithTryCatch(reducer, action, state);
}

/**
 * Runs the reducer on invalidated actions to get a fresh computation log.
 */
function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
  // Optimization: exit early and return the same reference
  // if we know nothing could have changed.
  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
    return computedStates;
  }

  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
    var actionId = stagedActionIds[i];
    var action = actionsById[actionId].action;

    var previousEntry = nextComputedStates[i - 1];
    var previousState = previousEntry ? previousEntry.state : committedState;

    var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
    var entry = void 0;
    if (shouldSkip) {
      entry = previousEntry;
    } else {
      if (shouldCatchErrors && previousEntry && previousEntry.error) {
        entry = {
          state: previousState,
          error: 'Interrupted by an error up the chain'
        };
      } else {
        entry = computeNextEntry(reducer, action, previousState, shouldCatchErrors);
      }
    }
    nextComputedStates.push(entry);
  }

  return nextComputedStates;
}

/**
 * Lifts an app's action into an action on the lifted store.
 */
function liftAction(action, trace, traceLimit, toExcludeFromTrace) {
  return ActionCreators.performAction(action, trace, traceLimit, toExcludeFromTrace);
}

/**
 * Creates a history state reducer from an app's reducer.
 */
function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
  var initialLiftedState = {
    monitorState: monitorReducer(undefined, {}),
    nextActionId: 1,
    actionsById: { 0: liftAction(INIT_ACTION) },
    stagedActionIds: [0],
    skippedActionIds: [],
    committedState: initialCommittedState,
    currentStateIndex: 0,
    computedStates: [],
    isLocked: options.shouldStartLocked === true,
    isPaused: options.shouldRecordChanges === false
  };

  /**
   * Manages how the history actions modify the history state.
   */
  return function (liftedState, liftedAction) {
    var _ref = liftedState || initialLiftedState,
        monitorState = _ref.monitorState,
        actionsById = _ref.actionsById,
        nextActionId = _ref.nextActionId,
        stagedActionIds = _ref.stagedActionIds,
        skippedActionIds = _ref.skippedActionIds,
        committedState = _ref.committedState,
        currentStateIndex = _ref.currentStateIndex,
        computedStates = _ref.computedStates,
        isLocked = _ref.isLocked,
        isPaused = _ref.isPaused;

    if (!liftedState) {
      // Prevent mutating initialLiftedState
      actionsById = _extends({}, actionsById);
    }

    function commitExcessActions(n) {
      // Auto-commits n-number of excess actions.
      var excess = n;
      var idsToDelete = stagedActionIds.slice(1, excess + 1);

      for (var i = 0; i < idsToDelete.length; i++) {
        if (computedStates[i + 1].error) {
          // Stop if error is found. Commit actions up to error.
          excess = i;
          idsToDelete = stagedActionIds.slice(1, excess + 1);
          break;
        } else {
          delete actionsById[idsToDelete[i]];
        }
      }

      skippedActionIds = skippedActionIds.filter(function (id) {
        return idsToDelete.indexOf(id) === -1;
      });
      stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
      committedState = computedStates[excess].state;
      computedStates = computedStates.slice(excess);
      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
    }

    function computePausedAction(shouldInit) {
      var _extends2;

      var computedState = void 0;
      if (shouldInit) {
        computedState = computedStates[currentStateIndex];
        monitorState = monitorReducer(monitorState, liftedAction);
      } else {
        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
      }
      if (!options.pauseActionType || nextActionId === 1) {
        return {
          monitorState: monitorState,
          actionsById: { 0: liftAction(INIT_ACTION) },
          nextActionId: 1,
          stagedActionIds: [0],
          skippedActionIds: [],
          committedState: computedState.state,
          currentStateIndex: 0,
          computedStates: [computedState],
          isLocked: isLocked,
          isPaused: true
        };
      }
      if (shouldInit) {
        if (currentStateIndex === stagedActionIds.length - 1) {
          currentStateIndex++;
        }
        stagedActionIds = [].concat(stagedActionIds, [nextActionId]);
        nextActionId++;
      }
      return {
        monitorState: monitorState,
        actionsById: _extends({}, actionsById, (_extends2 = {}, _extends2[nextActionId - 1] = liftAction({ type: options.pauseActionType }), _extends2)),
        nextActionId: nextActionId,
        stagedActionIds: stagedActionIds,
        skippedActionIds: skippedActionIds,
        committedState: committedState,
        currentStateIndex: currentStateIndex,
        computedStates: [].concat(computedStates.slice(0, stagedActionIds.length - 1), [computedState]),
        isLocked: isLocked,
        isPaused: true
      };
    }

    // By default, agressively recompute every state whatever happens.
    // This has O(n) performance, so we'll override this to a sensible
    // value whenever we feel like we don't have to recompute the states.
    var minInvalidatedStateIndex = 0;

    // maxAge number can be changed dynamically
    var maxAge = options.maxAge;
    if (typeof maxAge === 'function') maxAge = maxAge(liftedAction, liftedState);

    if (/^@@redux\/(INIT|REPLACE)/.test(liftedAction.type)) {
      if (options.shouldHotReload === false) {
        actionsById = { 0: liftAction(INIT_ACTION) };
        nextActionId = 1;
        stagedActionIds = [0];
        skippedActionIds = [];
        committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
        currentStateIndex = 0;
        computedStates = [];
      }

      // Recompute states on hot reload and init.
      minInvalidatedStateIndex = 0;

      if (maxAge && stagedActionIds.length > maxAge) {
        // States must be recomputed before committing excess.
        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);

        commitExcessActions(stagedActionIds.length - maxAge);

        // Avoid double computation.
        minInvalidatedStateIndex = Infinity;
      }
    } else {
      switch (liftedAction.type) {
        case ActionTypes.PERFORM_ACTION:
          {
            if (isLocked) return liftedState || initialLiftedState;
            if (isPaused) return computePausedAction();

            // Auto-commit as new actions come in.
            if (maxAge && stagedActionIds.length >= maxAge) {
              commitExcessActions(stagedActionIds.length - maxAge + 1);
            }

            if (currentStateIndex === stagedActionIds.length - 1) {
              currentStateIndex++;
            }
            var actionId = nextActionId++;
            // Mutation! This is the hottest path, and we optimize on purpose.
            // It is safe because we set a new key in a cache dictionary.
            actionsById[actionId] = liftedAction;
            stagedActionIds = [].concat(stagedActionIds, [actionId]);
            // Optimization: we know that only the new action needs computing.
            minInvalidatedStateIndex = stagedActionIds.length - 1;
            break;
          }
        case ActionTypes.RESET:
          {
            // Get back to the state the store was created with.
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            committedState = initialCommittedState;
            currentStateIndex = 0;
            computedStates = [];
            break;
          }
        case ActionTypes.COMMIT:
          {
            // Consider the last committed state the new starting point.
            // Squash any staged actions into a single committed state.
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            committedState = computedStates[currentStateIndex].state;
            currentStateIndex = 0;
            computedStates = [];
            break;
          }
        case ActionTypes.ROLLBACK:
          {
            // Forget about any staged actions.
            // Start again from the last committed state.
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            currentStateIndex = 0;
            computedStates = [];
            break;
          }
        case ActionTypes.TOGGLE_ACTION:
          {
            // Toggle whether an action with given ID is skipped.
            // Being skipped means it is a no-op during the computation.
            var _actionId = liftedAction.id;

            var index = skippedActionIds.indexOf(_actionId);
            if (index === -1) {
              skippedActionIds = [_actionId].concat(skippedActionIds);
            } else {
              skippedActionIds = skippedActionIds.filter(function (id) {
                return id !== _actionId;
              });
            }
            // Optimization: we know history before this action hasn't changed
            minInvalidatedStateIndex = stagedActionIds.indexOf(_actionId);
            break;
          }
        case ActionTypes.SET_ACTIONS_ACTIVE:
          {
            // Toggle whether an action with given ID is skipped.
            // Being skipped means it is a no-op during the computation.
            var start = liftedAction.start,
                end = liftedAction.end,
                active = liftedAction.active;

            var actionIds = [];
            for (var i = start; i < end; i++) {
              actionIds.push(i);
            }if (active) {
              skippedActionIds = (0, _difference2.default)(skippedActionIds, actionIds);
            } else {
              skippedActionIds = (0, _union2.default)(skippedActionIds, actionIds);
            }

            // Optimization: we know history before this action hasn't changed
            minInvalidatedStateIndex = stagedActionIds.indexOf(start);
            break;
          }
        case ActionTypes.JUMP_TO_STATE:
          {
            // Without recomputing anything, move the pointer that tell us
            // which state is considered the current one. Useful for sliders.
            currentStateIndex = liftedAction.index;
            // Optimization: we know the history has not changed.
            minInvalidatedStateIndex = Infinity;
            break;
          }
        case ActionTypes.JUMP_TO_ACTION:
          {
            // Jumps to a corresponding state to a specific action.
            // Useful when filtering actions.
            var _index = stagedActionIds.indexOf(liftedAction.actionId);
            if (_index !== -1) currentStateIndex = _index;
            minInvalidatedStateIndex = Infinity;
            break;
          }
        case ActionTypes.SWEEP:
          {
            // Forget any actions that are currently being skipped.
            stagedActionIds = (0, _difference2.default)(stagedActionIds, skippedActionIds);
            skippedActionIds = [];
            currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
            break;
          }
        case ActionTypes.REORDER_ACTION:
          {
            // Recompute actions in a new order.
            var _actionId2 = liftedAction.actionId;
            var idx = stagedActionIds.indexOf(_actionId2);
            // do nothing in case the action is already removed or trying to move the first action
            if (idx < 1) break;
            var beforeActionId = liftedAction.beforeActionId;
            var newIdx = stagedActionIds.indexOf(beforeActionId);
            if (newIdx < 1) {
              // move to the beginning or to the end
              var count = stagedActionIds.length;
              newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
            }
            var diff = idx - newIdx;

            if (diff > 0) {
              // move left
              stagedActionIds = [].concat(stagedActionIds.slice(0, newIdx), [_actionId2], stagedActionIds.slice(newIdx, idx), stagedActionIds.slice(idx + 1));
              minInvalidatedStateIndex = newIdx;
            } else if (diff < 0) {
              // move right
              stagedActionIds = [].concat(stagedActionIds.slice(0, idx), stagedActionIds.slice(idx + 1, newIdx), [_actionId2], stagedActionIds.slice(newIdx));
              minInvalidatedStateIndex = idx;
            }
            break;
          }
        case ActionTypes.IMPORT_STATE:
          {
            if (Array.isArray(liftedAction.nextLiftedState)) {
              // recompute array of actions
              actionsById = { 0: liftAction(INIT_ACTION) };
              nextActionId = 1;
              stagedActionIds = [0];
              skippedActionIds = [];
              currentStateIndex = liftedAction.nextLiftedState.length;
              computedStates = [];
              committedState = liftedAction.preloadedState;
              minInvalidatedStateIndex = 0;
              // iterate through actions
              liftedAction.nextLiftedState.forEach(function (action) {
                actionsById[nextActionId] = liftAction(action, options.trace || options.shouldIncludeCallstack);
                stagedActionIds.push(nextActionId);
                nextActionId++;
              });
            } else {
              var _liftedAction$nextLif = liftedAction.nextLiftedState;
              // Completely replace everything.

              monitorState = _liftedAction$nextLif.monitorState;
              actionsById = _liftedAction$nextLif.actionsById;
              nextActionId = _liftedAction$nextLif.nextActionId;
              stagedActionIds = _liftedAction$nextLif.stagedActionIds;
              skippedActionIds = _liftedAction$nextLif.skippedActionIds;
              committedState = _liftedAction$nextLif.committedState;
              currentStateIndex = _liftedAction$nextLif.currentStateIndex;
              computedStates = _liftedAction$nextLif.computedStates;


              if (liftedAction.noRecompute) {
                minInvalidatedStateIndex = Infinity;
              }
            }

            break;
          }
        case ActionTypes.LOCK_CHANGES:
          {
            isLocked = liftedAction.status;
            minInvalidatedStateIndex = Infinity;
            break;
          }
        case ActionTypes.PAUSE_RECORDING:
          {
            isPaused = liftedAction.status;
            if (isPaused) {
              return computePausedAction(true);
            }
            // Commit when unpausing
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            committedState = computedStates[currentStateIndex].state;
            currentStateIndex = 0;
            computedStates = [];
            break;
          }
        default:
          {
            // If the action is not recognized, it's a monitor action.
            // Optimization: a monitor action can't change history.
            minInvalidatedStateIndex = Infinity;
            break;
          }
      }
    }

    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
    monitorState = monitorReducer(monitorState, liftedAction);
    return {
      monitorState: monitorState,
      actionsById: actionsById,
      nextActionId: nextActionId,
      stagedActionIds: stagedActionIds,
      skippedActionIds: skippedActionIds,
      committedState: committedState,
      currentStateIndex: currentStateIndex,
      computedStates: computedStates,
      isLocked: isLocked,
      isPaused: isPaused
    };
  };
}

/**
 * Provides an app's view into the state of the lifted store.
 */
function unliftState(liftedState) {
  var computedStates = liftedState.computedStates,
      currentStateIndex = liftedState.currentStateIndex;
  var state = computedStates[currentStateIndex].state;

  return state;
}

/**
 * Provides an app's view into the lifted store.
 */
function unliftStore(liftedStore, liftReducer, options) {
  var _extends3;

  var lastDefinedState = void 0;
  var trace = options.trace || options.shouldIncludeCallstack;
  var traceLimit = options.traceLimit || 10;

  function getState() {
    var state = unliftState(liftedStore.getState());
    if (state !== undefined) {
      lastDefinedState = state;
    }
    return lastDefinedState;
  }

  function dispatch(action) {
    liftedStore.dispatch(liftAction(action, trace, traceLimit, dispatch));
    return action;
  }

  return _extends({}, liftedStore, (_extends3 = {

    liftedStore: liftedStore,

    dispatch: dispatch,

    getState: getState,

    replaceReducer: function replaceReducer(nextReducer) {
      liftedStore.replaceReducer(liftReducer(nextReducer));
    }
  }, _extends3[_symbolObservable2.default] = function () {
    return _extends({}, liftedStore[_symbolObservable2.default](), {
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = liftedStore.subscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    });
  }, _extends3));
}

/**
 * Redux instrumentation store enhancer.
 */
function instrument() {
  var monitorReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return null;
  };
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options.maxAge === 'number' && options.maxAge < 2) {
    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
  }

  return function (createStore) {
    return function (reducer, initialState, enhancer) {

      function liftReducer(r) {
        if (typeof r !== 'function') {
          if (r && typeof r.default === 'function') {
            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
          }
          throw new Error('Expected the reducer to be a function.');
        }
        return liftReducerWith(r, initialState, monitorReducer, options);
      }

      var liftedStore = createStore(liftReducer(reducer), enhancer);
      if (liftedStore.liftedStore) {
        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
      }

      return unliftStore(liftedStore, liftReducer, options);
    };
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1688);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

var _base16 = __webpack_require__(58);

_defaults(exports, _interopExportWildcard(_base16, _defaults));

var _nicinabox = __webpack_require__(162);

exports.nicinabox = _interopRequire(_nicinabox);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _threezerotwofour = __webpack_require__(125);

exports.threezerotwofour = _interopRequire(_threezerotwofour);

var _apathy = __webpack_require__(126);

exports.apathy = _interopRequire(_apathy);

var _ashes = __webpack_require__(127);

exports.ashes = _interopRequire(_ashes);

var _atelierDune = __webpack_require__(128);

exports.atelierDune = _interopRequire(_atelierDune);

var _atelierForest = __webpack_require__(129);

exports.atelierForest = _interopRequire(_atelierForest);

var _atelierHeath = __webpack_require__(130);

exports.atelierHeath = _interopRequire(_atelierHeath);

var _atelierLakeside = __webpack_require__(131);

exports.atelierLakeside = _interopRequire(_atelierLakeside);

var _atelierSeaside = __webpack_require__(132);

exports.atelierSeaside = _interopRequire(_atelierSeaside);

var _bespin = __webpack_require__(133);

exports.bespin = _interopRequire(_bespin);

var _brewer = __webpack_require__(134);

exports.brewer = _interopRequire(_brewer);

var _bright = __webpack_require__(135);

exports.bright = _interopRequire(_bright);

var _chalk = __webpack_require__(136);

exports.chalk = _interopRequire(_chalk);

var _codeschool = __webpack_require__(137);

exports.codeschool = _interopRequire(_codeschool);

var _colors = __webpack_require__(138);

exports.colors = _interopRequire(_colors);

var _default = __webpack_require__(139);

exports['default'] = _interopRequire(_default);

var _eighties = __webpack_require__(140);

exports.eighties = _interopRequire(_eighties);

var _embers = __webpack_require__(141);

exports.embers = _interopRequire(_embers);

var _flat = __webpack_require__(142);

exports.flat = _interopRequire(_flat);

var _google = __webpack_require__(143);

exports.google = _interopRequire(_google);

var _grayscale = __webpack_require__(144);

exports.grayscale = _interopRequire(_grayscale);

var _greenscreen = __webpack_require__(145);

exports.greenscreen = _interopRequire(_greenscreen);

var _harmonic = __webpack_require__(146);

exports.harmonic = _interopRequire(_harmonic);

var _hopscotch = __webpack_require__(147);

exports.hopscotch = _interopRequire(_hopscotch);

var _isotope = __webpack_require__(148);

exports.isotope = _interopRequire(_isotope);

var _marrakesh = __webpack_require__(149);

exports.marrakesh = _interopRequire(_marrakesh);

var _mocha = __webpack_require__(150);

exports.mocha = _interopRequire(_mocha);

var _monokai = __webpack_require__(151);

exports.monokai = _interopRequire(_monokai);

var _ocean = __webpack_require__(152);

exports.ocean = _interopRequire(_ocean);

var _paraiso = __webpack_require__(153);

exports.paraiso = _interopRequire(_paraiso);

var _pop = __webpack_require__(154);

exports.pop = _interopRequire(_pop);

var _railscasts = __webpack_require__(155);

exports.railscasts = _interopRequire(_railscasts);

var _shapeshifter = __webpack_require__(156);

exports.shapeshifter = _interopRequire(_shapeshifter);

var _solarized = __webpack_require__(157);

exports.solarized = _interopRequire(_solarized);

var _summerfruit = __webpack_require__(158);

exports.summerfruit = _interopRequire(_summerfruit);

var _tomorrow = __webpack_require__(159);

exports.tomorrow = _interopRequire(_tomorrow);

var _tube = __webpack_require__(160);

exports.tube = _interopRequire(_tube);

var _twilight = __webpack_require__(161);

exports.twilight = _interopRequire(_twilight);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateScrollTop = updateScrollTop;
exports.startConsecutiveToggle = startConsecutiveToggle;
var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
function updateScrollTop(scrollTop) {
  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
}

var START_CONSECUTIVE_TOGGLE = exports.START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
function startConsecutiveToggle(id) {
  return { type: START_CONSECUTIVE_TOGGLE, id: id };
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(19);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(40);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(42);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNode = __webpack_require__(63);

var _JSONNode2 = _interopRequireDefault(_JSONNode);

var _createStylingFromTheme = __webpack_require__(194);

var _createStylingFromTheme2 = _interopRequireDefault(_createStylingFromTheme);

var _reactBase16Styling = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var identity = function identity(value) {
  return value;
}; // ES6 + inline style port of JSONViewer https://bitbucket.org/davevedder/react-json-viewer/
// all credits and original code to the author
// Dave Vedder <veddermatic@gmail.com> http://www.eskimospy.com/
// port by Daniele Zannotti http://www.github.com/dzannotti <dzannotti@me.com>

var expandRootNode = function expandRootNode(keyName, data, level) {
  return level === 0;
};
var defaultItemString = function defaultItemString(type, data, itemType, itemString) {
  return _react2['default'].createElement(
    'span',
    null,
    itemType,
    ' ',
    itemString
  );
};
var defaultLabelRenderer = function defaultLabelRenderer(_ref) {
  var label = _ref[0];
  return _react2['default'].createElement(
    'span',
    null,
    label,
    ':'
  );
};
var noCustomNode = function noCustomNode() {
  return false;
};

function checkLegacyTheming(theme, props) {
  var deprecatedStylingMethodsMap = {
    getArrowStyle: 'arrow',
    getListStyle: 'nestedNodeChildren',
    getItemStringStyle: 'nestedNodeItemString',
    getLabelStyle: 'label',
    getValueStyle: 'valueText'
  };

  var deprecatedStylingMethods = (0, _keys2['default'])(deprecatedStylingMethodsMap).filter(function (name) {
    return props[name];
  });

  if (deprecatedStylingMethods.length > 0) {
    if (typeof theme === 'string') {
      theme = {
        extend: theme
      };
    } else {
      theme = (0, _extends3['default'])({}, theme);
    }

    deprecatedStylingMethods.forEach(function (name) {
      // eslint-disable-next-line no-console
      console.error('Styling method "' + name + '" is deprecated, use "theme" property instead');

      theme[deprecatedStylingMethodsMap[name]] = function (_ref2) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var style = _ref2.style;
        return {
          style: (0, _extends3['default'])({}, style, props[name].apply(props, args))
        };
      };
    });
  }

  return theme;
}

function getStateFromProps(props) {
  var theme = checkLegacyTheming(props.theme, props);
  if (props.invertTheme) {
    if (typeof theme === 'string') {
      theme = theme + ':inverted';
    } else if (theme && theme.extend) {
      if (typeof theme === 'string') {
        theme = (0, _extends3['default'])({}, theme, { extend: theme.extend + ':inverted' });
      } else {
        theme = (0, _extends3['default'])({}, theme, { extend: (0, _reactBase16Styling.invertTheme)(theme.extend) });
      }
    } else if (theme) {
      theme = (0, _reactBase16Styling.invertTheme)(theme);
    }
  }
  return {
    styling: (0, _createStylingFromTheme2['default'])(theme)
  };
}

var JSONTree = function (_React$Component) {
  (0, _inherits3['default'])(JSONTree, _React$Component);

  function JSONTree(props) {
    (0, _classCallCheck3['default'])(this, JSONTree);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = getStateFromProps(props);
    return _this;
  }

  JSONTree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (['theme', 'invertTheme'].find(function (k) {
      return nextProps[k] !== _this2.props[k];
    })) {
      this.setState(getStateFromProps(nextProps));
    }
  };

  JSONTree.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this3 = this;

    return !!(0, _keys2['default'])(nextProps).find(function (k) {
      return k === 'keyPath' ? nextProps[k].join('/') !== _this3.props[k].join('/') : nextProps[k] !== _this3.props[k];
    });
  };

  JSONTree.prototype.render = function render() {
    var _props = this.props,
        value = _props.data,
        keyPath = _props.keyPath,
        postprocessValue = _props.postprocessValue,
        hideRoot = _props.hideRoot,
        theme = _props.theme,
        _ = _props.invertTheme,
        rest = (0, _objectWithoutProperties3['default'])(_props, ['data', 'keyPath', 'postprocessValue', 'hideRoot', 'theme', 'invertTheme']);
    var styling = this.state.styling;


    return _react2['default'].createElement(
      'ul',
      styling('tree'),
      _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, (0, _extends3['default'])({ postprocessValue: postprocessValue, hideRoot: hideRoot, styling: styling }, rest), {
        keyPath: hideRoot ? [] : keyPath,
        value: postprocessValue(value)
      }))
    );
  };

  return JSONTree;
}(_react2['default'].Component);

JSONTree.propTypes = {
  data: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
  hideRoot: _propTypes2['default'].bool,
  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
  invertTheme: _propTypes2['default'].bool,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
  postprocessValue: _propTypes2['default'].func,
  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool])
};
JSONTree.defaultProps = {
  shouldExpandNode: expandRootNode,
  hideRoot: false,
  keyPath: ['root'],
  getItemString: defaultItemString,
  labelRenderer: defaultLabelRenderer,
  valueRenderer: identity,
  postprocessValue: identity,
  isCustomNode: noCustomNode,
  collectionLimit: 50,
  invertTheme: true
};
exports['default'] = JSONTree;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(62);
var core = __webpack_require__(15);
var fails = __webpack_require__(173);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(117);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(19);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objType = __webpack_require__(174);

var _objType2 = _interopRequireDefault(_objType);

var _JSONObjectNode = __webpack_require__(176);

var _JSONObjectNode2 = _interopRequireDefault(_JSONObjectNode);

var _JSONArrayNode = __webpack_require__(186);

var _JSONArrayNode2 = _interopRequireDefault(_JSONArrayNode);

var _JSONIterableNode = __webpack_require__(187);

var _JSONIterableNode2 = _interopRequireDefault(_JSONIterableNode);

var _JSONValueNode = __webpack_require__(193);

var _JSONValueNode2 = _interopRequireDefault(_JSONValueNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var JSONNode = function JSONNode(_ref) {
  var getItemString = _ref.getItemString,
      keyPath = _ref.keyPath,
      labelRenderer = _ref.labelRenderer,
      styling = _ref.styling,
      value = _ref.value,
      valueRenderer = _ref.valueRenderer,
      isCustomNode = _ref.isCustomNode,
      rest = (0, _objectWithoutProperties3['default'])(_ref, ['getItemString', 'keyPath', 'labelRenderer', 'styling', 'value', 'valueRenderer', 'isCustomNode']);

  var nodeType = isCustomNode(value) ? 'Custom' : (0, _objType2['default'])(value);

  var simpleNodeProps = {
    getItemString: getItemString,
    key: keyPath[0],
    keyPath: keyPath,
    labelRenderer: labelRenderer,
    nodeType: nodeType,
    styling: styling,
    value: value,
    valueRenderer: valueRenderer
  };

  var nestedNodeProps = (0, _extends3['default'])({}, rest, simpleNodeProps, {
    data: value,
    isCustomNode: isCustomNode
  });

  switch (nodeType) {
    case 'Object':
    case 'Error':
    case 'WeakMap':
    case 'WeakSet':
      return _react2['default'].createElement(_JSONObjectNode2['default'], nestedNodeProps);
    case 'Array':
      return _react2['default'].createElement(_JSONArrayNode2['default'], nestedNodeProps);
    case 'Iterable':
    case 'Map':
    case 'Set':
      return _react2['default'].createElement(_JSONIterableNode2['default'], nestedNodeProps);
    case 'String':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
          return '"' + raw + '"';
        } }));
    case 'Number':
      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
    case 'Boolean':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw ? 'true' : 'false';
        }
      }));
    case 'Date':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw.toISOString();
        }
      }));
    case 'Null':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
          return 'null';
        } }));
    case 'Undefined':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
          return 'undefined';
        } }));
    case 'Function':
    case 'Symbol':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw.toString();
        }
      }));
    case 'Custom':
      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
    default:
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
          return '<' + nodeType + '>';
        } }));
  }
};

JSONNode.propTypes = {
  getItemString: _propTypes2['default'].func.isRequired,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  value: _propTypes2['default'].any,
  valueRenderer: _propTypes2['default'].func.isRequired,
  isCustomNode: _propTypes2['default'].func.isRequired
};

exports['default'] = JSONNode;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(177), __esModule: true };

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var JSONArrow = function JSONArrow(_ref) {
  var styling = _ref.styling,
      arrowStyle = _ref.arrowStyle,
      expanded = _ref.expanded,
      nodeType = _ref.nodeType,
      onClick = _ref.onClick;
  return _react2['default'].createElement(
    'div',
    (0, _extends3['default'])({}, styling('arrowContainer', arrowStyle), { onClick: onClick }),
    _react2['default'].createElement(
      'div',
      styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle),
      '\u25B6',
      arrowStyle === 'double' && _react2['default'].createElement(
        'div',
        styling(['arrowSign', 'arrowSignInner']),
        '\u25B6'
      )
    )
  );
};

JSONArrow.propTypes = {
  styling: _propTypes2['default'].func.isRequired,
  arrowStyle: _propTypes2['default'].oneOf(['single', 'double']),
  expanded: _propTypes2['default'].bool.isRequired,
  nodeType: _propTypes2['default'].string.isRequired,
  onClick: _propTypes2['default'].func.isRequired
};

JSONArrow.defaultProps = {
  arrowStyle: 'single'
};

exports['default'] = JSONArrow;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1404);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(532);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBase16Theme = exports.createStyling = exports.invertTheme = undefined;

var _typeof2 = __webpack_require__(195);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(196);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(203);

var _lodash2 = _interopRequireDefault(_lodash);

var _base = __webpack_require__(58);

var base16 = _interopRequireWildcard(_base);

var _rgb2hex = __webpack_require__(204);

var _rgb2hex2 = _interopRequireDefault(_rgb2hex);

var _parse = __webpack_require__(205);

var _parse2 = _interopRequireDefault(_parse);

var _lodash3 = __webpack_require__(210);

var _lodash4 = _interopRequireDefault(_lodash3);

var _colorConverters = __webpack_require__(211);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_BASE16 = base16.default;

var BASE16_KEYS = (0, _keys2.default)(DEFAULT_BASE16);

// we need a correcting factor, so that a dark, but not black background color
// converts to bright enough inversed color
var flip = function flip(x) {
  return x < 0.25 ? 1 : x < 0.5 ? 0.9 - x : 1.1 - x;
};

var invertColor = (0, _lodash4.default)(_parse2.default, _colorConverters.rgb2yuv, function (_ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
      y = _ref2[0],
      u = _ref2[1],
      v = _ref2[2];

  return [flip(y), u, v];
}, _colorConverters.yuv2rgb, _rgb2hex2.default);

var merger = function merger(styling) {
  return function (prevStyling) {
    return {
      className: [prevStyling.className, styling.className].filter(Boolean).join(' '),
      style: (0, _extends3.default)({}, prevStyling.style || {}, styling.style || {})
    };
  };
};

var mergeStyling = function mergeStyling(customStyling, defaultStyling) {
  if (customStyling === undefined) {
    return defaultStyling;
  }
  if (defaultStyling === undefined) {
    return customStyling;
  }

  var customType = typeof customStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(customStyling);
  var defaultType = typeof defaultStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaultStyling);

  switch (customType) {
    case 'string':
      switch (defaultType) {
        case 'string':
          return [defaultStyling, customStyling].filter(Boolean).join(' ');
        case 'object':
          return merger({ className: customStyling, style: defaultStyling });
        case 'function':
          return function (styling) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            return merger({
              className: customStyling
            })(defaultStyling.apply(undefined, [styling].concat(args)));
          };
      }
    case 'object':
      switch (defaultType) {
        case 'string':
          return merger({ className: defaultStyling, style: customStyling });
        case 'object':
          return (0, _extends3.default)({}, defaultStyling, customStyling);
        case 'function':
          return function (styling) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            return merger({
              style: customStyling
            })(defaultStyling.apply(undefined, [styling].concat(args)));
          };
      }
    case 'function':
      switch (defaultType) {
        case 'string':
          return function (styling) {
            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            return customStyling.apply(undefined, [merger(styling)({
              className: defaultStyling
            })].concat(args));
          };
        case 'object':
          return function (styling) {
            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              args[_key4 - 1] = arguments[_key4];
            }

            return customStyling.apply(undefined, [merger(styling)({
              style: defaultStyling
            })].concat(args));
          };
        case 'function':
          return function (styling) {
            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
              args[_key5 - 1] = arguments[_key5];
            }

            return customStyling.apply(undefined, [defaultStyling.apply(undefined, [styling].concat(args))].concat(args));
          };
      }
  }
};

var mergeStylings = function mergeStylings(customStylings, defaultStylings) {
  var keys = (0, _keys2.default)(defaultStylings);
  for (var key in customStylings) {
    if (keys.indexOf(key) === -1) keys.push(key);
  }

  return keys.reduce(function (mergedStyling, key) {
    return mergedStyling[key] = mergeStyling(customStylings[key], defaultStylings[key]), mergedStyling;
  }, {});
};

var getStylingByKeys = function getStylingByKeys(mergedStyling, keys) {
  for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
    args[_key6 - 2] = arguments[_key6];
  }

  if (keys === null) {
    return mergedStyling;
  }

  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  var styles = keys.map(function (key) {
    return mergedStyling[key];
  }).filter(Boolean);

  var props = styles.reduce(function (obj, s) {
    if (typeof s === 'string') {
      obj.className = [obj.className, s].filter(Boolean).join(' ');
    } else if ((typeof s === 'undefined' ? 'undefined' : (0, _typeof3.default)(s)) === 'object') {
      obj.style = (0, _extends3.default)({}, obj.style, s);
    } else if (typeof s === 'function') {
      obj = (0, _extends3.default)({}, obj, s.apply(undefined, [obj].concat(args)));
    }

    return obj;
  }, { className: '', style: {} });

  if (!props.className) {
    delete props.className;
  }

  if ((0, _keys2.default)(props.style).length === 0) {
    delete props.style;
  }

  return props;
};

var invertTheme = exports.invertTheme = function invertTheme(theme) {
  return (0, _keys2.default)(theme).reduce(function (t, key) {
    return t[key] = /^base/.test(key) ? invertColor(theme[key]) : key === 'scheme' ? theme[key] + ':inverted' : theme[key], t;
  }, {});
};

var createStyling = exports.createStyling = (0, _lodash2.default)(function (getStylingFromBase16) {
  for (var _len7 = arguments.length, args = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
    args[_key7 - 3] = arguments[_key7];
  }

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var themeOrStyling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$defaultBase = options.defaultBase16,
      defaultBase16 = _options$defaultBase === undefined ? DEFAULT_BASE16 : _options$defaultBase,
      _options$base16Themes = options.base16Themes,
      base16Themes = _options$base16Themes === undefined ? null : _options$base16Themes;


  var base16Theme = getBase16Theme(themeOrStyling, base16Themes);
  if (base16Theme) {
    themeOrStyling = (0, _extends3.default)({}, base16Theme, themeOrStyling);
  }

  var theme = BASE16_KEYS.reduce(function (t, key) {
    return t[key] = themeOrStyling[key] || defaultBase16[key], t;
  }, {});

  var customStyling = (0, _keys2.default)(themeOrStyling).reduce(function (s, key) {
    return BASE16_KEYS.indexOf(key) === -1 ? (s[key] = themeOrStyling[key], s) : s;
  }, {});

  var defaultStyling = getStylingFromBase16(theme);

  var mergedStyling = mergeStylings(customStyling, defaultStyling);

  return (0, _lodash2.default)(getStylingByKeys, 2).apply(undefined, [mergedStyling].concat(args));
}, 3);

var getBase16Theme = exports.getBase16Theme = function getBase16Theme(theme, base16Themes) {
  if (theme && theme.extend) {
    theme = theme.extend;
  }

  if (typeof theme === 'string') {
    var _theme$split = theme.split(':'),
        _theme$split2 = (0, _slicedToArray3.default)(_theme$split, 2),
        themeName = _theme$split2[0],
        modifier = _theme$split2[1];

    theme = (base16Themes || {})[themeName] || base16[themeName];
    if (modifier === 'inverted') {
      theme = invertTheme(theme);
    }
  }

  return theme && theme.hasOwnProperty('base00') ? theme : undefined;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(40);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

var component = /-?\d+(\.\d+)?%?/g;
function extractComponents(color) {
  return color.match(component);
}

module.exports = extractComponents;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toggleVisibility = toggleVisibility;
exports.changePosition = changePosition;
exports.changeSize = changeSize;
exports.changeMonitor = changeMonitor;
var TOGGLE_VISIBILITY = exports.TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
function toggleVisibility() {
  return { type: TOGGLE_VISIBILITY };
}

var CHANGE_POSITION = exports.CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
function changePosition() {
  return { type: CHANGE_POSITION };
}

var CHANGE_SIZE = exports.CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
function changeSize(size) {
  return { type: CHANGE_SIZE, size: size };
}

var CHANGE_MONITOR = exports.CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
function changeMonitor() {
  return { type: CHANGE_MONITOR };
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMenuItemClick = exports.trackLinkClick = exports.trackButtonClick = exports.trackInteractionEvent = exports.ANALYTICS_TIMING = exports.ANALYTICS_INTERACTION_EVENT = void 0;

var _analytics = __webpack_require__(12);

var ANALYTICS_INTERACTION_EVENT = 'ANALYTICS/INTERACTION_EVENT';
exports.ANALYTICS_INTERACTION_EVENT = ANALYTICS_INTERACTION_EVENT;
var ANALYTICS_TIMING = 'ANALYTICS/TIMING';
/**
 * An action creator to trigger an analytics interaction event
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} [params.action='click'] Action which occurred (e.g. 'click')
 * @param {String} params.areaName area of app that event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this
 *  event (e.g. 'rptKey' or 'rpeKey')
 * @param {Array} params.elementPath Array of strings representing path to the element in which
 *  event occurred
 * @param {String} [params.elementType='button'] Type of element (e.g. 'button' or 'link')
 * @returns {Object} redux action
 */

exports.ANALYTICS_TIMING = ANALYTICS_TIMING;

var trackInteractionEvent = function trackInteractionEvent(_ref) {
  var _ref$action = _ref.action,
      action = _ref$action === void 0 ? _analytics.actionList.click : _ref$action,
      areaName = _ref.areaName,
      elementPath = _ref.elementPath,
      _ref$elementType = _ref.elementType,
      elementType = _ref$elementType === void 0 ? _analytics.elementList.button : _ref$elementType,
      _ref$dimensions = _ref.dimensions,
      dimensions = _ref$dimensions === void 0 ? {} : _ref$dimensions;
  return {
    type: ANALYTICS_INTERACTION_EVENT,
    payload: {
      elementType: elementType,
      action: action,
      areaName: areaName,
      elementPath: elementPath,
      dimensions: dimensions
    }
  };
};
/**
 * Convenience function for triggering button click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element
 *  in which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */


exports.trackInteractionEvent = trackInteractionEvent;

var trackButtonClick = function trackButtonClick(_ref2) {
  var areaName = _ref2.areaName,
      elementPath = _ref2.elementPath,
      _ref2$dimensions = _ref2.dimensions,
      dimensions = _ref2$dimensions === void 0 ? {} : _ref2$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.button,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};
/**
 * Convenience function for triggering link click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element in
 *  which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */


exports.trackButtonClick = trackButtonClick;

var trackLinkClick = function trackLinkClick(_ref3) {
  var areaName = _ref3.areaName,
      elementPath = _ref3.elementPath,
      _ref3$dimensions = _ref3.dimensions,
      dimensions = _ref3$dimensions === void 0 ? {} : _ref3$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.link,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};
/**
 * Convenience function for triggering menu item click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element
 *  in which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */


exports.trackLinkClick = trackLinkClick;

var trackMenuItemClick = function trackMenuItemClick(_ref4) {
  var areaName = _ref4.areaName,
      elementPath = _ref4.elementPath,
      _ref4$dimensions = _ref4.dimensions,
      dimensions = _ref4$dimensions === void 0 ? {} : _ref4$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.menuItem,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};

exports.trackMenuItemClick = trackMenuItemClick;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultContext = {
  userProfile: {},
  isPublic: true,
  getTitle: function getTitle(newTitle) {
    return newTitle;
  }
};

var AppContext = _react.default.createContext(defaultContext);

exports.AppContext = AppContext;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonSections = exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _lodash = _interopRequireDefault(__webpack_require__(246));

var _nuiIntl = __webpack_require__(3);

var _reactRedux = __webpack_require__(5);

var _AppCategory = _interopRequireDefault(__webpack_require__(247));

var _LoadingIndicator = _interopRequireDefault(__webpack_require__(76));

var ListingsActions = _interopRequireWildcard(__webpack_require__(10));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// let SEED = Date.now();
// function random() {
//   const x = Math.sin(SEED++) * 10000;
//   return x - Math.floor(x);
// }
var CommonSections =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CommonSections, _React$Component);

  function CommonSections() {
    _classCallCheck(this, CommonSections);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommonSections).apply(this, arguments));
  }

  _createClass(CommonSections, [{
    key: "renderNoResults",
    value: function renderNoResults() {
      return _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "NoSearchResults"
      })));
    }
  }, {
    key: "buildCollectionSet",
    value: function buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps) {
      var listings = this.props.listings;
      var MIN_APP_NUM = 20;
      var MIN_NUM_LISTINGS = allListingsSection.length >= MIN_APP_NUM;

      var chooseEnterpriseTitle = function chooseEnterpriseTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "EnterpriseAppsCollection"
          });
        }

        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "CategoryForEnterprise",
          values: {
            category: categoryDescription
          }
        });
      };

      var choosePopularForCategoryTitle = function choosePopularForCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "PopularConnectionsCollection"
          });
        }

        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "PopularForCategoryCollection",
          values: {
            category: categoryDescription
          }
        });
      };

      var chooseAllCategoryTitle = function chooseAllCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return MIN_NUM_LISTINGS ? _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "AllAppsCollection"
          }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "Connections"
          });
        }

        return MIN_NUM_LISTINGS ? _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "AllForCategoryCollection",
          values: {
            category: categoryDescription
          }
        }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ConnectionsForCategory",
          values: {
            category: categoryDescription
          }
        });
      };

      if (!popularListings.length && !popularForEnterprise.length && !allListingsSection.length) {
        return this.renderNoResults();
      }

      var categoryDescription = listings.category ? listings.category.description : ''; // we don't want two collections showing the same listings

      if ((!popularListings.length || !popularForEnterprise.length) && popularListings.length < 10 && popularForEnterprise.length < 10) {
        return _react.default.createElement("div", {
          className: "row"
        }, _react.default.createElement("div", {
          className: "col-xs-12",
          id: "all-listings"
        }, _react.default.createElement(_AppCategory.default, {
          categoryTitle: chooseAllCategoryTitle(categoryDescription),
          categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "AllAppsCollectionSubtitle"
          }),
          listings: partitionedAllApps,
          isLoggedIn: this.props.userPrefs.isLoggedIn,
          windowWidth: window.innerWidth
        })));
      }

      return _react.default.createElement("div", null, MIN_NUM_LISTINGS && _react.default.createElement("div", {
        id: "popular-section",
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: choosePopularForCategoryTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "PopularConnsCollectionSubtitle"
        }),
        listings: popularListings,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-for-enterprise"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: chooseEnterpriseTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "EnterpriseAppsCollectionSubtitle"
        }),
        listings: popularForEnterprise,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))), _react.default.createElement("div", {
        id: "connections-section",
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "all-listings"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: chooseAllCategoryTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "AllAppsCollectionSubtitle"
        }),
        listings: MIN_NUM_LISTINGS ? allListingsSection : nonshuffledAllListingsSection,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$listings = this.props.listings,
          listingsReadyState = _this$props$listings.listingsReadyState,
          filtered = _this$props$listings.filtered;
      var isLoaded = listingsReadyState === ListingsActions.LISTINGS_FETCHED;

      if (listingsReadyState === ListingsActions.LISTINGS_FETCH_FAILED) {
        return _react.default.createElement("p", null, "Failed to fetch Listings");
      }

      function prioritySort(a, b) {
        if (a.core.priority < b.core.priority) return -1;
        if (a.core.priority > b.core.priority) return 1;
        return 0;
      }

      var partitionedListings = _lodash.default.partition(filtered.concat([]).sort(prioritySort), function (listing) {
        return !listing.core.listingDisabled;
      });

      var partitionedAllApps = _lodash.default.flatten(partitionedListings);

      var popularListings = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).take(10).value();

      var popularForEnterprise = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'ADMIN';
      }).sort(prioritySort).value();

      var shuffledPartionedAllApps = _lodash.default.shuffle(partitionedListings[0]).concat(_lodash.default.shuffle(partitionedListings[1]));

      var nonshuffledAllListingsSection = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      var allListingsSection = _lodash.default.chain(shuffledPartionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      return _react.default.createElement("div", {
        style: {
          minHeight: '1151px'
        }
      }, _react.default.createElement(_LoadingIndicator.default, {
        isLoaded: isLoaded,
        beta: this.props.profile && this.props.profile.betas['concur-ui-spinner']
      }, this.buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps)));
    }
  }]);

  return CommonSections;
}(_react.default.Component);

exports.CommonSections = CommonSections;
CommonSections.propTypes = {
  listings: _propTypes.default.object,
  user: _propTypes.default.object,
  userPrefs: _propTypes.default.shape({
    isLoggedIn: _propTypes.default.bool
  })
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    user: state.user,
    userPrefs: state.userPrefs,
    profile: state.userProfile.profile
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(CommonSections);

exports.default = _default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _nuiWidgets = __webpack_require__(28);

var _reactLoader = _interopRequireDefault(__webpack_require__(77));

var _nuiIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var spinnerOpts = {
  lines: 8,
  length: 1,
  width: 14,
  radius: 32,
  scale: 1,
  corners: 3,
  color: '#2379BF',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '300px',
  left: '50%',
  shadow: false,
  hwaccel: false,
  height: '300px'
};

var LoadingIndicator = function LoadingIndicator(_ref) {
  var isLoaded = _ref.isLoaded,
      children = _ref.children,
      beta = _ref.beta,
      props = _objectWithoutProperties(_ref, ["isLoaded", "children", "beta"]);

  if (beta) {
    var formatter = props.formatter;
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_nuiWidgets.Spinner, {
      visible: !isLoaded,
      size: "lg",
      id: "spinner",
      type: "block",
      message: formatter.formattedMessage('Loading')
    }), isLoaded && children);
  } else {
    return _react.default.createElement(_reactLoader.default, {
      loaded: isLoaded,
      options: spinnerOpts
    }, children);
  }
};

LoadingIndicator.propTypes = {
  isLoaded: _propTypes.default.bool.isRequired,
  children: _propTypes.default.any
};

var _default = (0, _nuiIntl.withFormatter)(LoadingIndicator);

exports.default = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1293);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(279);

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(82);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(46);

__webpack_require__(47);

var _history = __webpack_require__(86);

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(87));

var _Root = _interopRequireDefault(__webpack_require__(88));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (false) {
  module.hot.accept();
}

var history = (0, _history.createBrowserHistory)();

_reactDom.default.render(_react.default.createElement(_Root.default, {
  history: history
}), document.getElementById('root'));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(898);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1258);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(89);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1266);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(23);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiShell = __webpack_require__(17);

__webpack_require__(46);

__webpack_require__(47);

var _react = _interopRequireDefault(__webpack_require__(1));

var _configureStore = _interopRequireDefault(__webpack_require__(89));

var _routes = _interopRequireDefault(__webpack_require__(232));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global __DEVTOOLS__, window */
var store = (0, _configureStore.default)(window.__INITIAL_STATE__); // eslint-disable-line no-underscore-dangle

var DevTools = function DevTools() {
  return null;
};

if (false) {
  DevTools = require('./DevTools').default;
}

var Root = function Root() {
  return _react.default.createElement(_nuiShell.NuiClient, {
    store: store,
    routes: _routes.default
  }, "boolean" !== 'undefined' && false && _react.default.createElement(DevTools, null));
};

var _default = Root;
exports.default = _default;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(49);

var _reduxThunk = _interopRequireDefault(__webpack_require__(90));

var _reduxPromise = _interopRequireDefault(__webpack_require__(91));

var _nuiShell = __webpack_require__(17);

var _rootReducer = _interopRequireDefault(__webpack_require__(92));

var _utils = __webpack_require__(4);

var _DevTools = _interopRequireDefault(__webpack_require__(112));

var _analytics = _interopRequireDefault(__webpack_require__(230));

var _listingModule = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDebugSessionKey() {
  // By default we try to read the key from ?debug_session=<key> in the address bar
  var matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
  return matches && matches.length > 0 ? matches[1] : null;
}

var store = null;

function configureStore(initialState) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var utilityFns = arguments.length > 2 ? arguments[2] : undefined;

  if (!initialState.userPrefs.userId) {
    initialState.userPrefs = _objectSpread({}, initialState.userPrefs, {
      userId: ''
    });
  }

  var createStoreWithMiddleware;

  var customReduxMiddleware = _nuiShell.nuiReduxMiddlewares.customize({
    analytics: function analytics(mw) {
      return mw.withOptions({
        mapStateToAnalytics: _analytics.default
      });
    }
  });

  if (false) {
    var createLogger = require('redux-logger');

    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
      createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, createLogger({
        level: 'info',
        collapsed: true
      })])), persistState(getDebugSessionKey()))(_redux.createStore);
    } else {
      createStoreWithMiddleware = (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, createLogger({
        level: 'info',
        collapsed: true
      })])), _DevTools.default.instrument(), persistState(getDebugSessionKey()))(_redux.createStore);
    }
  } else if (process.env.QA_REDUX_LOGGING) {
    var _createLogger = __webpack_require__(231);

    createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, _createLogger({
      level: 'info',
      collapsed: true
    })]))(_redux.createStore);
  } else {
    createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default]))(_redux.createStore);
  }

  if (!_utils.isClient) {
    // this only works with webpack because of the Ignore plugin in config
    var ConcurProtect = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"@concur/concur-protect\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); // TripIt expects to decode using `_protectKey` from session
    // ConcurProtect knowns to grab this field and use it if present


    var otProtectCSRF = new ConcurProtect(req.session);
    var encryptUserId = utilityFns.encryptUserId;

    if (req.session && req.session.UserID) {
      initialState.userPrefs = _objectSpread({}, initialState.userPrefs, {
        userId: encryptUserId(req.session.UserID),
        csrf_token: otProtectCSRF.protectValue('csrf_token', req.session.SessionId)
      });
    }

    var originalhost = req.headers['original-host'] || '';
    initialState.meta = _objectSpread({}, initialState.meta, {
      originalhost: originalhost,
      listingNotFound: req.listingNotFound
    });
    initialState.baseUrl = (0, _utils.getNuiBaseUrlFromHost)(originalhost);
  }

  if (req.data) {
    initialState.listing = _objectSpread({}, _listingModule.initialState, _defineProperty({}, req.listingId, {
      readyState: _listingModule.LISTING_FETCHED,
      data: req.data
    }));
  }

  if (req.location) {
    initialState.listing = _objectSpread({}, initialState.listing, {
      localizedRegions: req.location.localizedRegions,
      localizedCountries: req.location.localizedCountries
    });
  }

  if (req.userProfile) {
    initialState.userProfile = req.userProfile;
  }

  store = createStoreWithMiddleware(_rootReducer.default, initialState);
  return store;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(520);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1376);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = __webpack_require__(49);

var _nuiShell = __webpack_require__(17);

var _listingsModule = _interopRequireDefault(__webpack_require__(10));

var _listingModule = _interopRequireDefault(__webpack_require__(6));

var _termsModule = _interopRequireDefault(__webpack_require__(14));

var _userProfileModule = _interopRequireDefault(__webpack_require__(24));

var _utilsModule = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _redux.combineReducers)(_objectSpread({
  listings: _listingsModule.default,
  listing: _listingModule.default,
  terms: _termsModule.default,
  userProfile: _userProfileModule.default,
  meta: _utilsModule.default
}, _nuiShell.reducers));

exports.default = _default;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(123);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(29),
    baseUniq = __webpack_require__(30);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(386);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(97),
    noop = __webpack_require__(98),
    setToArray = __webpack_require__(50);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1634);

/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(100),
    baseIteratee = __webpack_require__(29),
    baseSome = __webpack_require__(101),
    isArray = __webpack_require__(52),
    isIterateeCall = __webpack_require__(102);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1627);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(51);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1619);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(35),
    baseIntersection = __webpack_require__(104),
    baseRest = __webpack_require__(36),
    castArrayLikeObject = __webpack_require__(105);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(31),
    arrayIncludes = __webpack_require__(32),
    arrayIncludesWith = __webpack_require__(33),
    arrayMap = __webpack_require__(35),
    baseUnary = __webpack_require__(53),
    cacheHas = __webpack_require__(34);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(37);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(190);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(108),
    baseEach = __webpack_require__(51),
    baseIteratee = __webpack_require__(29),
    baseReduce = __webpack_require__(109),
    isArray = __webpack_require__(52);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(680);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(210);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _reduxDevtools = __webpack_require__(39);

var _reduxDevtoolsLogMonitor = _interopRequireDefault(__webpack_require__(122));

var _reduxDevtoolsDockMonitor = _interopRequireDefault(__webpack_require__(215));

var _reduxDevtoolsDispatch = _interopRequireDefault(__webpack_require__(225));

var _reduxDevtoolsMultipleMonitors = _interopRequireDefault(__webpack_require__(228));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionCreators = {};

var _default = (0, _reduxDevtools.createDevTools)(_react.default.createElement(_reduxDevtoolsDockMonitor.default, {
  toggleVisibilityKey: "ctrl-h",
  defaultIsVisible: false,
  changePositionKey: "ctrl-q"
}, _react.default.createElement(_reduxDevtoolsMultipleMonitors.default, null, _react.default.createElement(_reduxDevtoolsLogMonitor.default, {
  theme: "tomorrow"
}), _react.default.createElement(_reduxDevtoolsDispatch.default, {
  actionCreators: actionCreators
}))));

exports.default = _default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(114),
    baseFlatten = __webpack_require__(56),
    baseRest = __webpack_require__(36),
    isArrayLikeObject = __webpack_require__(37);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(31),
    arrayIncludes = __webpack_require__(32),
    arrayIncludesWith = __webpack_require__(33),
    arrayMap = __webpack_require__(35),
    baseUnary = __webpack_require__(53),
    cacheHas = __webpack_require__(34);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(56),
    baseRest = __webpack_require__(36),
    baseUniq = __webpack_require__(30),
    isArrayLikeObject = __webpack_require__(37);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(380);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1319);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = persistState;

var _mapValues = __webpack_require__(119);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _identity = __webpack_require__(120);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function persistState(sessionId) {
  var deserializeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
  var deserializeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;

  if (!sessionId) {
    return function (next) {
      return function () {
        return next.apply(undefined, arguments);
      };
    };
  }

  function deserialize(state) {
    return _extends({}, state, {
      actionsById: (0, _mapValues2.default)(state.actionsById, function (liftedAction) {
        return _extends({}, liftedAction, {
          action: deserializeAction(liftedAction.action)
        });
      }),
      committedState: deserializeState(state.committedState),
      computedStates: state.computedStates.map(function (computedState) {
        return _extends({}, computedState, {
          state: deserializeState(computedState.state)
        });
      })
    });
  }

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var key = 'redux-dev-session-' + sessionId;

      var finalInitialState = void 0;
      try {
        var json = localStorage.getItem(key);
        if (json) {
          finalInitialState = deserialize(JSON.parse(json)) || initialState;
          next(reducer, initialState);
        }
      } catch (e) {
        console.warn('Could not read debug session from localStorage:', e);
        try {
          localStorage.removeItem(key);
        } finally {
          finalInitialState = undefined;
        }
      }

      var store = next(reducer, finalInitialState, enhancer);

      return _extends({}, store, {
        dispatch: function dispatch(action) {
          store.dispatch(action);

          try {
            localStorage.setItem(key, JSON.stringify(store.getState()));
          } catch (e) {
            console.warn('Could not write debug session to localStorage:', e);
          }

          return action;
        }
      });
    };
  };
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(657);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(382);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createDevTools;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(5);

var _reduxDevtoolsInstrument = __webpack_require__(55);

var _reduxDevtoolsInstrument2 = _interopRequireDefault(_reduxDevtoolsInstrument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function logError(type) {
  if (type === 'NoStore') {
    console.error('Redux DevTools could not render. You must pass the Redux store ' + 'to <DevTools> either as a "store" prop or by wrapping it in a ' + '<Provider store={store}>.');
  } else {
    console.error('Redux DevTools could not render. Did you forget to include ' + 'DevTools.instrument() in your store enhancer chain before ' + 'using createStore()?');
  }
}

function createDevTools(children) {
  var _class, _temp;

  var monitorElement = _react.Children.only(children);
  var monitorProps = monitorElement.props;
  var Monitor = monitorElement.type;
  var ConnectedMonitor = (0, _reactRedux.connect)(function (state) {
    return state;
  })(Monitor);

  return _temp = _class = function (_Component) {
    _inherits(DevTools, _Component);

    function DevTools(props, context) {
      _classCallCheck(this, DevTools);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      if (_reactRedux.ReactReduxContext) {
        if (_this.props.store && !_this.props.store.liftedStore) {
          logError('NoLiftedStore');
        }
        return _possibleConstructorReturn(_this);
      }

      if (!props.store && !context.store) {
        logError('NoStore');
        return _possibleConstructorReturn(_this);
      }

      if (context.store) {
        _this.liftedStore = context.store.liftedStore;
      } else {
        _this.liftedStore = props.store.liftedStore;
      }

      if (!_this.liftedStore) {
        logError('NoLiftedStore');
      }
      return _this;
    }

    DevTools.prototype.render = function render() {
      if (_reactRedux.ReactReduxContext) {
        // For react-redux@6
        if (this.props.store) {
          if (!this.props.store.liftedStore) {
            return null;
          }
          return _react2.default.createElement(
            _reactRedux.Provider,
            { store: this.props.store.liftedStore },
            _react2.default.createElement(ConnectedMonitor, monitorProps)
          );
        }
        return _react2.default.createElement(
          _reactRedux.ReactReduxContext.Consumer,
          null,
          function (props) {
            if (!props || !props.store) {
              logError('NoStore');
              return null;
            }
            if (!props.store.liftedStore) {
              logError('NoLiftedStore');
              return null;
            }
            return _react2.default.createElement(
              _reactRedux.Provider,
              { store: props.store.liftedStore },
              _react2.default.createElement(ConnectedMonitor, monitorProps)
            );
          }
        );
      }

      if (!this.liftedStore) {
        return null;
      }

      return _react2.default.createElement(ConnectedMonitor, _extends({}, monitorProps, { store: this.liftedStore }));
    };

    return DevTools;
  }(_react.Component), _class.contextTypes = {
    store: _propTypes2.default.object
  }, _class.propTypes = {
    store: _propTypes2.default.object
  }, _class.instrument = function (options) {
    return (0, _reduxDevtoolsInstrument2.default)(function (state, action) {
      return Monitor.update(monitorProps, state, action);
    }, options);
  }, _temp;
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _LogMonitor = __webpack_require__(123);

var _LogMonitor2 = _interopRequireDefault(_LogMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LogMonitor2.default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _function = __webpack_require__(18);

var _function2 = _interopRequireDefault(_function);

var _reduxDevtoolsThemes = __webpack_require__(57);

var themes = _interopRequireWildcard(_reduxDevtoolsThemes);

var _reduxDevtools = __webpack_require__(39);

var _actions = __webpack_require__(59);

var _reducers = __webpack_require__(163);

var _reducers2 = _interopRequireDefault(_reducers);

var _LogMonitorButtonBar = __webpack_require__(164);

var _LogMonitorButtonBar2 = _interopRequireDefault(_LogMonitorButtonBar);

var _LogMonitorEntryList = __webpack_require__(167);

var _LogMonitorEntryList2 = _interopRequireDefault(_LogMonitorEntryList);

var _lodash = __webpack_require__(214);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toggleAction = _reduxDevtools.ActionCreators.toggleAction;
var setActionsActive = _reduxDevtools.ActionCreators.setActionsActive;


var styles = {
  container: {
    fontFamily: 'monaco, Consolas, Lucida Console, monospace',
    position: 'relative',
    overflowY: 'hidden',
    width: '100%',
    height: '100%',
    minWidth: 300,
    direction: 'ltr'
  },
  elements: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflowX: 'hidden',
    overflowY: 'auto'
  }
};

var LogMonitor = function (_Component) {
  _inherits(LogMonitor, _Component);

  function LogMonitor(props) {
    _classCallCheck(this, LogMonitor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;
    _this.updateScrollTop = (0, _lodash2.default)(function () {
      var node = _this.node;
      _this.props.dispatch((0, _actions.updateScrollTop)(node ? node.scrollTop : 0));
    }, 500);

    _this.handleToggleAction = _this.handleToggleAction.bind(_this);
    _this.handleToggleConsecutiveAction = _this.handleToggleConsecutiveAction.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    return _this;
  }

  LogMonitor.prototype.scroll = function scroll() {
    var node = this.node;
    if (!node) {
      return;
    }
    if (this.scrollDown) {
      var offsetHeight = node.offsetHeight;
      var scrollHeight = node.scrollHeight;

      node.scrollTop = scrollHeight - offsetHeight;
      this.scrollDown = false;
    }
  };

  LogMonitor.prototype.componentDidMount = function componentDidMount() {
    var node = this.node;
    if (!node || !this.props.monitorState) {
      return;
    }

    if (this.props.preserveScrollTop) {
      node.scrollTop = this.props.monitorState.initialScrollTop;
      node.addEventListener('scroll', this.updateScrollTop);
    } else {
      this.scrollDown = true;
      this.scroll();
    }
  };

  LogMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
    var node = this.node;
    if (node && this.props.preserveScrollTop) {
      node.removeEventListener('scroll', this.updateScrollTop);
    }
  };

  LogMonitor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var node = this.node;
    if (!node) {
      this.scrollDown = true;
    } else if (this.props.stagedActionIds.length < nextProps.stagedActionIds.length) {
      var scrollTop = node.scrollTop;
      var offsetHeight = node.offsetHeight;
      var scrollHeight = node.scrollHeight;


      this.scrollDown = Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
    } else {
      this.scrollDown = false;
    }
  };

  LogMonitor.prototype.componentDidUpdate = function componentDidUpdate() {
    this.scroll();
  };

  LogMonitor.prototype.handleToggleAction = function handleToggleAction(id) {
    this.props.dispatch(toggleAction(id));
  };

  LogMonitor.prototype.handleToggleConsecutiveAction = function handleToggleConsecutiveAction(id) {
    var _props = this.props;
    var monitorState = _props.monitorState;
    var actionsById = _props.actionsById;
    var consecutiveToggleStartId = monitorState.consecutiveToggleStartId;

    if (consecutiveToggleStartId && actionsById[consecutiveToggleStartId]) {
      var skippedActionIds = this.props.skippedActionIds;

      var start = Math.min(consecutiveToggleStartId, id);
      var end = Math.max(consecutiveToggleStartId, id);
      var active = skippedActionIds.indexOf(consecutiveToggleStartId) > -1;
      this.props.dispatch(setActionsActive(start, end + 1, active));
      this.props.dispatch((0, _actions.startConsecutiveToggle)(null));
    } else if (id > 0) {
      this.props.dispatch((0, _actions.startConsecutiveToggle)(id));
    }
  };

  LogMonitor.prototype.getTheme = function getTheme() {
    var theme = this.props.theme;

    if (typeof theme !== 'string') {
      return theme;
    }

    if (typeof themes[theme] !== 'undefined') {
      return themes[theme];
    }

    console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
    return themes.nicinabox;
  };

  LogMonitor.prototype.getRef = function getRef(node) {
    this.node = node;
  };

  LogMonitor.prototype.render = function render() {
    var theme = this.getTheme();
    var consecutiveToggleStartId = this.props.monitorState.consecutiveToggleStartId;
    var _props2 = this.props;
    var dispatch = _props2.dispatch;
    var actionsById = _props2.actionsById;
    var skippedActionIds = _props2.skippedActionIds;
    var stagedActionIds = _props2.stagedActionIds;
    var computedStates = _props2.computedStates;
    var currentStateIndex = _props2.currentStateIndex;
    var select = _props2.select;
    var expandActionRoot = _props2.expandActionRoot;
    var expandStateRoot = _props2.expandStateRoot;
    var markStateDiff = _props2.markStateDiff;


    var entryListProps = {
      theme: theme,
      actionsById: actionsById,
      skippedActionIds: skippedActionIds,
      stagedActionIds: stagedActionIds,
      computedStates: computedStates,
      currentStateIndex: currentStateIndex,
      consecutiveToggleStartId: consecutiveToggleStartId,
      select: select,
      expandActionRoot: expandActionRoot,
      expandStateRoot: expandStateRoot,
      markStateDiff: markStateDiff,
      onActionClick: this.handleToggleAction,
      onActionShiftClick: this.handleToggleConsecutiveAction
    };

    return _react2.default.createElement(
      'div',
      { style: _extends({}, styles.container, { backgroundColor: theme.base00 }) },
      !this.props.hideMainButtons && _react2.default.createElement(_LogMonitorButtonBar2.default, {
        theme: theme,
        dispatch: dispatch,
        hasStates: computedStates.length > 1,
        hasSkippedActions: skippedActionIds.length > 0
      }),
      _react2.default.createElement(
        'div',
        {
          style: this.props.hideMainButtons ? styles.elements : _extends({}, styles.elements, { top: 30 }),
          ref: this.getRef
        },
        _react2.default.createElement(_LogMonitorEntryList2.default, entryListProps)
      )
    );
  };

  return LogMonitor;
}(_react.Component);

LogMonitor.update = _reducers2.default;
LogMonitor.propTypes = {
  dispatch: _propTypes2.default.func,
  computedStates: _propTypes2.default.array,
  actionsById: _propTypes2.default.object,
  stagedActionIds: _propTypes2.default.array,
  skippedActionIds: _propTypes2.default.array,
  monitorState: _propTypes2.default.shape({
    initialScrollTop: _propTypes2.default.number,
    consecutiveToggleStartId: _propTypes2.default.number
  }),

  preserveScrollTop: _propTypes2.default.bool,
  select: _propTypes2.default.func,
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool,
  markStateDiff: _propTypes2.default.bool,
  hideMainButtons: _propTypes2.default.bool
};
LogMonitor.defaultProps = {
  select: function select(state) {
    return state;
  },
  theme: 'nicinabox',
  preserveScrollTop: true,
  expandActionRoot: true,
  expandStateRoot: true,
  markStateDiff: false
};
exports.default = LogMonitor;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = shallowEqual;

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'threezerotwofour',
  author: 'jan t. sott (http://github.com/idleberg)',
  base00: '#090300',
  base01: '#3a3432',
  base02: '#4a4543',
  base03: '#5c5855',
  base04: '#807d7c',
  base05: '#a5a2a2',
  base06: '#d6d5d4',
  base07: '#f7f7f7',
  base08: '#db2d20',
  base09: '#e8bbd0',
  base0A: '#fded02',
  base0B: '#01a252',
  base0C: '#b5e4f4',
  base0D: '#01a0e4',
  base0E: '#a16a94',
  base0F: '#cdab53'
};
module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'apathy',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#031A16',
  base01: '#0B342D',
  base02: '#184E45',
  base03: '#2B685E',
  base04: '#5F9C92',
  base05: '#81B5AC',
  base06: '#A7CEC8',
  base07: '#D2E7E4',
  base08: '#3E9688',
  base09: '#3E7996',
  base0A: '#3E4C96',
  base0B: '#883E96',
  base0C: '#963E4C',
  base0D: '#96883E',
  base0E: '#4C963E',
  base0F: '#3E965B'
};
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'ashes',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#1C2023',
  base01: '#393F45',
  base02: '#565E65',
  base03: '#747C84',
  base04: '#ADB3BA',
  base05: '#C7CCD1',
  base06: '#DFE2E5',
  base07: '#F3F4F5',
  base08: '#C7AE95',
  base09: '#C7C795',
  base0A: '#AEC795',
  base0B: '#95C7AE',
  base0C: '#95AEC7',
  base0D: '#AE95C7',
  base0E: '#C795AE',
  base0F: '#C79595'
};
module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier dune',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)',
  base00: '#20201d',
  base01: '#292824',
  base02: '#6e6b5e',
  base03: '#7d7a68',
  base04: '#999580',
  base05: '#a6a28c',
  base06: '#e8e4cf',
  base07: '#fefbec',
  base08: '#d73737',
  base09: '#b65611',
  base0A: '#cfb017',
  base0B: '#60ac39',
  base0C: '#1fad83',
  base0D: '#6684e1',
  base0E: '#b854d4',
  base0F: '#d43552'
};
module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier forest',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)',
  base00: '#1b1918',
  base01: '#2c2421',
  base02: '#68615e',
  base03: '#766e6b',
  base04: '#9c9491',
  base05: '#a8a19f',
  base06: '#e6e2e0',
  base07: '#f1efee',
  base08: '#f22c40',
  base09: '#df5320',
  base0A: '#d5911a',
  base0B: '#5ab738',
  base0C: '#00ad9c',
  base0D: '#407ee7',
  base0E: '#6666ea',
  base0F: '#c33ff3'
};
module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier heath',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)',
  base00: '#1b181b',
  base01: '#292329',
  base02: '#695d69',
  base03: '#776977',
  base04: '#9e8f9e',
  base05: '#ab9bab',
  base06: '#d8cad8',
  base07: '#f7f3f7',
  base08: '#ca402b',
  base09: '#a65926',
  base0A: '#bb8a35',
  base0B: '#379a37',
  base0C: '#159393',
  base0D: '#516aec',
  base0E: '#7b59c0',
  base0F: '#cc33cc'
};
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier lakeside',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)',
  base00: '#161b1d',
  base01: '#1f292e',
  base02: '#516d7b',
  base03: '#5a7b8c',
  base04: '#7195a8',
  base05: '#7ea2b4',
  base06: '#c1e4f6',
  base07: '#ebf8ff',
  base08: '#d22d72',
  base09: '#935c25',
  base0A: '#8a8a0f',
  base0B: '#568c3b',
  base0C: '#2d8f6f',
  base0D: '#257fad',
  base0E: '#5d5db1',
  base0F: '#b72dd2'
};
module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier seaside',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)',
  base00: '#131513',
  base01: '#242924',
  base02: '#5e6e5e',
  base03: '#687d68',
  base04: '#809980',
  base05: '#8ca68c',
  base06: '#cfe8cf',
  base07: '#f0fff0',
  base08: '#e6193c',
  base09: '#87711d',
  base0A: '#c3c322',
  base0B: '#29a329',
  base0C: '#1999b3',
  base0D: '#3d62f5',
  base0E: '#ad2bee',
  base0F: '#e619c3'
};
module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'bespin',
  author: 'jan t. sott',
  base00: '#28211c',
  base01: '#36312e',
  base02: '#5e5d5c',
  base03: '#666666',
  base04: '#797977',
  base05: '#8a8986',
  base06: '#9d9b97',
  base07: '#baae9e',
  base08: '#cf6a4c',
  base09: '#cf7d34',
  base0A: '#f9ee98',
  base0B: '#54be0d',
  base0C: '#afc4db',
  base0D: '#5ea6ea',
  base0E: '#9b859d',
  base0F: '#937121'
};
module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'brewer',
  author: 'timothée poisot (http://github.com/tpoisot)',
  base00: '#0c0d0e',
  base01: '#2e2f30',
  base02: '#515253',
  base03: '#737475',
  base04: '#959697',
  base05: '#b7b8b9',
  base06: '#dadbdc',
  base07: '#fcfdfe',
  base08: '#e31a1c',
  base09: '#e6550d',
  base0A: '#dca060',
  base0B: '#31a354',
  base0C: '#80b1d3',
  base0D: '#3182bd',
  base0E: '#756bb1',
  base0F: '#b15928'
};
module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'bright',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#000000',
  base01: '#303030',
  base02: '#505050',
  base03: '#b0b0b0',
  base04: '#d0d0d0',
  base05: '#e0e0e0',
  base06: '#f5f5f5',
  base07: '#ffffff',
  base08: '#fb0120',
  base09: '#fc6d24',
  base0A: '#fda331',
  base0B: '#a1c659',
  base0C: '#76c7b7',
  base0D: '#6fb3d2',
  base0E: '#d381c3',
  base0F: '#be643c'
};
module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'chalk',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#151515',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#b0b0b0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#f5f5f5',
  base08: '#fb9fb1',
  base09: '#eda987',
  base0A: '#ddb26f',
  base0B: '#acc267',
  base0C: '#12cfc0',
  base0D: '#6fc2ef',
  base0E: '#e1a3ee',
  base0F: '#deaf8f'
};
module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'codeschool',
  author: 'brettof86',
  base00: '#232c31',
  base01: '#1c3657',
  base02: '#2a343a',
  base03: '#3f4944',
  base04: '#84898c',
  base05: '#9ea7a6',
  base06: '#a7cfa3',
  base07: '#b5d8f6',
  base08: '#2a5491',
  base09: '#43820d',
  base0A: '#a03b1e',
  base0B: '#237986',
  base0C: '#b02f30',
  base0D: '#484d79',
  base0E: '#c59820',
  base0F: '#c98344'
};
module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'colors',
  author: 'mrmrs (http://clrs.cc)',
  base00: '#111111',
  base01: '#333333',
  base02: '#555555',
  base03: '#777777',
  base04: '#999999',
  base05: '#bbbbbb',
  base06: '#dddddd',
  base07: '#ffffff',
  base08: '#ff4136',
  base09: '#ff851b',
  base0A: '#ffdc00',
  base0B: '#2ecc40',
  base0C: '#7fdbff',
  base0D: '#0074d9',
  base0E: '#b10dc9',
  base0F: '#85144b'
};
module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'default',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#181818',
  base01: '#282828',
  base02: '#383838',
  base03: '#585858',
  base04: '#b8b8b8',
  base05: '#d8d8d8',
  base06: '#e8e8e8',
  base07: '#f8f8f8',
  base08: '#ab4642',
  base09: '#dc9656',
  base0A: '#f7ca88',
  base0B: '#a1b56c',
  base0C: '#86c1b9',
  base0D: '#7cafc2',
  base0E: '#ba8baf',
  base0F: '#a16946'
};
module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'eighties',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2d2d2d',
  base01: '#393939',
  base02: '#515151',
  base03: '#747369',
  base04: '#a09f93',
  base05: '#d3d0c8',
  base06: '#e8e6df',
  base07: '#f2f0ec',
  base08: '#f2777a',
  base09: '#f99157',
  base0A: '#ffcc66',
  base0B: '#99cc99',
  base0C: '#66cccc',
  base0D: '#6699cc',
  base0E: '#cc99cc',
  base0F: '#d27b53'
};
module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'embers',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#16130F',
  base01: '#2C2620',
  base02: '#433B32',
  base03: '#5A5047',
  base04: '#8A8075',
  base05: '#A39A90',
  base06: '#BEB6AE',
  base07: '#DBD6D1',
  base08: '#826D57',
  base09: '#828257',
  base0A: '#6D8257',
  base0B: '#57826D',
  base0C: '#576D82',
  base0D: '#6D5782',
  base0E: '#82576D',
  base0F: '#825757'
};
module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'flat',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2C3E50',
  base01: '#34495E',
  base02: '#7F8C8D',
  base03: '#95A5A6',
  base04: '#BDC3C7',
  base05: '#e0e0e0',
  base06: '#f5f5f5',
  base07: '#ECF0F1',
  base08: '#E74C3C',
  base09: '#E67E22',
  base0A: '#F1C40F',
  base0B: '#2ECC71',
  base0C: '#1ABC9C',
  base0D: '#3498DB',
  base0E: '#9B59B6',
  base0F: '#be643c'
};
module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED'
};
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'grayscale',
  author: 'alexandre gavioli (https://github.com/alexx2/)',
  base00: '#101010',
  base01: '#252525',
  base02: '#464646',
  base03: '#525252',
  base04: '#ababab',
  base05: '#b9b9b9',
  base06: '#e3e3e3',
  base07: '#f7f7f7',
  base08: '#7c7c7c',
  base09: '#999999',
  base0A: '#a0a0a0',
  base0B: '#8e8e8e',
  base0C: '#868686',
  base0D: '#686868',
  base0E: '#747474',
  base0F: '#5e5e5e'
};
module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'green screen',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#001100',
  base01: '#003300',
  base02: '#005500',
  base03: '#007700',
  base04: '#009900',
  base05: '#00bb00',
  base06: '#00dd00',
  base07: '#00ff00',
  base08: '#007700',
  base09: '#009900',
  base0A: '#007700',
  base0B: '#00bb00',
  base0C: '#005500',
  base0D: '#009900',
  base0E: '#00bb00',
  base0F: '#005500'
};
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'harmonic16',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#0b1c2c',
  base01: '#223b54',
  base02: '#405c79',
  base03: '#627e99',
  base04: '#aabcce',
  base05: '#cbd6e2',
  base06: '#e5ebf1',
  base07: '#f7f9fb',
  base08: '#bf8b56',
  base09: '#bfbf56',
  base0A: '#8bbf56',
  base0B: '#56bf8b',
  base0C: '#568bbf',
  base0D: '#8b56bf',
  base0E: '#bf568b',
  base0F: '#bf5656'
};
module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'hopscotch',
  author: 'jan t. sott',
  base00: '#322931',
  base01: '#433b42',
  base02: '#5c545b',
  base03: '#797379',
  base04: '#989498',
  base05: '#b9b5b8',
  base06: '#d5d3d5',
  base07: '#ffffff',
  base08: '#dd464c',
  base09: '#fd8b19',
  base0A: '#fdcc59',
  base0B: '#8fc13e',
  base0C: '#149b93',
  base0D: '#1290bf',
  base0E: '#c85e7c',
  base0F: '#b33508'
};
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'isotope',
  author: 'jan t. sott',
  base00: '#000000',
  base01: '#404040',
  base02: '#606060',
  base03: '#808080',
  base04: '#c0c0c0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#ff0000',
  base09: '#ff9900',
  base0A: '#ff0099',
  base0B: '#33ff00',
  base0C: '#00ffff',
  base0D: '#0066ff',
  base0E: '#cc00ff',
  base0F: '#3300ff'
};
module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'marrakesh',
  author: 'alexandre gavioli (http://github.com/alexx2/)',
  base00: '#201602',
  base01: '#302e00',
  base02: '#5f5b17',
  base03: '#6c6823',
  base04: '#86813b',
  base05: '#948e48',
  base06: '#ccc37a',
  base07: '#faf0a5',
  base08: '#c35359',
  base09: '#b36144',
  base0A: '#a88339',
  base0B: '#18974e',
  base0C: '#75a738',
  base0D: '#477ca1',
  base0E: '#8868b3',
  base0F: '#b3588e'
};
module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'mocha',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#3B3228',
  base01: '#534636',
  base02: '#645240',
  base03: '#7e705a',
  base04: '#b8afad',
  base05: '#d0c8c6',
  base06: '#e9e1dd',
  base07: '#f5eeeb',
  base08: '#cb6077',
  base09: '#d28b71',
  base0A: '#f4bc87',
  base0B: '#beb55b',
  base0C: '#7bbda4',
  base0D: '#8ab3b5',
  base0E: '#a89bb9',
  base0F: '#bb9584'
};
module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633'
};
module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'ocean',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2b303b',
  base01: '#343d46',
  base02: '#4f5b66',
  base03: '#65737e',
  base04: '#a7adba',
  base05: '#c0c5ce',
  base06: '#dfe1e8',
  base07: '#eff1f5',
  base08: '#bf616a',
  base09: '#d08770',
  base0A: '#ebcb8b',
  base0B: '#a3be8c',
  base0C: '#96b5b4',
  base0D: '#8fa1b3',
  base0E: '#b48ead',
  base0F: '#ab7967'
};
module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'paraiso',
  author: 'jan t. sott',
  base00: '#2f1e2e',
  base01: '#41323f',
  base02: '#4f424c',
  base03: '#776e71',
  base04: '#8d8687',
  base05: '#a39e9b',
  base06: '#b9b6b0',
  base07: '#e7e9db',
  base08: '#ef6155',
  base09: '#f99b15',
  base0A: '#fec418',
  base0B: '#48b685',
  base0C: '#5bc4bf',
  base0D: '#06b6ef',
  base0E: '#815ba4',
  base0F: '#e96ba8'
};
module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'pop',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#000000',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#b0b0b0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#eb008a',
  base09: '#f29333',
  base0A: '#f8ca12',
  base0B: '#37b349',
  base0C: '#00aabb',
  base0D: '#0e5a94',
  base0E: '#b31e8d',
  base0F: '#7a2d00'
};
module.exports = exports['default'];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'railscasts',
  author: 'ryan bates (http://railscasts.com)',
  base00: '#2b2b2b',
  base01: '#272935',
  base02: '#3a4055',
  base03: '#5a647e',
  base04: '#d4cfc9',
  base05: '#e6e1dc',
  base06: '#f4f1ed',
  base07: '#f9f7f3',
  base08: '#da4939',
  base09: '#cc7833',
  base0A: '#ffc66d',
  base0B: '#a5c261',
  base0C: '#519f50',
  base0D: '#6d9cbe',
  base0E: '#b6b3eb',
  base0F: '#bc9458'
};
module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'shapeshifter',
  author: 'tyler benziger (http://tybenz.com)',
  base00: '#000000',
  base01: '#040404',
  base02: '#102015',
  base03: '#343434',
  base04: '#555555',
  base05: '#ababab',
  base06: '#e0e0e0',
  base07: '#f9f9f9',
  base08: '#e92f2f',
  base09: '#e09448',
  base0A: '#dddd13',
  base0B: '#0ed839',
  base0C: '#23edda',
  base0D: '#3b48e3',
  base0E: '#f996e2',
  base0F: '#69542d'
};
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'solarized',
  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
  base00: '#002b36',
  base01: '#073642',
  base02: '#586e75',
  base03: '#657b83',
  base04: '#839496',
  base05: '#93a1a1',
  base06: '#eee8d5',
  base07: '#fdf6e3',
  base08: '#dc322f',
  base09: '#cb4b16',
  base0A: '#b58900',
  base0B: '#859900',
  base0C: '#2aa198',
  base0D: '#268bd2',
  base0E: '#6c71c4',
  base0F: '#d33682'
};
module.exports = exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'summerfruit',
  author: 'christopher corley (http://cscorley.github.io/)',
  base00: '#151515',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#B0B0B0',
  base05: '#D0D0D0',
  base06: '#E0E0E0',
  base07: '#FFFFFF',
  base08: '#FF0086',
  base09: '#FD8900',
  base0A: '#ABA800',
  base0B: '#00C918',
  base0C: '#1faaaa',
  base0D: '#3777E6',
  base0E: '#AD00A1',
  base0F: '#cc6633'
};
module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'tomorrow',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#cc6666',
  base09: '#de935f',
  base0A: '#f0c674',
  base0B: '#b5bd68',
  base0C: '#8abeb7',
  base0D: '#81a2be',
  base0E: '#b294bb',
  base0F: '#a3685a'
};
module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'london tube',
  author: 'jan t. sott',
  base00: '#231f20',
  base01: '#1c3f95',
  base02: '#5a5758',
  base03: '#737171',
  base04: '#959ca1',
  base05: '#d9d8d8',
  base06: '#e7e7e8',
  base07: '#ffffff',
  base08: '#ee2e24',
  base09: '#f386a1',
  base0A: '#ffd204',
  base0B: '#00853e',
  base0C: '#85cebc',
  base0D: '#009ddc',
  base0E: '#98005d',
  base0F: '#b06110'
};
module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'twilight',
  author: 'david hart (http://hart-dev.com)',
  base00: '#1e1e1e',
  base01: '#323537',
  base02: '#464b50',
  base03: '#5f5a60',
  base04: '#838184',
  base05: '#a7a7a7',
  base06: '#c3c3c3',
  base07: '#ffffff',
  base08: '#cf6a4c',
  base09: '#cda869',
  base0A: '#f9ee98',
  base0B: '#8f9d6a',
  base0C: '#afc4db',
  base0D: '#7587a6',
  base0E: '#9b859d',
  base0F: '#9b703f'
};
module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'nicinabox',
  author: 'nicinabox (http://github.com/nicinabox)',
  base00: '#2A2F3A',
  base01: '#3C444F',
  base02: '#4F5A65',
  base03: '#BEBEBE',
  base04: '#b0b0b0', // based on ocean theme
  base05: '#d0d0d0', // based on ocean theme
  base06: '#FFFFFF',
  base07: '#f5f5f5', // based on ocean theme
  base08: '#fb9fb1', // based on ocean theme
  base09: '#FC6D24',
  base0A: '#ddb26f', // based on ocean theme
  base0B: '#A1C659',
  base0C: '#12cfc0', // based on ocean theme
  base0D: '#6FB3D2',
  base0E: '#D381C3',
  base0F: '#deaf8f' // based on ocean theme
};
module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = reducer;

var _actions = __webpack_require__(59);

function initialScrollTop(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var action = arguments[2];

  if (!props.preserveScrollTop) {
    return 0;
  }

  return action.type === _actions.UPDATE_SCROLL_TOP ? action.scrollTop : state;
}

function startConsecutiveToggle(props, state, action) {
  return action.type === _actions.START_CONSECUTIVE_TOGGLE ? action.id : state;
}

function reducer(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments[2];

  return {
    initialScrollTop: initialScrollTop(props, state.initialScrollTop, action),
    consecutiveToggleStartId: startConsecutiveToggle(props, state.consecutiveToggleStartId, action)
  };
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _function = __webpack_require__(18);

var _function2 = _interopRequireDefault(_function);

var _reduxDevtools = __webpack_require__(39);

var _LogMonitorButton = __webpack_require__(165);

var _LogMonitorButton2 = _interopRequireDefault(_LogMonitorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reset = _reduxDevtools.ActionCreators.reset;
var rollback = _reduxDevtools.ActionCreators.rollback;
var commit = _reduxDevtools.ActionCreators.commit;
var sweep = _reduxDevtools.ActionCreators.sweep;


var style = {
  textAlign: 'center',
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'row'
};

var LogMonitorButtonBar = function (_Component) {
  _inherits(LogMonitorButtonBar, _Component);

  function LogMonitorButtonBar(props) {
    _classCallCheck(this, LogMonitorButtonBar);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;

    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleRollback = _this.handleRollback.bind(_this);
    _this.handleSweep = _this.handleSweep.bind(_this);
    _this.handleCommit = _this.handleCommit.bind(_this);
    return _this;
  }

  LogMonitorButtonBar.prototype.handleRollback = function handleRollback() {
    this.props.dispatch(rollback());
  };

  LogMonitorButtonBar.prototype.handleSweep = function handleSweep() {
    this.props.dispatch(sweep());
  };

  LogMonitorButtonBar.prototype.handleCommit = function handleCommit() {
    this.props.dispatch(commit());
  };

  LogMonitorButtonBar.prototype.handleReset = function handleReset() {
    this.props.dispatch(reset());
  };

  LogMonitorButtonBar.prototype.render = function render() {
    var _props = this.props;
    var theme = _props.theme;
    var hasStates = _props.hasStates;
    var hasSkippedActions = _props.hasSkippedActions;

    return _react2.default.createElement(
      'div',
      { style: _extends({}, style, { borderColor: theme.base02 }) },
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleReset,
          enabled: true },
        'Reset'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleRollback,
          enabled: hasStates },
        'Revert'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleSweep,
          enabled: hasSkippedActions },
        'Sweep'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleCommit,
          enabled: hasStates },
        'Commit'
      )
    );
  };

  return LogMonitorButtonBar;
}(_react.Component);

LogMonitorButtonBar.propTypes = {
  dispatch: _propTypes2.default.func,
  theme: _propTypes2.default.object
};
exports.default = LogMonitorButtonBar;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _brighten = __webpack_require__(166);

var _brighten2 = _interopRequireDefault(_brighten);

var _function = __webpack_require__(18);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  base: {
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: 3,
    padding: 4,
    marginLeft: 3,
    marginRight: 3,
    marginTop: 5,
    marginBottom: 5,
    flexGrow: 1,
    display: 'inline-block',
    fontSize: '0.8em',
    color: 'white',
    textDecoration: 'none'
  }
};

var LogMonitorButton = function (_React$Component) {
  _inherits(LogMonitorButton, _React$Component);

  function LogMonitorButton(props) {
    _classCallCheck(this, LogMonitorButton);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;


    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.onClick = _this.onClick.bind(_this);

    _this.state = {
      hovered: false,
      active: false
    };
    return _this;
  }

  LogMonitorButton.prototype.handleMouseEnter = function handleMouseEnter() {
    this.setState({ hovered: true });
  };

  LogMonitorButton.prototype.handleMouseLeave = function handleMouseLeave() {
    this.setState({ hovered: false });
  };

  LogMonitorButton.prototype.handleMouseDown = function handleMouseDown() {
    this.setState({ active: true });
  };

  LogMonitorButton.prototype.handleMouseUp = function handleMouseUp() {
    this.setState({ active: false });
  };

  LogMonitorButton.prototype.onClick = function onClick() {
    if (!this.props.enabled) {
      return;
    }
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  LogMonitorButton.prototype.render = function render() {
    var style = _extends({}, styles.base, {
      backgroundColor: this.props.theme.base02
    });
    if (this.props.enabled && this.state.hovered) {
      style = _extends({}, style, {
        backgroundColor: (0, _brighten2.default)(this.props.theme.base02, 0.2)
      });
    }
    if (!this.props.enabled) {
      style = _extends({}, style, {
        opacity: 0.2,
        cursor: 'text',
        backgroundColor: 'transparent'
      });
    }
    return _react2.default.createElement(
      'a',
      { onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onClick: this.onClick,
        style: style },
      this.props.children
    );
  };

  return LogMonitorButton;
}(_react2.default.Component);

exports.default = LogMonitorButton;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (hexColor, lightness) {
  var hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex.replace(/(.)/g, '$1$1');
  }
  var lum = lightness || 0;

  var rgb = '#';
  var c = void 0;
  for (var i = 0; i < 3; ++i) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }
  return rgb;
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LogMonitorEntry = __webpack_require__(168);

var _LogMonitorEntry2 = _interopRequireDefault(_LogMonitorEntry);

var _function = __webpack_require__(18);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogMonitorEntryList = function (_Component) {
  _inherits(LogMonitorEntryList, _Component);

  function LogMonitorEntryList() {
    var _temp, _this, _ret;

    _classCallCheck(this, LogMonitorEntryList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LogMonitorEntryList.prototype.render = function render() {
    var elements = [];
    var _props = this.props;
    var theme = _props.theme;
    var actionsById = _props.actionsById;
    var computedStates = _props.computedStates;
    var currentStateIndex = _props.currentStateIndex;
    var consecutiveToggleStartId = _props.consecutiveToggleStartId;
    var select = _props.select;
    var skippedActionIds = _props.skippedActionIds;
    var stagedActionIds = _props.stagedActionIds;
    var expandActionRoot = _props.expandActionRoot;
    var expandStateRoot = _props.expandStateRoot;
    var markStateDiff = _props.markStateDiff;
    var onActionClick = _props.onActionClick;
    var onActionShiftClick = _props.onActionShiftClick;


    for (var i = 0; i < stagedActionIds.length; i++) {
      var actionId = stagedActionIds[i];
      var action = actionsById[actionId].action;
      var _computedStates$i = computedStates[i];
      var state = _computedStates$i.state;
      var error = _computedStates$i.error;

      var previousState = void 0;
      if (i > 0) {
        previousState = computedStates[i - 1].state;
      }
      elements.push(_react2.default.createElement(_LogMonitorEntry2.default, { key: actionId,
        theme: theme,
        select: select,
        action: action,
        actionId: actionId,
        state: state,
        previousState: previousState,
        collapsed: skippedActionIds.indexOf(actionId) > -1,
        inFuture: i > currentStateIndex,
        selected: consecutiveToggleStartId === i,
        error: error,
        expandActionRoot: expandActionRoot,
        expandStateRoot: expandStateRoot,
        markStateDiff: markStateDiff,
        onActionClick: onActionClick,
        onActionShiftClick: onActionShiftClick }));
    }

    return _react2.default.createElement(
      'div',
      null,
      elements
    );
  };

  return LogMonitorEntryList;
}(_react.Component);

LogMonitorEntryList.propTypes = {
  actionsById: _propTypes2.default.object,
  computedStates: _propTypes2.default.array,
  stagedActionIds: _propTypes2.default.array,
  skippedActionIds: _propTypes2.default.array,
  currentStateIndex: _propTypes2.default.number,
  consecutiveToggleStartId: _propTypes2.default.number,

  select: _propTypes2.default.func.isRequired,
  onActionClick: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool
};
exports.default = LogMonitorEntryList;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJsonTree = __webpack_require__(60);

var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);

var _LogMonitorEntryAction = __webpack_require__(213);

var _LogMonitorEntryAction2 = _interopRequireDefault(_LogMonitorEntryAction);

var _function = __webpack_require__(18);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  entry: {
    display: 'block',
    WebkitUserSelect: 'none'
  },

  root: {
    marginLeft: 0
  }
};

var getDeepItem = function getDeepItem(data, path) {
  return path.reduce(function (obj, key) {
    return obj && obj[key];
  }, data);
};
var dataIsEqual = function dataIsEqual(data, previousData, keyPath) {
  var path = [].concat(keyPath).reverse().slice(1);

  return getDeepItem(data, path) === getDeepItem(previousData, path);
};

var LogMonitorEntry = function (_Component) {
  _inherits(LogMonitorEntry, _Component);

  function LogMonitorEntry(props) {
    _classCallCheck(this, LogMonitorEntry);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;

    _this.handleActionClick = _this.handleActionClick.bind(_this);
    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
    return _this;
  }

  LogMonitorEntry.prototype.printState = function printState(state, error) {
    var _this2 = this;

    var errorText = error;
    if (!errorText) {
      try {
        var _ret = function () {
          var data = _this2.props.select(state);
          var theme = void 0;

          if (_this2.props.markStateDiff) {
            (function () {
              var previousData = typeof _this2.props.previousState !== 'undefined' ? _this2.props.select(_this2.props.previousState) : undefined;
              var getValueStyle = function getValueStyle(_ref, nodeType, keyPath) {
                var style = _ref.style;
                return {
                  style: _extends({}, style, {
                    backgroundColor: dataIsEqual(data, previousData, keyPath) ? 'transparent' : _this2.props.theme.base01
                  })
                };
              };
              var getNestedNodeStyle = function getNestedNodeStyle(_ref2, keyPath) {
                var style = _ref2.style;
                return {
                  style: _extends({}, style, keyPath.length > 1 ? {} : styles.root)
                };
              };
              theme = {
                extend: _this2.props.theme,
                tree: styles.tree,
                value: getValueStyle,
                nestedNode: getNestedNodeStyle
              };
            })();
          } else {
            theme = _this2.props.theme;
          }

          return {
            v: _react2.default.createElement(_reactJsonTree2.default, {
              theme: theme,
              data: data,
              invertTheme: false,
              keyPath: ['state'],
              shouldExpandNode: _this2.shouldExpandNode })
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      } catch (err) {
        errorText = 'Error selecting state.';
      }
    }

    return _react2.default.createElement(
      'div',
      { style: {
          color: this.props.theme.base08,
          paddingTop: 20,
          paddingLeft: 30,
          paddingRight: 30,
          paddingBottom: 35
        } },
      errorText
    );
  };

  LogMonitorEntry.prototype.handleActionClick = function handleActionClick(e) {
    var _props = this.props;
    var actionId = _props.actionId;
    var onActionClick = _props.onActionClick;
    var onActionShiftClick = _props.onActionShiftClick;

    if (actionId > 0) {
      if (e.shiftKey) {
        onActionShiftClick(actionId);
      } else {
        onActionClick(actionId);
      }
    }
  };

  LogMonitorEntry.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
    return this.props.expandStateRoot && level === 0;
  };

  LogMonitorEntry.prototype.render = function render() {
    var _props2 = this.props;
    var actionId = _props2.actionId;
    var error = _props2.error;
    var action = _props2.action;
    var state = _props2.state;
    var collapsed = _props2.collapsed;
    var selected = _props2.selected;
    var inFuture = _props2.inFuture;

    var styleEntry = {
      opacity: collapsed ? 0.5 : 1,
      cursor: actionId > 0 ? 'pointer' : 'default'
    };

    return _react2.default.createElement(
      'div',
      { style: {
          opacity: selected ? 0.4 : inFuture ? 0.6 : 1, // eslint-disable-line no-nested-ternary
          textDecoration: collapsed ? 'line-through' : 'none',
          color: this.props.theme.base06
        } },
      _react2.default.createElement(_LogMonitorEntryAction2.default, {
        theme: this.props.theme,
        collapsed: collapsed,
        action: action,
        expandActionRoot: this.props.expandActionRoot,
        onClick: this.handleActionClick,
        style: _extends({}, styles.entry, styleEntry) }),
      !collapsed && _react2.default.createElement(
        'div',
        { style: { paddingLeft: 16 } },
        this.printState(state, error)
      )
    );
  };

  return LogMonitorEntry;
}(_react.Component);

LogMonitorEntry.propTypes = {
  state: _propTypes2.default.object.isRequired,
  action: _propTypes2.default.object.isRequired,
  actionId: _propTypes2.default.number.isRequired,
  select: _propTypes2.default.func.isRequired,
  inFuture: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  onActionClick: _propTypes2.default.func.isRequired,
  onActionShiftClick: _propTypes2.default.func.isRequired,
  collapsed: _propTypes2.default.bool,
  selected: _propTypes2.default.bool,
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool
};
exports.default = LogMonitorEntry;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(170);
module.exports = __webpack_require__(15).Object.keys;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(171);
var $keys = __webpack_require__(172);

__webpack_require__(61)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(254);

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(193);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(191);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(175);

var _iterator2 = _interopRequireDefault(_iterator);

exports['default'] = objType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function objType(obj) {
  var type = Object.prototype.toString.call(obj).slice(8, -1);
  if (type === 'Object' && typeof obj[_iterator2['default']] === 'function') {
    return 'Iterable';
  }

  if (type === 'Custom' && obj.constructor !== Object && obj instanceof Object) {
    // For projects implementing objects overriding `.prototype[Symbol.toStringTag]`
    return 'Object';
  }

  return type;
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1397);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(19);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getOwnPropertyNames = __webpack_require__(64);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNestedNode = __webpack_require__(43);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data) {
  var len = (0, _getOwnPropertyNames2['default'])(data).length;
  return len + ' ' + (len !== 1 ? 'keys' : 'key');
}

// Configures <JSONNestedNode> to render an Object
var JSONObjectNode = function JSONObjectNode(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    data: data,
    nodeType: 'Object',
    nodeTypeIndicator: props.nodeType === 'Error' ? 'Error()' : '{}',
    createItemString: createItemString,
    expandable: (0, _getOwnPropertyNames2['default'])(data).length > 0
  }));
};

JSONObjectNode.propTypes = {
  data: _propTypes2['default'].object,
  nodeType: _propTypes2['default'].string
};

exports['default'] = JSONObjectNode;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
var $Object = __webpack_require__(15).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(61)('getOwnPropertyNames', function () {
  return __webpack_require__(179).f;
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1414);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getIterator2 = __webpack_require__(44);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getOwnPropertyNames = __webpack_require__(64);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

exports['default'] = getCollectionEntries;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getLength(type, collection) {
  if (type === 'Object') {
    return (0, _keys2['default'])(collection).length;
  } else if (type === 'Array') {
    return collection.length;
  }

  return Infinity;
}

function isIterableMap(collection) {
  return typeof collection.set === 'function';
}

function getEntries(type, collection, sortObjectKeys) {
  var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var to = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;

  var res = void 0;

  if (type === 'Object') {
    var keys = (0, _getOwnPropertyNames2['default'])(collection);

    if (sortObjectKeys) {
      keys.sort(sortObjectKeys === true ? undefined : sortObjectKeys);
    }

    keys = keys.slice(from, to + 1);

    res = {
      entries: keys.map(function (key) {
        return { key: key, value: collection[key] };
      })
    };
  } else if (type === 'Array') {
    res = {
      entries: collection.slice(from, to + 1).map(function (val, idx) {
        return { key: idx + from, value: val };
      })
    };
  } else {
    var idx = 0;
    var entries = [];
    var done = true;

    var isMap = isIterableMap(collection);

    for (var _iterator = collection, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var item = _ref;

      if (idx > to) {
        done = false;
        break;
      }
      if (from <= idx) {
        if (isMap && Array.isArray(item)) {
          if (typeof item[0] === 'string' || typeof item[0] === 'number') {
            entries.push({ key: item[0], value: item[1] });
          } else {
            entries.push({
              key: '[entry ' + idx + ']',
              value: {
                '[key]': item[0],
                '[value]': item[1]
              }
            });
          }
        } else {
          entries.push({ key: idx, value: item });
        }
      }
      idx++;
    }

    res = {
      hasMore: !done,
      entries: entries
    };
  }

  return res;
}

function getRanges(from, to, limit) {
  var ranges = [];
  while (to - from > limit * limit) {
    limit = limit * limit;
  }
  for (var i = from; i <= to; i += limit) {
    ranges.push({ from: i, to: Math.min(to, i + limit - 1) });
  }

  return ranges;
}

function getCollectionEntries(type, collection, sortObjectKeys, limit) {
  var from = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var to = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;

  var getEntriesBound = getEntries.bind(null, type, collection, sortObjectKeys);

  if (!limit) {
    return getEntriesBound().entries;
  }

  var isSubset = to < Infinity;
  var length = Math.min(to - from, getLength(type, collection));

  if (type !== 'Iterable') {
    if (length <= limit || limit < 7) {
      return getEntriesBound(from, to).entries;
    }
  } else {
    if (length <= limit && !isSubset) {
      return getEntriesBound(from, to).entries;
    }
  }

  var limitedEntries = void 0;
  if (type === 'Iterable') {
    var _getEntriesBound = getEntriesBound(from, from + limit - 1),
        hasMore = _getEntriesBound.hasMore,
        entries = _getEntriesBound.entries;

    limitedEntries = hasMore ? [].concat(entries, getRanges(from + limit, from + 2 * limit - 1, limit)) : entries;
  } else {
    limitedEntries = isSubset ? getRanges(from, to, limit) : [].concat(getEntriesBound(0, limit - 5).entries, getRanges(limit - 4, length - 5, limit), getEntriesBound(length - 4, length - 1).entries);
  }

  return limitedEntries;
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
__webpack_require__(67);
module.exports = __webpack_require__(182);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(183);
var get = __webpack_require__(184);
module.exports = __webpack_require__(15).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(159);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1447);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(40);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(42);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONArrow = __webpack_require__(65);

var _JSONArrow2 = _interopRequireDefault(_JSONArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ItemRange = function (_React$Component) {
  (0, _inherits3['default'])(ItemRange, _React$Component);

  function ItemRange(props) {
    (0, _classCallCheck3['default'])(this, ItemRange);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = { expanded: false };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  ItemRange.prototype.render = function render() {
    var _props = this.props,
        styling = _props.styling,
        from = _props.from,
        to = _props.to,
        renderChildNodes = _props.renderChildNodes,
        nodeType = _props.nodeType;


    return this.state.expanded ? _react2['default'].createElement(
      'div',
      styling('itemRange', this.state.expanded),
      renderChildNodes(this.props, from, to)
    ) : _react2['default'].createElement(
      'div',
      (0, _extends3['default'])({}, styling('itemRange', this.state.expanded), {
        onClick: this.handleClick
      }),
      _react2['default'].createElement(_JSONArrow2['default'], {
        nodeType: nodeType,
        styling: styling,
        expanded: false,
        onClick: this.handleClick,
        arrowStyle: 'double'
      }),
      from + ' ... ' + to
    );
  };

  ItemRange.prototype.handleClick = function handleClick() {
    this.setState({ expanded: !this.state.expanded });
  };

  return ItemRange;
}(_react2['default'].Component);

ItemRange.propTypes = {
  styling: _propTypes2['default'].func.isRequired,
  from: _propTypes2['default'].number.isRequired,
  to: _propTypes2['default'].number.isRequired,
  renderChildNodes: _propTypes2['default'].func.isRequired,
  nodeType: _propTypes2['default'].string.isRequired
};
exports['default'] = ItemRange;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(19);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNestedNode = __webpack_require__(43);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data) {
  return data.length + ' ' + (data.length !== 1 ? 'items' : 'item');
}

// Configures <JSONNestedNode> to render an Array
var JSONArrayNode = function JSONArrayNode(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    data: data,
    nodeType: 'Array',
    nodeTypeIndicator: '[]',
    createItemString: createItemString,
    expandable: data.length > 0
  }));
};

JSONArrayNode.propTypes = {
  data: _propTypes2['default'].array
};

exports['default'] = JSONArrayNode;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(19);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(44);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _isSafeInteger = __webpack_require__(188);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

exports['default'] = JSONIterableNode;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _JSONNestedNode = __webpack_require__(43);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data, limit) {
  var count = 0;
  var hasMore = false;
  if ((0, _isSafeInteger2['default'])(data.size)) {
    count = data.size;
  } else {
    // eslint-disable-next-line no-unused-vars
    for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var entry = _ref;

      if (limit && count + 1 > limit) {
        hasMore = true;
        break;
      }
      count += 1;
    }
  }
  return '' + (hasMore ? '>' : '') + count + ' ' + (count !== 1 ? 'entries' : 'entry');
}

// Configures <JSONNestedNode> to render an iterable
function JSONIterableNode(_ref2) {
  var props = (0, _objectWithoutProperties3['default'])(_ref2, []);

  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    nodeType: 'Iterable',
    nodeTypeIndicator: '()',
    createItemString: createItemString
  }));
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
module.exports = __webpack_require__(15).Number.isSafeInteger;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(62);
var isInteger = __webpack_require__(191);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(192);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(160);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Renders simple values (eg. strings, numbers, booleans, etc)
 */

var JSONValueNode = function JSONValueNode(_ref) {
  var nodeType = _ref.nodeType,
      styling = _ref.styling,
      labelRenderer = _ref.labelRenderer,
      keyPath = _ref.keyPath,
      valueRenderer = _ref.valueRenderer,
      value = _ref.value,
      valueGetter = _ref.valueGetter;
  return _react2['default'].createElement(
    'li',
    styling('value', nodeType, keyPath),
    _react2['default'].createElement(
      'label',
      styling(['label', 'valueLabel'], nodeType, keyPath),
      labelRenderer(keyPath, nodeType, false, false)
    ),
    _react2['default'].createElement(
      'span',
      styling('valueText', nodeType, keyPath),
      valueRenderer.apply(undefined, [valueGetter(value), value].concat(keyPath))
    )
  );
};

JSONValueNode.propTypes = {
  nodeType: _propTypes2['default'].string.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  valueRenderer: _propTypes2['default'].func.isRequired,
  value: _propTypes2['default'].any,
  valueGetter: _propTypes2['default'].func
};

JSONValueNode.defaultProps = {
  valueGetter: function valueGetter(value) {
    return value;
  }
};

exports['default'] = JSONValueNode;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _reactBase16Styling = __webpack_require__(68);

var _solarized = __webpack_require__(212);

var _solarized2 = _interopRequireDefault(_solarized);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var colorMap = function colorMap(theme) {
  return {
    BACKGROUND_COLOR: theme.base00,
    TEXT_COLOR: theme.base07,
    STRING_COLOR: theme.base0B,
    DATE_COLOR: theme.base0B,
    NUMBER_COLOR: theme.base09,
    BOOLEAN_COLOR: theme.base09,
    NULL_COLOR: theme.base08,
    UNDEFINED_COLOR: theme.base08,
    FUNCTION_COLOR: theme.base08,
    SYMBOL_COLOR: theme.base08,
    LABEL_COLOR: theme.base0D,
    ARROW_COLOR: theme.base0D,
    ITEM_STRING_COLOR: theme.base0B,
    ITEM_STRING_EXPANDED_COLOR: theme.base03
  };
};

var valueColorMap = function valueColorMap(colors) {
  return {
    String: colors.STRING_COLOR,
    Date: colors.DATE_COLOR,
    Number: colors.NUMBER_COLOR,
    Boolean: colors.BOOLEAN_COLOR,
    Null: colors.NULL_COLOR,
    Undefined: colors.UNDEFINED_COLOR,
    Function: colors.FUNCTION_COLOR,
    Symbol: colors.SYMBOL_COLOR
  };
};

var getDefaultThemeStyling = function getDefaultThemeStyling(theme) {
  var colors = colorMap(theme);

  return {
    tree: {
      border: 0,
      padding: 0,
      marginTop: '0.5em',
      marginBottom: '0.5em',
      marginLeft: '0.125em',
      marginRight: 0,
      listStyle: 'none',
      MozUserSelect: 'none',
      WebkitUserSelect: 'none',
      backgroundColor: colors.BACKGROUND_COLOR
    },

    value: function value(_ref, nodeType, keyPath) {
      var style = _ref.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          paddingTop: '0.25em',
          paddingRight: 0,
          marginLeft: '0.875em',
          WebkitUserSelect: 'text',
          MozUserSelect: 'text',
          wordWrap: 'break-word',
          paddingLeft: keyPath.length > 1 ? '2.125em' : '1.25em',
          textIndent: '-0.5em',
          wordBreak: 'break-all'
        })
      };
    },

    label: {
      display: 'inline-block',
      color: colors.LABEL_COLOR
    },

    valueLabel: {
      margin: '0 0.5em 0 0'
    },

    valueText: function valueText(_ref2, nodeType) {
      var style = _ref2.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          color: valueColorMap(colors)[nodeType]
        })
      };
    },

    itemRange: function itemRange(styling, expanded) {
      return {
        style: {
          paddingTop: expanded ? 0 : '0.25em',
          cursor: 'pointer',
          color: colors.LABEL_COLOR
        }
      };
    },

    arrow: function arrow(_ref3, nodeType, expanded) {
      var style = _ref3.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          marginLeft: 0,
          transition: '150ms',
          WebkitTransition: '150ms',
          MozTransition: '150ms',
          WebkitTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          MozTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          transform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          transformOrigin: '45% 50%',
          WebkitTransformOrigin: '45% 50%',
          MozTransformOrigin: '45% 50%',
          position: 'relative',
          lineHeight: '1.1em',
          fontSize: '0.75em'
        })
      };
    },

    arrowContainer: function arrowContainer(_ref4, arrowStyle) {
      var style = _ref4.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          display: 'inline-block',
          paddingRight: '0.5em',
          paddingLeft: arrowStyle === 'double' ? '1em' : 0,
          cursor: 'pointer'
        })
      };
    },

    arrowSign: {
      color: colors.ARROW_COLOR
    },

    arrowSignInner: {
      position: 'absolute',
      top: 0,
      left: '-0.4em'
    },

    nestedNode: function nestedNode(_ref5, keyPath, nodeType, expanded, expandable) {
      var style = _ref5.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          position: 'relative',
          paddingTop: '0.25em',
          marginLeft: keyPath.length > 1 ? '0.875em' : 0,
          paddingLeft: !expandable ? '1.125em' : 0
        })
      };
    },

    rootNode: {
      padding: 0,
      margin: 0
    },

    nestedNodeLabel: function nestedNodeLabel(_ref6, keyPath, nodeType, expanded, expandable) {
      var style = _ref6.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          margin: 0,
          padding: 0,
          WebkitUserSelect: expandable ? 'inherit' : 'text',
          MozUserSelect: expandable ? 'inherit' : 'text',
          cursor: expandable ? 'pointer' : 'default'
        })
      };
    },

    nestedNodeItemString: function nestedNodeItemString(_ref7, keyPath, nodeType, expanded) {
      var style = _ref7.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          paddingLeft: '0.5em',
          cursor: 'default',
          color: expanded ? colors.ITEM_STRING_EXPANDED_COLOR : colors.ITEM_STRING_COLOR
        })
      };
    },

    nestedNodeItemType: {
      marginLeft: '0.3em',
      marginRight: '0.3em'
    },

    nestedNodeChildren: function nestedNodeChildren(_ref8, nodeType, expanded) {
      var style = _ref8.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          padding: 0,
          margin: 0,
          listStyle: 'none',
          display: expanded ? 'block' : 'none'
        })
      };
    },

    rootNodeChildren: {
      padding: 0,
      margin: 0,
      listStyle: 'none'
    }
  };
};

exports['default'] = (0, _reactBase16Styling.createStyling)(getDefaultThemeStyling, {
  defaultBase16: _solarized2['default']
});

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(362);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(197);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(44);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(198), __esModule: true };

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
__webpack_require__(67);
module.exports = __webpack_require__(199);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(200);
var ITERATOR = __webpack_require__(201)('iterator');
var Iterators = __webpack_require__(202);
module.exports = __webpack_require__(15).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1448);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(94);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(195);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', ARY_FLAG],
  ['bind', BIND_FLAG],
  ['bindKey', BIND_KEY_FLAG],
  ['curry', CURRY_FLAG],
  ['curryRight', CURRY_RIGHT_FLAG],
  ['flip', FLIP_FLAG],
  ['partial', PARTIAL_FLAG],
  ['partialRight', PARTIAL_RIGHT_FLAG],
  ['rearg', REARG_FLAG]
];

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var objectCreate = Object.create;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/* Used to set `toString` methods. */
var defineProperty = (function() {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;

  return (name && name.length > 2) ? func : undefined;
}());

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;

  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
  var source = (reference + '');
  return defineProperty(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var clamp = __webpack_require__(45);

function componentToHex(c) {
  var value = Math.round(clamp(c, 0, 255));
  var hex   = value.toString(16);

  return hex.length == 1 ? "0" + hex : hex;
}

function rgb2hex(rgb) {
  var alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";

  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
}

module.exports = rgb2hex;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var hsl = __webpack_require__(206);
var hex = __webpack_require__(207);
var rgb = __webpack_require__(208);
var hsl2rgb = __webpack_require__(209);

function hsl2rgbParse(color) {
  var h = hsl(color);
  var r = hsl2rgb(h);

  // handle alpha since hsl2rgb doesn't know (or care!) about it
  if(h.length === 4) {
    r.push(h[3]);
  }

  return r;
}

var space2parser = {
  "#" : hex,
  "hsl" : hsl2rgbParse,
  "rgb" : rgb
};

function parse(color) {
  for(var scheme in space2parser) {
    if(color.indexOf(scheme) === 0) {
      return space2parser[scheme](color);
    }
  }
}

parse.rgb = rgb;
parse.hsl = hsl;
parse.hex = hex;

module.exports = parse;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var extractComponents = __webpack_require__(70);
var clamp = __webpack_require__(45);

function parseHslComponent(component, i) {
  component = parseFloat(component);

  switch(i) {
    case 0:
      return clamp(component, 0, 360);
    case 1:
    case 2:
      return clamp(component, 0, 100);
    case 3:
      return clamp(component, 0, 1);
  }
}

function hsl(color) {
  return extractComponents(color).map(parseHslComponent);
}

module.exports = hsl;

/***/ }),
/* 207 */
/***/ (function(module, exports) {

function expand(hex) {
  var result = "#";

  for (var i = 1; i < hex.length; i++) {
    var val = hex.charAt(i);
    result += val + val;
  }

  return result;
}

function hex(hex) {
  // #RGB or #RGBA
  if(hex.length === 4 || hex.length === 5) {
    hex = expand(hex);
  }

  var rgb = [
    parseInt(hex.substring(1,3), 16),
    parseInt(hex.substring(3,5), 16),
    parseInt(hex.substring(5,7), 16)
  ];

  // #RRGGBBAA
  if (hex.length === 9) {
    var alpha = parseFloat((parseInt(hex.substring(7,9), 16) / 255).toFixed(2));
    rgb.push(alpha);
  }

  return rgb;
}

module.exports = hex;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var extractComponents = __webpack_require__(70);
var clamp = __webpack_require__(45);

function parseRgbComponent(component, i) {
  if (i < 3) {
    if (component.indexOf('%') != -1) {
      return Math.round(255 * clamp(parseInt(component, 10), 0, 100)/100);
    } else {
      return clamp(parseInt(component, 10), 0, 255);
    }
  } else {
    return clamp(parseFloat(component), 0, 1);
  } 
}

function rgb(color) {
  return extractComponents(color).map(parseRgbComponent);
}

module.exports = rgb;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

module.exports = hsl2rgb;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return baseRest(function(funcs) {
    funcs = baseFlatten(funcs, 1);

    var length = funcs.length,
        index = length;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      if (typeof funcs[index] != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }
    return function() {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yuv2rgb = yuv2rgb;
exports.rgb2yuv = rgb2yuv;
function yuv2rgb(yuv) {
  var y = yuv[0],
      u = yuv[1],
      v = yuv[2],
      r,
      g,
      b;

  r = y * 1 + u * 0 + v * 1.13983;
  g = y * 1 + u * -0.39465 + v * -0.58060;
  b = y * 1 + u * 2.02311 + v * 0;

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function rgb2yuv(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  var y = r * 0.299 + g * 0.587 + b * 0.114;
  var u = r * -0.14713 + g * -0.28886 + b * 0.436;
  var v = r * 0.615 + g * -0.51499 + b * -0.10001;

  return [y, u, v];
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'solarized',
  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
  base00: '#002b36',
  base01: '#073642',
  base02: '#586e75',
  base03: '#657b83',
  base04: '#839496',
  base05: '#93a1a1',
  base06: '#eee8d5',
  base07: '#fdf6e3',
  base08: '#dc322f',
  base09: '#cb4b16',
  base0A: '#b58900',
  base0B: '#859900',
  base0C: '#2aa198',
  base0D: '#268bd2',
  base0E: '#6c71c4',
  base0F: '#d33682'
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactJsonTree = __webpack_require__(60);

var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  actionBar: {
    paddingTop: 8,
    paddingBottom: 7,
    paddingLeft: 16
  },
  payload: {
    margin: 0,
    paddingLeft: 16,
    overflow: 'auto'
  }
};

var LogMonitorAction = function (_Component) {
  _inherits(LogMonitorAction, _Component);

  function LogMonitorAction(props) {
    _classCallCheck(this, LogMonitorAction);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
    return _this;
  }

  LogMonitorAction.prototype.renderPayload = function renderPayload(payload) {
    return _react2.default.createElement(
      'div',
      { style: _extends({}, styles.payload, {
          backgroundColor: this.props.theme.base00
        }) },
      Object.keys(payload).length > 0 ? _react2.default.createElement(_reactJsonTree2.default, { theme: this.props.theme,
        invertTheme: false,
        keyPath: ['action'],
        data: payload,
        shouldExpandNode: this.shouldExpandNode }) : ''
    );
  };

  LogMonitorAction.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
    return this.props.expandActionRoot && level === 0;
  };

  LogMonitorAction.prototype.render = function render() {
    var _props$action = this.props.action;
    var type = _props$action.type;

    var payload = _objectWithoutProperties(_props$action, ['type']);

    return _react2.default.createElement(
      'div',
      { style: _extends({
          backgroundColor: this.props.theme.base02,
          color: this.props.theme.base06
        }, this.props.style) },
      _react2.default.createElement(
        'div',
        { style: styles.actionBar,
          onClick: this.props.onClick },
        type !== null && type.toString()
      ),
      !this.props.collapsed ? this.renderPayload(payload) : ''
    );
  };

  return LogMonitorAction;
}(_react.Component);

exports.default = LogMonitorAction;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1359);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _DockMonitor = __webpack_require__(216);

var _DockMonitor2 = _interopRequireDefault(_DockMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DockMonitor2.default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDock = __webpack_require__(217);

var _reactDock2 = _interopRequireDefault(_reactDock);

var _constants = __webpack_require__(71);

var _actions = __webpack_require__(72);

var _reducers = __webpack_require__(222);

var _reducers2 = _interopRequireDefault(_reducers);

var _parseKey = __webpack_require__(223);

var _parseKey2 = _interopRequireDefault(_parseKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DockMonitor = function (_Component) {
  _inherits(DockMonitor, _Component);

  function DockMonitor(props) {
    _classCallCheck(this, DockMonitor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleSizeChange = _this.handleSizeChange.bind(_this);

    var childrenCount = _react.Children.count(props.children);
    if (childrenCount === 0) {
      console.error('<DockMonitor> requires at least one monitor inside. ' + 'Why don’t you try <LogMonitor>? You can get it at ' + 'https://github.com/gaearon/redux-devtools-log-monitor.');
    } else if (childrenCount > 1 && !props.changeMonitorKey) {
      console.error('You specified multiple monitors inside <DockMonitor> ' + 'but did not provide `changeMonitorKey` prop to change them. ' + 'Try specifying <DockMonitor changeMonitorKey="ctrl-m" /> ' + 'and then press Ctrl-M.');
    }
    return _this;
  }

  DockMonitor.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  };

  DockMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  };

  DockMonitor.prototype.matchesKey = function matchesKey(key, event) {
    if (!key) {
      return false;
    }

    var charCode = event.keyCode || event.which;
    var char = String.fromCharCode(charCode);
    return key.name.toUpperCase() === char.toUpperCase() && key.alt === event.altKey && key.ctrl === event.ctrlKey && key.meta === event.metaKey && key.shift === event.shiftKey;
  };

  DockMonitor.prototype.handleKeyDown = function handleKeyDown(e) {
    // Ignore regular keys when focused on a field
    // and no modifiers are active.
    if (!e.ctrlKey && !e.metaKey && !e.altKey && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable)) {
      return;
    }

    var visibilityKey = (0, _parseKey2.default)(this.props.toggleVisibilityKey);
    var positionKey = (0, _parseKey2.default)(this.props.changePositionKey);

    var monitorKey = void 0;
    if (this.props.changeMonitorKey) {
      monitorKey = (0, _parseKey2.default)(this.props.changeMonitorKey);
    }

    if (this.matchesKey(visibilityKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.toggleVisibility)());
    } else if (this.matchesKey(positionKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.changePosition)());
    } else if (this.matchesKey(monitorKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.changeMonitor)());
    }
  };

  DockMonitor.prototype.handleSizeChange = function handleSizeChange(requestedSize) {
    this.props.dispatch((0, _actions.changeSize)(requestedSize));
  };

  DockMonitor.prototype.renderChild = function renderChild(child, index, otherProps) {
    var monitorState = this.props.monitorState;
    var childMonitorIndex = monitorState.childMonitorIndex,
        childMonitorStates = monitorState.childMonitorStates;


    if (index !== childMonitorIndex) {
      return null;
    }

    return (0, _react.cloneElement)(child, _extends({
      monitorState: childMonitorStates[index]
    }, otherProps));
  };

  DockMonitor.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        monitorState = _props.monitorState,
        children = _props.children,
        fluid = _props.fluid,
        rest = _objectWithoutProperties(_props, ['monitorState', 'children', 'fluid']);

    var position = monitorState.position,
        isVisible = monitorState.isVisible,
        size = monitorState.size;


    return _react2.default.createElement(
      _reactDock2.default,
      { position: position,
        isVisible: isVisible,
        size: size,
        fluid: fluid,
        onSizeChange: this.handleSizeChange,
        dimMode: 'none' },
      _react.Children.map(children, function (child, index) {
        return _this2.renderChild(child, index, rest);
      })
    );
  };

  return DockMonitor;
}(_react.Component);

DockMonitor.update = _reducers2.default;
DockMonitor.propTypes = {
  defaultPosition: _propTypes2.default.oneOf(_constants.POSITIONS),
  defaultIsVisible: _propTypes2.default.bool.isRequired,
  defaultSize: _propTypes2.default.number.isRequired,
  toggleVisibilityKey: _propTypes2.default.string.isRequired,
  changePositionKey: _propTypes2.default.string.isRequired,
  changeMonitorKey: _propTypes2.default.string,
  fluid: _propTypes2.default.bool,

  dispatch: _propTypes2.default.func,
  monitorState: _propTypes2.default.shape({
    position: _propTypes2.default.oneOf(_constants.POSITIONS).isRequired,
    size: _propTypes2.default.number.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    childMonitorState: _propTypes2.default.any
  })
};
DockMonitor.defaultProps = {
  defaultIsVisible: true,
  defaultPosition: 'right',
  defaultSize: 0.3,
  fluid: true
};
exports.default = DockMonitor;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dock = __webpack_require__(218);

var _Dock2 = _interopRequireDefault(_Dock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dock2.default;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(219);

var _lodash2 = _interopRequireDefault(_lodash);

var _autoprefix = __webpack_require__(221);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function autoprefixes(styles) {
  return Object.keys(styles).reduce(function (obj, key) {
    return obj[key] = (0, _autoprefix2.default)(styles[key]), obj;
  }, {});
}

var styles = autoprefixes({
  wrapper: {
    position: 'fixed',
    width: 0,
    height: 0,
    top: 0,
    left: 0
  },

  dim: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    background: 'rgba(0, 0, 0, 0.2)',
    opacity: 1
  },

  dimAppear: {
    opacity: 0
  },

  dimTransparent: {
    pointerEvents: 'none'
  },

  dimHidden: {
    opacity: 0
  },

  dock: {
    position: 'fixed',
    zIndex: 1,
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
    background: 'white',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },

  dockHidden: {
    opacity: 0
  },

  dockResizing: {
    transition: 'none'
  },

  dockContent: {
    width: '100%',
    height: '100%',
    overflow: 'auto'
  },

  resizer: {
    position: 'absolute',
    zIndex: 2,
    opacity: 0
  }
});

function getTransitions(duration) {
  return ['left', 'top', 'width', 'height'].map(function (p) {
    return p + ' ' + duration / 1000 + 's ease-out';
  });
}

function getDockStyles(_ref, _ref2) {
  var fluid = _ref.fluid;
  var dockStyle = _ref.dockStyle;
  var dockHiddenStyle = _ref.dockHiddenStyle;
  var duration = _ref.duration;
  var position = _ref.position;
  var isVisible = _ref.isVisible;
  var size = _ref2.size;
  var isResizing = _ref2.isResizing;
  var fullWidth = _ref2.fullWidth;
  var fullHeight = _ref2.fullHeight;

  var posStyle = void 0;
  var absSize = fluid ? size * 100 + '%' : size + 'px';

  function getRestSize(fullSize) {
    return fluid ? 100 - size * 100 + '%' : fullSize - size + 'px';
  }

  switch (position) {
    case 'left':
      posStyle = {
        width: absSize,
        left: isVisible ? 0 : '-' + absSize
      };
      break;
    case 'right':
      posStyle = {
        left: isVisible ? getRestSize(fullWidth) : fullWidth,
        width: absSize
      };
      break;
    case 'top':
      posStyle = {
        top: isVisible ? 0 : '-' + absSize,
        height: absSize
      };
      break;
    case 'bottom':
      posStyle = {
        top: isVisible ? getRestSize(fullHeight) : fullHeight,
        height: absSize
      };
      break;
  }

  var transitions = getTransitions(duration);

  return [styles.dock, (0, _autoprefix2.default)({
    transition: [].concat(_toConsumableArray(transitions), [!isVisible && 'opacity 0.01s linear ' + duration / 1000 + 's']).filter(function (t) {
      return t;
    }).join(',')
  }), dockStyle, (0, _autoprefix2.default)(posStyle), isResizing && styles.dockResizing, !isVisible && styles.dockHidden, !isVisible && dockHiddenStyle];
}

function getDimStyles(_ref3, _ref4) {
  var dimMode = _ref3.dimMode;
  var dimStyle = _ref3.dimStyle;
  var duration = _ref3.duration;
  var isVisible = _ref3.isVisible;
  var isTransitionStarted = _ref4.isTransitionStarted;

  return [styles.dim, (0, _autoprefix2.default)({
    transition: 'opacity ' + duration / 1000 + 's ease-out'
  }), dimStyle, dimMode === 'transparent' && styles.dimTransparent, !isVisible && styles.dimHidden, isTransitionStarted && isVisible && styles.dimAppear, isTransitionStarted && !isVisible && styles.dimDisappear];
}

function getResizerStyles(position) {
  var resizerStyle = void 0;
  var size = 10;

  switch (position) {
    case 'left':
      resizerStyle = {
        right: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'right':
      resizerStyle = {
        left: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'top':
      resizerStyle = {
        bottom: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
    case 'bottom':
      resizerStyle = {
        top: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
  }

  return [styles.resizer, (0, _autoprefix2.default)(resizerStyle)];
}

function getFullSize(position, fullWidth, fullHeight) {
  return position === 'left' || position === 'right' ? fullWidth : fullHeight;
}

var Dock = (_temp = _class = function (_Component) {
  _inherits(Dock, _Component);

  function Dock(props) {
    _classCallCheck(this, Dock);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dock).call(this, props));

    _this.transitionEnd = function () {
      _this.setState({ isTransitionStarted: false });
    };

    _this.hideDim = function () {
      if (!_this.props.isVisible) {
        _this.setState({ isDimHidden: true });
      }
    };

    _this.handleDimClick = function () {
      if (_this.props.dimMode === 'opaque') {
        _this.props.onVisibleChange && _this.props.onVisibleChange(false);
      }
    };

    _this.handleResize = function () {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(_this.updateWindowSize.bind(_this, true));
      } else {
        _this.updateWindowSize(true);
      }
    };

    _this.updateWindowSize = function (windowResize) {
      var sizeState = {
        fullWidth: window.innerWidth,
        fullHeight: window.innerHeight
      };

      if (windowResize) {
        _this.setState(_extends({}, sizeState, {
          isResizing: true,
          isWindowResizing: windowResize
        }));

        _this.debouncedUpdateWindowSizeEnd();
      } else {
        _this.setState(sizeState);
      }
    };

    _this.updateWindowSizeEnd = function () {
      _this.setState({
        isResizing: false,
        isWindowResizing: false
      });
    };

    _this.debouncedUpdateWindowSizeEnd = (0, _lodash2.default)(_this.updateWindowSizeEnd, 30);

    _this.handleWrapperLeave = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseDown = function () {
      _this.setState({ isResizing: true });
    };

    _this.handleMouseUp = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseMove = function (e) {
      if (!_this.state.isResizing || _this.state.isWindowResizing) return;
      e.preventDefault();

      var _this$props = _this.props;
      var position = _this$props.position;
      var fluid = _this$props.fluid;
      var _this$state = _this.state;
      var fullWidth = _this$state.fullWidth;
      var fullHeight = _this$state.fullHeight;
      var isControlled = _this$state.isControlled;
      var x = e.clientX;
      var y = e.clientY;

      var size = void 0;

      switch (position) {
        case 'left':
          size = fluid ? x / fullWidth : x;
          break;
        case 'right':
          size = fluid ? (fullWidth - x) / fullWidth : fullWidth - x;
          break;
        case 'top':
          size = fluid ? y / fullHeight : y;
          break;
        case 'bottom':
          size = fluid ? (fullHeight - y) / fullHeight : fullHeight - y;
          break;
      }

      _this.props.onSizeChange && _this.props.onSizeChange(size);

      if (!isControlled) {
        _this.setState({ size: size });
      }
    };

    _this.state = {
      isControlled: typeof props.size !== 'undefined',
      size: props.size || props.defaultSize,
      isDimHidden: !props.isVisible,
      fullWidth: typeof window !== 'undefined' && window.innerWidth,
      fullHeight: typeof window !== 'undefined' && window.innerHeight,
      isTransitionStarted: false,
      isWindowResizing: false
    };
    return _this;
  }

  _createClass(Dock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('mouseup', this.handleMouseUp);
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('resize', this.handleResize);

      if (!window.fullWidth) {
        this.updateWindowSize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.handleMouseUp);
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isControlled = typeof nextProps.size !== 'undefined';

      this.setState({ isControlled: isControlled });

      if (isControlled && this.props.size !== nextProps.size) {
        this.setState({ size: nextProps.size });
      } else if (this.props.fluid !== nextProps.fluid) {
        this.updateSize(nextProps);
      }

      if (this.props.isVisible !== nextProps.isVisible) {
        this.setState({
          isTransitionStarted: true
        });
      }
    }
  }, {
    key: 'updateSize',
    value: function updateSize(props) {
      var _state = this.state;
      var fullWidth = _state.fullWidth;
      var fullHeight = _state.fullHeight;


      this.setState({
        size: props.fluid ? this.state.size / getFullSize(props.position, fullWidth, fullHeight) : getFullSize(props.position, fullWidth, fullHeight) * this.state.size
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.isVisible !== prevProps.isVisible) {
        if (!this.props.isVisible) {
          window.setTimeout(function () {
            return _this2.hideDim();
          }, this.props.duration);
        } else {
          this.setState({ isDimHidden: false });
        }

        window.setTimeout(function () {
          return _this2.setState({ isTransitionStarted: false });
        }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var zIndex = _props.zIndex;
      var dimMode = _props.dimMode;
      var position = _props.position;
      var isVisible = _props.isVisible;
      var _state2 = this.state;
      var isResizing = _state2.isResizing;
      var size = _state2.size;
      var isDimHidden = _state2.isDimHidden;


      var dimStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDimStyles(this.props, this.state))));
      var dockStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDockStyles(this.props, this.state))));
      var resizerStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getResizerStyles(position))));

      return _react2.default.createElement(
        'div',
        { style: Object.assign({}, styles.wrapper, { zIndex: zIndex }) },
        dimMode !== 'none' && !isDimHidden && _react2.default.createElement('div', { style: dimStyles, onClick: this.handleDimClick }),
        _react2.default.createElement(
          'div',
          { style: dockStyles },
          _react2.default.createElement('div', { style: resizerStyles,
            onMouseDown: this.handleMouseDown }),
          _react2.default.createElement(
            'div',
            { style: styles.dockContent },
            typeof children === 'function' ? children({
              position: position,
              isResizing: isResizing,
              size: size,
              isVisible: isVisible
            }) : children
          )
        )
      );
    }
  }]);

  return Dock;
}(_react.Component), _class.propTypes = {
  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
  zIndex: _propTypes2.default.number,
  fluid: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  defaultSize: _propTypes2.default.number,
  dimMode: _propTypes2.default.oneOf(['none', 'transparent', 'opaque']),
  isVisible: _propTypes2.default.bool,
  onVisibleChange: _propTypes2.default.func,
  onSizeChange: _propTypes2.default.func,
  dimStyle: _propTypes2.default.object,
  dockStyle: _propTypes2.default.object,
  duration: _propTypes2.default.number
}, _class.defaultProps = {
  position: 'left',
  zIndex: 99999999,
  fluid: true,
  defaultSize: 0.3,
  dimMode: 'opaque',
  duration: 200
}, _temp);
exports.default = Dock;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(220);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = autoprefix;
// Same as https://github.com/SimenB/react-vendor-prefixes/blob/master/src/index.js,
// but dumber

var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'appearance', 'backfaceVisibility', 'backgroundClip', 'borderImage', 'borderImageSlice', 'boxSizing', 'boxShadow', 'contentColumns', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction', 'perspective', 'perspectiveOrigin', 'userSelect'];

var prefixes = ['Moz', 'Webkit', 'ms', 'O'];

function prefixProp(key, value) {
  return prefixes.reduce(function (obj, pre) {
    return obj[pre + key[0].toUpperCase() + key.substr(1)] = value, obj;
  }, {});
}

function autoprefix(style) {
  return Object.keys(style).reduce(function (obj, key) {
    return vendorSpecificProperties.indexOf(key) !== -1 ? _extends({}, obj, prefixProp(key, style[key])) : obj;
  }, style);
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = reducer;

var _actions = __webpack_require__(72);

var _constants = __webpack_require__(71);

var _react = __webpack_require__(1);

function position(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultPosition;
  var action = arguments[2];

  return action.type === _actions.CHANGE_POSITION ? _constants.POSITIONS[(_constants.POSITIONS.indexOf(state) + 1) % _constants.POSITIONS.length] : state;
}

function size(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultSize;
  var action = arguments[2];

  return action.type === _actions.CHANGE_SIZE ? action.size : state;
}

function isVisible(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultIsVisible;
  var action = arguments[2];

  return action.type === _actions.TOGGLE_VISIBILITY ? !state : state;
}

function childMonitorStates(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var action = arguments[2];

  return _react.Children.map(props.children, function (child, index) {
    return child.type.update(child.props, state[index], action);
  });
}

function childMonitorIndex(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var action = arguments[2];

  switch (action.type) {
    case _actions.CHANGE_MONITOR:
      return (state + 1) % _react.Children.count(props.children);
    default:
      return state;
  }
}

function reducer(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments[2];

  if (!state.childMonitorStates) {
    _react.Children.forEach(props.children, function (child, index) {
      if (typeof child.type.update !== 'function') {
        console.error('Child of <DockMonitor> with the index ' + index + ' ' + ('(' + (child.type.displayName || child.type.name || child.type) + ') ') + 'does not appear to be a valid Redux DevTools monitor.');
      }
    });
  }

  return {
    position: position(props, state.position, action),
    isVisible: isVisible(props, state.isVisible, action),
    size: size(props, state.size, action),
    childMonitorIndex: childMonitorIndex(props, state.childMonitorIndex, action),
    childMonitorStates: childMonitorStates(props, state.childMonitorStates, action)
  };
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keycodes = __webpack_require__(224);

function assertKeyString(s) {
  if (!/^(ctrl-|shift-|alt-|meta-){0,4}\w+$/.test(s))
    throw new Error('The string to parse needs to be of the format "c", "ctrl-c", "shift-ctrl-c".');
}

module.exports = function parse(s) {
  var keyString = s.trim().toLowerCase();

  assertKeyString(keyString);

  var key = {
      name     :  undefined
    , ctrl     :  false
    , meta     :  false
    , shift    :  false
    , alt      :  false
    , sequence :  undefined
  }
  , parts = keyString.split('-')
  , c;

  key.name = parts.pop();
  while((c = parts.pop())) key[c] = true;
  key.sequence = key.ctrl 
    ? keycodes.ctrl[key.name] || key.name
    : keycodes.nomod[key.name] || key.name;

  // uppercase sequence for single chars when shift was pressed
  if (key.shift && key.sequence && key.sequence.length === 1)
    key.sequence = key.sequence.toUpperCase();

  return key;
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
// However where nodejs readline diverges, they are adjusted to conform to it
module.exports = {
  nomod: {
      escape: '\u001b'
    , space: ' ' // actually '\u0020'
    }
  , ctrl: {
        ' ': '\u0000'
      , 'a': '\u0001'
      , 'b': '\u0002'
      , 'c': '\u0003'
      , 'd': '\u0004'
      , 'e': '\u0005'
      , 'f': '\u0006'
      , 'g': '\u0007'
      , 'h': '\u0008'
      , 'i': '\u0009'
      , 'j': '\u000a'
      , 'k': '\u000b'
      , 'm': '\u000c'
      , 'n': '\u000d'
      , 'l': '\u000e'
      , 'o': '\u000f'
      , 'p': '\u0010'
      , 'q': '\u0011'
      , 'r': '\u0012'
      , 's': '\u0013'
      , 't': '\u0014'
      , 'u': '\u0015'
      , 'v': '\u0016'
      , 'w': '\u0017'
      , 'x': '\u0018'
      , 'y': '\u0019'
      , 'z': '\u001a'
      , '[': '\u001b'
      , '\\':'\u001c'
      , ']': '\u001d'
      , '^': '\u001e'
      , '_': '\u001f'

      , 'space': '\u0000'
    }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _Dispatcher = __webpack_require__(226);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dispatcher2.default;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getParams = __webpack_require__(227);

var _getParams2 = _interopRequireDefault(_getParams);

var _reduxDevtoolsThemes = __webpack_require__(57);

var themes = _interopRequireWildcard(_reduxDevtoolsThemes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  button: {
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '3px',
    padding: '3px',
    margin: '5px 3px',
    fontSize: '0.8em',
    textDecoration: 'none',
    border: 'none'
  },
  content: {
    margin: '5px',
    padding: '5px',
    borderRadius: '3px',
    outline: 'none',
    flex: '1 1 80%',
    overflow: 'auto'
  },
  label: {
    margin: '5px',
    padding: '5px',
    flex: '1 1 20%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    direction: 'rtl',
    textAlign: 'left'
  }
};

var Dispatcher = function (_Component) {
  _inherits(Dispatcher, _Component);

  function Dispatcher(props, context) {
    _classCallCheck(this, Dispatcher);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {
      selectedActionCreator: 'default',
      args: [],
      error: null
    };
    return _this;
  }

  Dispatcher.prototype.selectActionCreator = function selectActionCreator(e) {
    var selectedActionCreator = e.target.value;
    var args = [];
    if (selectedActionCreator !== 'default') {
      // Shrink the number args to the number of the new ones
      args = this.state.args.slice(0, this.getActionCreators()[selectedActionCreator].args.length);
    }
    this.setState({
      selectedActionCreator: selectedActionCreator,
      args: args
    });
  };

  Dispatcher.prototype.handleArg = function handleArg(e, argIndex) {
    var args = [].concat(this.state.args.slice(0, argIndex), [this.refs['arg' + argIndex].textContent], this.state.args.slice(argIndex + 1));
    this.setState({ args: args });
  };

  Dispatcher.prototype.launchAction = function launchAction() {
    try {
      var actionCreator = function actionCreator() {
        return {};
      },
          argsToInject = [];
      if (this.state.selectedActionCreator !== 'default') {
        actionCreator = this.getSelectedActionCreator().func;

        var interpretArg = function interpretArg(arg) {
          return new Function('return ' + arg)();
        };
        argsToInject = this.state.args.map(interpretArg);
        var rest = interpretArg(this.refs.restArgs.textContent);
        if (rest) {
          var _argsToInject;

          if (Array.isArray(rest)) argsToInject = (_argsToInject = argsToInject).concat.apply(_argsToInject, rest);else throw new Error('rest must be an array');
        }
      } else {
        actionCreator = new Function('return ' + this.refs.action.textContent);
      }

      (this.props.dispatchFn || this.context.store.dispatch)(actionCreator.apply(undefined, argsToInject));

      this.setState({ error: null });
    } catch (e) {
      this.setState({ error: e.message });
    }
  };

  Dispatcher.prototype.componentDidMount = function componentDidMount() {
    this.resetCustomAction();
  };

  Dispatcher.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedActionCreator === 'default' && prevState.selectedActionCreator !== 'default') {
      this.resetCustomAction();
    }
  };

  Dispatcher.prototype.resetCustomAction = function resetCustomAction() {
    this.refs.action.innerHTML = this.props.initEmpty ? '<br/>' : '{<br/>type: ""<br/>}';
  };

  Dispatcher.prototype.getSelectedActionCreator = function getSelectedActionCreator() {
    return this.getActionCreators()[this.state.selectedActionCreator];
  };

  Dispatcher.prototype.getActionCreators = function getActionCreators() {
    var actionCreators = this.props.actionCreators;


    if (Array.isArray(actionCreators)) {
      return actionCreators;
    }

    var flatTree = function flatTree(object) {
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var functions = [];
      for (var propertyName in object) {
        var prop = object[propertyName];
        if (object.hasOwnProperty(propertyName)) {
          if (typeof prop === "function") {
            functions.push({
              name: namespace + (propertyName || prop.name || 'anonymous'),
              func: prop,
              args: (0, _getParams2.default)(prop)
            });
          } else if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === "object") {
            functions = functions.concat(flatTree(prop, namespace + propertyName + '.'));
          }
        }
      }
      return functions;
    };

    return flatTree(actionCreators);
  };

  Dispatcher.prototype.getTheme = function getTheme() {
    var theme = this.props.theme;

    if (typeof theme !== 'string') {
      return theme;
    }

    if (typeof themes[theme] !== 'undefined') {
      return themes[theme];
    }

    console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
    return themes.nicinabox;
  };

  Dispatcher.prototype.render = function render() {
    var _this2 = this;

    var theme = this.getTheme(),
        contentEditableStyle = _extends({}, styles.content, { color: theme.base06, backgroundColor: theme.base00 }),
        buttonStyle = _extends({}, styles.button, { color: theme.base06, backgroundColor: theme.base00 }),
        actionCreators = this.getActionCreators();

    var fields = _react2.default.createElement('div', { contentEditable: true, style: contentEditableStyle, ref: 'action' });
    if (this.state.selectedActionCreator !== 'default') {
      var fieldStyles = _extends({}, styles.label, { color: theme.base06 });
      fields = this.getSelectedActionCreator().args.map(function (param, i) {
        return _react2.default.createElement(
          'div',
          { key: i, style: { display: 'flex' } },
          _react2.default.createElement(
            'span',
            { style: fieldStyles },
            param
          ),
          _react2.default.createElement('div', { contentEditable: true, style: contentEditableStyle, ref: 'arg' + i, onInput: function onInput(e) {
              return _this2.handleArg(e, i);
            } })
        );
      });
      fields.push(_react2.default.createElement(
        'div',
        { key: 'action', style: { display: 'flex' } },
        _react2.default.createElement(
          'span',
          { style: fieldStyles },
          'rest...'
        ),
        _react2.default.createElement('div', { contentEditable: true, style: contentEditableStyle, ref: 'restArgs' })
      ));
    }

    var error = '';
    if (this.state.error) {
      error = _react2.default.createElement(
        'div',
        { style: { color: theme.base06, background: '#FC2424', padding: '5px', display: 'flex' } },
        _react2.default.createElement(
          'div',
          { style: { flex: '1', alignItems: 'center' } },
          _react2.default.createElement(
            'p',
            { style: { margin: '0px' } },
            this.state.error
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { alignItems: 'center' } },
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.setState({ error: null });
              }, style: _extends({}, buttonStyle, { margin: '0', background: '#DC2424' }) },
            '\xD7'
          )
        )
      );
    }

    var dispatchButtonStyle = buttonStyle;
    if (actionCreators.length <= 0) {
      dispatchButtonStyle = _extends({}, buttonStyle, {
        position: 'absolute',
        bottom: '3px',
        right: '5px',
        background: theme.base02
      });
    }

    var dispatchButton = _react2.default.createElement(
      'button',
      { style: dispatchButtonStyle, onClick: this.launchAction.bind(this) },
      'Dispatch'
    );

    return _react2.default.createElement(
      'div',
      { style: { background: theme.base02, fontFamily: 'monaco,Consolas,Lucida Console,monospace', position: 'relative' } },
      error,
      fields,
      actionCreators.length > 0 ? _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
          'select',
          { onChange: this.selectActionCreator.bind(this), style: { flex: '1', fontFamily: 'inherit' }, defaultValue: this.state.selectedActionCreator || 'default' },
          _react2.default.createElement(
            'option',
            { value: 'default' },
            'Custom action'
          ),
          actionCreators.map(function (_ref, i) {
            var name = _ref.name,
                func = _ref.func,
                args = _ref.args;
            return _react2.default.createElement(
              'option',
              { key: i, value: i },
              name + '(' + args.join(', ') + ')'
            );
          })
        ),
        dispatchButton
      ) : dispatchButton
    );
  };

  return Dispatcher;
}(_react.Component);

Dispatcher.contextTypes = {
  store: _propTypes2.default.object
};
Dispatcher.propTypes = {
  dispatch: _propTypes2.default.func,
  computedStates: _propTypes2.default.array,
  actionsById: _propTypes2.default.object,
  stagedActionIds: _propTypes2.default.array,
  skippedActionIds: _propTypes2.default.array,
  monitorState: _propTypes2.default.shape({
    initialScrollTop: _propTypes2.default.number
  }),

  initEmpty: _propTypes2.default.bool,
  actionCreators: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  dispatchFn: _propTypes2.default.func,
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
};
Dispatcher.defaultProps = {
  theme: 'nicinabox',
  initEmpty: false,
  actionCreators: {}
};

Dispatcher.update = function () {};

exports.default = Dispatcher;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

/* global window */
var GetParams = function (func) {
	'use strict';

	if (typeof func !== 'function') {
		return [];
	}

	var patternComments = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var patternArguments = /([^\s,]+)/g;

	var funcString = func
		.toString()
		.replace(patternComments, '');

	var result = funcString
		.slice(
			funcString.indexOf('(') + 1,
			funcString.indexOf(')')
		)
		.match(patternArguments);

	if (result === null) {
		return [];
	}

	return result;
};

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	module.exports = GetParams;
}

if (typeof window !== 'undefined') {
	window.GetParams = GetParams;
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _MultipleMonitors = __webpack_require__(229);

var _MultipleMonitors2 = _interopRequireDefault(_MultipleMonitors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultipleMonitors2.default;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function childrenMonitorState(props, state, action) {
  return props.children.map(function (child) {
    return child.type.update(child.props, state, action);
  });
}

function reducer(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var action = arguments[2];

  return {
    childrenMonitorState: childrenMonitorState(props, state.childMonitorState, action)
  };
}

var defaultStyle = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
};

var MultipleMonitors = function (_Component) {
  _inherits(MultipleMonitors, _Component);

  function MultipleMonitors(props, context) {
    _classCallCheck(this, MultipleMonitors);

    return _possibleConstructorReturn(this, _Component.call(this, props, context));
  }

  MultipleMonitors.prototype.render = function render() {
    var _props = this.props;
    var monitorState = _props.monitorState;
    var children = _props.children;
    var _props$style = _props.style;
    var style = _props$style === undefined ? defaultStyle : _props$style;

    var rest = _objectWithoutProperties(_props, ['monitorState', 'children', 'style']);

    var monitors = children.map(function (e, i) {
      return (0, _react.cloneElement)(e, _extends({}, rest, {
        monitorState: monitorState.childrenMonitorState[i],
        key: 'monitor' + i
      }));
    });

    return _react2.default.createElement(
      'div',
      { style: style },
      monitors
    );
  };

  return MultipleMonitors;
}(_react.Component);

MultipleMonitors.update = reducer;
exports.default = MultipleMonitors;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiShell = __webpack_require__(17);

var Actions = _interopRequireWildcard(__webpack_require__(73));

var _analytics = __webpack_require__(12);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAppDimensions = function getAppDimensions(state) {
  return {// things to track, such as user id, listing id, listing name and compnay uuid.
    // Pull them in from state.
  };
};

var interactionEventActions = _defineProperty({}, Actions.ANALYTICS_INTERACTION_EVENT, function (_ref) {
  var payload = _ref.payload;
  return _objectSpread({}, payload);
});

var _default = _nuiShell.analyticsEvents.createMapStateToAnalytics({
  applicationName: _analytics.APPLICATION_NAME,
  getAppDimensions: getAppDimensions,
  interactionEventActions: interactionEventActions
});

exports.default = _default;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1371);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WrapperChooser = exports.ROUTES = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _reactRouter = __webpack_require__(8);

var _nuiShell = __webpack_require__(17);

var _Errors = __webpack_require__(233);

var _wwwWrapperCom = _interopRequireDefault(__webpack_require__(234));

var _nuiIntl = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var httpCodes = _interopRequireWildcard(__webpack_require__(235));

var _App = _interopRequireDefault(__webpack_require__(236));

var _listings = _interopRequireDefault(__webpack_require__(239));

var _listing = _interopRequireDefault(__webpack_require__(252));

var _SearchContainer = _interopRequireDefault(__webpack_require__(275));

var _TermsPage = _interopRequireDefault(__webpack_require__(276));

var _utils = __webpack_require__(4);

var _utilsModule = __webpack_require__(38);

var _HelpContainer = _interopRequireDefault(__webpack_require__(277));

var _config = _interopRequireDefault(__webpack_require__(13));

var _NotFoundRedirect = _interopRequireDefault(__webpack_require__(286));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ROUTES = {
  US_PUBLIC: '/app-center',
  EU_PUBLIC: '/app-centre'
}; // silly little thing to let us use the in-product or public header and footer

exports.ROUTES = ROUTES;

var WrapperChooser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WrapperChooser, _React$Component);

  function WrapperChooser(props) {
    var _this;

    _classCallCheck(this, WrapperChooser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WrapperChooser).call(this, props));
    var code = (0, _utils.getCountryCode)(props.meta.originalhost);
    props.setCountryCode(code);
    return _this;
  }

  _createClass(WrapperChooser, [{
    key: "render",
    value: function render() {
      var usePublicWrapper = (0, _utils.isPublic)(this.props.location.pathname);

      if (usePublicWrapper) {
        var nuiLangToUse = (0, _utils.getNuiLanguage)(this.props.meta.originalhost);
        var publicLangToUse = (0, _utils.mapCountryToPublicLang)(this.props.meta.country || 'US');
        var localeData = (0, _nuiIntl.getLocaleData)(this.props);
        localeData.lang = nuiLangToUse; // eslint-disable-next-line import/no-dynamic-require, global-require

        var translations = window.NUI_TRANSLATIONS;

        return !this.props.meta.listingNotFound ? _react.default.createElement(_wwwWrapperCom.default, {
          lang: publicLangToUse
        }, _react.default.createElement(_nuiIntl.default, {
          messages: translations,
          localeData: localeData
        }, this.props.children)) : _react.default.createElement(_NotFoundRedirect.default, null);
      }

      return _react.default.createElement(_nuiShell.NuiPageContainer, null, this.props.meta.listingNotFound ? _react.default.createElement(_Errors.ErrorPage, null, _react.default.createElement(_Errors.NotFound, null)) : this.props.children);
    }
  }]);

  return WrapperChooser;
}(_react.default.Component);

exports.WrapperChooser = WrapperChooser;
WrapperChooser.propTypes = {
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string,
    country: _propTypes.default.string,
    listingFound: _propTypes.default.bool
  }),
  setCountryCode: _propTypes.default.func
};

function mapStateToProps(_ref) {
  var baseUrl = _ref.baseUrl,
      userPrefs = _ref.userPrefs,
      nuiPage = _ref.nuiPage,
      meta = _ref.meta;
  return {
    baseUrl: baseUrl,
    userPrefs: userPrefs,
    nuiPage: nuiPage,
    meta: meta
  };
}

var RRWrapperChooser = (0, _reactRedux.connect)(mapStateToProps, {
  setCountryCode: _utilsModule.setCountryCode
})((0, _reactRouter.withRouter)(WrapperChooser));
var commonRoutes = [_react.default.createElement(_reactRouter.IndexRoute, {
  component: _listings.default,
  key: "Listings"
}), _react.default.createElement(_reactRouter.Route, {
  path: "listings/:id",
  component: _listing.default,
  key: "Listing"
}), _react.default.createElement(_reactRouter.Route, {
  path: "listings/:id/:name",
  component: _listing.default,
  key: "ListingsName"
}), _react.default.createElement(_reactRouter.Redirect, {
  from: "listing/:id/:name",
  to: "listings/:id/:name",
  key: "listingRedirect"
}), _react.default.createElement(_reactRouter.Route, {
  path: "category/:category",
  component: _listings.default,
  key: "Category"
}), _react.default.createElement(_reactRouter.Route, {
  path: "search/:term",
  component: _SearchContainer.default,
  key: "Search"
}), _react.default.createElement(_reactRouter.Route, {
  path: "terms/:name",
  component: _TermsPage.default,
  key: "Terms"
}), _react.default.createElement(_reactRouter.Route, {
  path: "help",
  component: _HelpContainer.default,
  key: "Help"
})];
/* const public404 = (<Route
  path="*" onEnter={(nextState, replace) => {
    replace('/404');
  }}
/>); */

var commonWrapperRoute = _react.default.createElement(_reactRouter.Route, {
  component: RRWrapperChooser
}, _react.default.createElement(_reactRouter.Route, {
  component: _App.default
}, commonRoutes));

var public404 = _react.default.createElement(_reactRouter.Route, {
  path: "*",
  status: httpCodes.NOT_FOUND,
  component: _NotFoundRedirect.default
});

var publicRoute = _react.default.createElement("div", null, commonWrapperRoute, public404);

var _default = _react.default.createElement(_reactRouter.Route, null, _react.default.createElement(_reactRouter.Route, {
  path: _config.default.nui.baseUrl
}, commonWrapperRoute), _react.default.createElement(_reactRouter.Route, {
  path: ROUTES.US_PUBLIC,
  isAnonymous: true
}, publicRoute), _react.default.createElement(_reactRouter.Route, {
  path: ROUTES.EU_PUBLIC,
  isAnonymous: true
}, publicRoute));

exports.default = _default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(712);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(718);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1893);

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactHelmet = _interopRequireDefault(__webpack_require__(20));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _AppContext = __webpack_require__(74);

var _utils = __webpack_require__(4);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(237) : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(238) : void 0;

var _userProfileModule = __webpack_require__(24);

var _utilsModule = __webpack_require__(38);

var _listingsModule = __webpack_require__(10);

var _listingModule = __webpack_require__(6);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var urlToLang = function urlToLang(url) {
  return (0, _utils.mapCountryToPublicLang)((0, _utils.getCountryCode)(url));
};

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));
    props.isAppCenterEnabledCheck();
    props.setIsPublic((0, _utils.isPublic)(props.location.pathname));
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _utils.canUseDOM)() && (0, _utils.isPublic)(this.props.location.pathname)) {
        if (window.utag_data) {
          window.site_regional = urlToLang(this.props.meta.originalhost);
        }
      }

      this.loadTrustArcScript();
    }
  }, {
    key: "loadTrustArcScript",
    value: function loadTrustArcScript() {
      var script = document.createElement('script');
      script.src = '//consent.trustarc.com/notice?domain=concur.com&c=teconsent&js=nj&noticeType=bb&text=true';
      script.async = true;
      var footerElement = document.getElementById('teconsent');
      footerElement.appendChild(script);
      this.props.fetchListingsIfNeeded();
      this.props.fetchLocalizedRegions();
      this.props.fetchLocalizedCountries();
      this.props.fetchCategoriesIfNeeded();
    }
  }, {
    key: "render",
    value: function render() {
      var style = {};
      var scripts = [];
      var title = 'App Center';
      var links = [{
        href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css',
        rel: 'stylesheet',
        type: 'text/css'
      }]; // TODO: figure out why the details page won't update canonical, then re-enable

      if ((0, _utils.isPublic)(this.props.location.pathname)) {
        title = 'SAP Concur App Center';
        style.backgroundColor = '#efefef';
        scripts = [{
          src: '//code.jquery.com/jquery-1.12.4.min.js',
          type: 'text/javascript'
        }];

        function getCookie(name) {
          var re = new RegExp("".concat(name, "=([^;]+)"));
          var value = re.exec(document.cookie);
          return value != null ? unescape(value[1]) : null;
        }

        if ((0, _utils.canUseDOM)()) {
          if (typeof getCookie('notice_preferences') === 'undefined' || getCookie('notice_preferences') == null || getCookie('notice_preferences') !== '0:') {
            scripts.push({
              src: '//static.concursolutions.com/nui/appcenter/static/omniture.bundle.f4e88b342e6ff25c6df3.js',
              type: 'text/javascript'
            });
          }
        }

        if (this.props.meta.originalhost) {
          links.push({
            rel: 'canonical',
            href: "".concat((0, _utils.getCanonicalLink)(this.props.meta.originalhost, this.props.location.pathname))
          });
        }

        links.push({
          rel: 'shortcut icon',
          href: '//www.concur.com/sites/all/themes/concur7/favicon.ico',
          type: 'image/png'
        });
        (0, _utils.getHreflangLinks)(links);
      }

      var context = {
        userProfile: this.props.userProfile,
        isPublic: (0, _utils.isPublic)(this.props.location.pathname),
        getTitle: function getTitle(newTitle) {
          if (newTitle !== _utils.HOME) {
            return "".concat(newTitle, " - ").concat(title);
          }

          return title;
        }
      };
      return _react.default.createElement("div", {
        id: "app",
        style: style
      }, _react.default.createElement(_AppContext.AppContext.Provider, {
        value: context
      }, _react.default.createElement(_reactHelmet.default, {
        htmlAttributes: {
          lang: (0, _utils.getNuiLanguage)(this.props.meta.originalhost)
        },
        title: title,
        meta: [{
          'char-set': 'utf-8'
        }, {
          name: 'application-name',
          content: this.props.formatter.formattedMessage({
            id: 'AppCenterHeader'
          })
        }, {
          name: 'description',
          content: this.props.formatter.formattedMessage({
            id: 'MetaDescription'
          })
        }, {
          name: 'keywords',
          content: 'Concur App Center, App Center'
        }, {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1'
        }],
        script: scripts,
        link: links
      }), _react.default.createElement("div", {
        className: "route-content ".concat((0, _utils.isPublic)(this.props.location.pathname) ? 'public-content container' : ''),
        style: {
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
        }
      }, this.props.children)));
    }
  }]);

  return App;
}(_react.Component); // We don't own location, formatter, or userProfile so we shouldn't define the shape.
// Ideally the react-router and nui-intl packages would expose the shape and we could consume it.


App.propTypes = {
  children: _propTypes.default.node,
  isAppCenterEnabledCheck: _propTypes.default.func.isRequired,
  setIsPublic: _propTypes.default.func.isRequired,
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string
  }),
  userProfile: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProfile: state.userProfile,
    meta: state.meta
  };
};

var mapDispatchToProps = {
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck,
  setIsPublic: _utilsModule.setIsPublic,
  fetchListingsIfNeeded: _listingsModule.fetchListingsIfNeeded,
  fetchLocalizedRegions: _listingModule.fetchLocalizedRegions,
  fetchLocalizedCountries: _listingModule.fetchLocalizedCountries,
  fetchCategoriesIfNeeded: _listingsModule.fetchCategoriesIfNeeded
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nuiIntl.withFormatter)(App));

exports.default = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ListingsContainer = _interopRequireDefault(__webpack_require__(240));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ListingsContainer.default;
exports.default = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = _interopRequireWildcard(__webpack_require__(3));

var _get2 = _interopRequireDefault(__webpack_require__(22));

var ListingsActions = _interopRequireWildcard(__webpack_require__(10));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(241) : void 0;

var _Header = _interopRequireDefault(__webpack_require__(27));

var _CommonSections = _interopRequireDefault(__webpack_require__(75));

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Home =
/*#__PURE__*/
function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, _getPrototypeOf(Home).apply(this, arguments));
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');
      if (categorySlug) this.props.setCategorySlug(categorySlug);

      if (this.props.context.isPublic && (0, _utils.canUseDOM)() && window.utag) {
        (0, _utils.sendPublicView)();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');

      if (categorySlug) {
        if (this.props.listings.categories.length > 0) {
          var isValidCategory = this.props.listings.categories.some(function (category) {
            var subCategoryMatch = false;

            if (category.subcategories.length > 0) {
              subCategoryMatch = category.subcategories.some(function (subCategory) {
                return subCategory.slug.toLowerCase() === categorySlug.toLowerCase();
              });
            }

            return subCategoryMatch || category.slug.toLowerCase() === categorySlug.toLowerCase();
          });
          if (!isValidCategory) window.location = '/404';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var localeData = (0, _nuiIntl.getLocaleData)(this.props);

      var translations = window.NUI_TRANSLATIONS; // eslint-disable-line global-require, import/no-dynamic-require


      return _react.default.createElement(_nuiIntl.default, {
        messages: translations,
        localeData: localeData
      }, _react.default.createElement("div", null, _react.default.createElement(_Header.default, {
        enableLiveSearch: true
      }), _react.default.createElement(_CommonSections.default, {
        enableLiveUpdate: true
      })));
    }
  }]);

  return Home;
}(_react.Component);

Home.propTypes = {
  listings: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  setCategorySlug: _propTypes.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  setCategorySlug: ListingsActions.setCategorySlug
})(Home));

exports.default = _default;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _reactRouter = __webpack_require__(8);

var _utils = __webpack_require__(4);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(243) : void 0;

var _trackClick = _interopRequireDefault(__webpack_require__(11));

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var extractValue = function extractValue(cb, e) {
  cb(e.target.value);
};

var SearchBar =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (e) {
      e.preventDefault();

      if (!_this.props.search) {
        return;
      }

      document.title = _this.props.context.getTitle("Search: ".concat(_this.props.search));

      _this.props.router.push("".concat((0, _utils.getAppCenterPathName)(_this.props.location.pathname), "/search/").concat(encodeURIComponent(_this.props.search)));

      _this.props.filterApps();
    });

    return _this;
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          search = _this$props.search,
          onChange = _this$props.onChange,
          router = _this$props.router,
          location = _this$props.location,
          host = _this$props.host,
          formatter = _this$props.formatter;
      var TrackedButton = (0, _trackClick.default)(_react.default.createElement("button", {
        id: "ac-search-btn",
        className: "btn btn-lg btn-default search-btn-spacing"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Search"
      })), 'CLICK', {
        context: router.location.pathname === "".concat((0, _utils.getAppCenterPathName)(location.pathname)) ? 'HOME' : 'LISTING_DETAILS',
        type: 'BUTTON',
        value: 'SEARCH',
        searchKeyword: search,
        domain: {
          host: host
        }
      });
      return _react.default.createElement("div", {
        className: "search-bar-container"
      }, _react.default.createElement("form", {
        onSubmit: this.handleSearch
      }, _react.default.createElement("input", {
        className: "ac-search-bar form-control input-lg",
        placeholder: formatter.formattedMessage({
          id: 'FindApps'
        }),
        value: search,
        type: "text",
        onChange: extractValue.bind(undefined, onChange)
      }), _react.default.createElement(TrackedButton, null)));
    }
  }]);

  return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
  search: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  filterApps: _propTypes.default.func.isRequired,
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  host: _propTypes.default.string,
  formatter: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};

function mapStateToProps(state) {
  return {
    host: state.meta.host
  };
}

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _nuiIntl.withFormatter)((0, _reactRedux.connect)(mapStateToProps, {})(SearchBar))));

exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategoryMenu = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactRouter = __webpack_require__(8);

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _nuiWidgets = __webpack_require__(28);

var _utils = __webpack_require__(4);

var _analytics = __webpack_require__(12);

var ListingsActions = _interopRequireWildcard(__webpack_require__(10));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var defaultCategory = {
  slug: 'all',
  code: 'ALL_APPS',
  description: 'All Apps'
};
var ACTION_POP = 'POP';

var CategoryMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CategoryMenu, _React$Component);

  function CategoryMenu(props) {
    var _this;

    _classCallCheck(this, CategoryMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryMenu).call(this, props));
    _this.handleLinkClick = _this.handleLinkClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CategoryMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.backListenerCallback = function (location) {
        if (location.action === ACTION_POP) {
          var pathname = _this2.props.location.pathname;
          var slug = pathname.substr(pathname.lastIndexOf('/') + 1); // not logged in uses app-center, logged in uses appcenter

          if (slug === 'app-center' || slug === 'appcenter') {
            slug = 'all';
          }

          _this2.props.categories.map(function (category) {
            if (category.slug === slug) {
              _this2.props.setCategory(category);

              return;
            }

            category.subcategories.map(function (subcategory) {
              if (subcategory.slug === slug) {
                _this2.props.setCategory(subcategory);
              }
            });
          });
        }
      };

      this.backListener = _reactRouter.browserHistory.listen(this.backListenerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Unbind listener
      this.backListener();
    }
  }, {
    key: "handleLinkClick",
    value: function handleLinkClick(category) {
      var _this$props = this.props,
          router = _this$props.router,
          location = _this$props.location,
          setAndFilterByCategory = _this$props.setAndFilterByCategory,
          trackCategoryLinkClick = _this$props.trackCategoryLinkClick,
          companyUUID = _this$props.companyUUID;
      var pathname = (0, _utils.getAppCenterPathName)(location.pathname);
      var categoryRoute = "".concat(pathname, "/category/").concat(category.slug);
      var context = router.location.pathname === pathname ? _analytics.CONTEXTS.HOME : _analytics.CONTEXTS.LISTING_DETAILS;
      setAndFilterByCategory(category);
      router.push(categoryRoute); // track clicks

      if (typeof caLogger !== 'undefined') {
        caLogger.track(_analytics.EVENTS.CLICK, {
          context: context,
          type: _analytics.TYPES.LINK,
          value: _analytics.VALUES.CATEGORY,
          category: category.description,
          domain: window.location.hostname
        });
      }

      trackCategoryLinkClick({
        elementPath: [_analytics.categoryDropdown, category.slug],
        dimensions: {
          category: category.slug,
          companyUUID: companyUUID
        }
      });
    }
  }, {
    key: "renderCategories",
    value: function renderCategories() {
      var _this3 = this;

      var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isChildren = arguments.length > 1 ? arguments[1] : undefined;
      var _this$props$category = this.props.category,
          currentCategory = _this$props$category === void 0 ? defaultCategory : _this$props$category;
      return categories.reduce(function (items, category) {
        items.push(_react.default.createElement(_nuiWidgets.MenuItem, {
          key: category.code,
          eventKey: category,
          active: currentCategory.code === category.code,
          className: isChildren && 'subcategories'
        }, category.description));

        if (category.subcategories) {
          return items.concat(_this3.renderCategories(category.subcategories, true));
        }

        return items;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          formatter = _this$props2.formatter,
          categories = _this$props2.categories,
          category = _this$props2.category,
          display = _this$props2.display;
      var label = "".concat(formatter.formattedMessage({
        id: 'Category'
      }), ":");
      return display ? _react.default.createElement(_nuiWidgets.ButtonToolbar, {
        muted: true,
        style: {
          paddingTop: '4px',
          paddingBottom: '6px'
        }
      }, _react.default.createElement(_nuiWidgets.ButtonDropdown, {
        id: "categoryDropdown",
        type: "link",
        textLabel: label,
        title: category === undefined ? categories[0].description : category.description,
        onSelect: this.handleLinkClick
      }, this.renderCategories(categories))) : _react.default.createElement("br", null);
    }
  }]);

  return CategoryMenu;
}(_react.default.Component);

exports.CategoryMenu = CategoryMenu;
CategoryMenu.propTypes = {
  setAndFilterByCategory: _propTypes.default.func.isRequired,
  categories: _propTypes.default.arrayOf(_propTypes.default.object),
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  display: _propTypes.default.bool,
  category: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  trackCategoryLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  listingName: _propTypes.default.string
};

function mapStateToProps(state) {
  return {};
}

var mapDispatchToProps = {
  setCategory: ListingsActions.setCategory
};

var _default = (0, _nuiIntl.withFormatter)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoryMenu)));

exports.default = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(485);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactRouter = __webpack_require__(8);

var _reactSlick = _interopRequireDefault(__webpack_require__(248));

var _MiniListing = _interopRequireDefault(__webpack_require__(249));

var _trackClick = _interopRequireDefault(__webpack_require__(11));

var _utils = __webpack_require__(4);

var _Arrow = _interopRequireDefault(__webpack_require__(251));

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppCategory =
/*#__PURE__*/
function (_Component) {
  _inherits(AppCategory, _Component);

  function AppCategory(props) {
    var _this;

    _classCallCheck(this, AppCategory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppCategory).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "renderListings", function () {
      var sliderFeaturesVisibility = _this.getSliderVisibility();

      var variableMargins = sliderFeaturesVisibility ? '' : 'no-side-margins';
      var sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        lazyLoad: false,
        responsive: [{
          breakpoint: 530,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 980,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }, {
          breakpoint: 10000,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }],
        className: "slider-row ".concat(variableMargins),
        dotsClass: "".concat(sliderFeaturesVisibility ? 'ac-listings-slider-dots' : 'hidden'),
        draggable: true
      };
      return _react.default.createElement("div", {
        className: "collection-row"
      }, _react.default.createElement(_reactSlick.default, sliderSettings, _this.props.listings.map(function (listing, i) {
        var TrackedListing = (0, _trackClick.default)(_react.default.createElement(_MiniListing.default, {
          listing: listing,
          isLoggedIn: _this.props.isLoggedIn
        }), 'CLICK', {
          context: 'HOME',
          type: 'LISTING',
          v2_listing_id: listing.ID,
          app_name: listing.core.listingName,
          domain: window.location.hostname
        });
        var listingLink = "".concat((0, _utils.getAppCenterPathName)(_this.props.location.pathname), "/listings/").concat(listing.ID);
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRouter.Link, {
          key: i,
          to: listingLink,
          "data-analytics": "ec=".concat(listing.localized.name, "\n                |ea=ViewDetails\n                |dp=Home\n                |dt=AppCenterHome\n                |cd2=nui"),
          onClick: function onClick() {
            return document.title = _this.props.context.getTitle(listing.localized.name);
          }
        }, _react.default.createElement(TrackedListing, {
          style: {
            display: 'inline-block'
          }
        })));
      })));
    });

    _this.state = {
      width: 0,
      height: 0
    };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AppCategory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
  }, {
    key: "getSliderVisibility",
    value: function getSliderVisibility() {
      var sliderFeaturesVisibility = false;

      if (this.props.listings.length > 6 && this.state.width > 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 5 && this.state.width > 980 && this.state.width <= 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 4 && this.state.width > 768 && this.state.width <= 980) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 2 && this.state.width <= 768) {
        sliderFeaturesVisibility = true;
      }

      return sliderFeaturesVisibility;
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(prevNext, isVisible) {
      return _react.default.createElement(_Arrow.default, {
        direction: prevNext,
        areSlideFeaturesVisible: isVisible ? '' : 'hidden'
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.listings.length === 0) return null;
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-12"
      }, _react.default.createElement("h2", {
        className: "collection-title"
      }, this.props.categoryTitle), _react.default.createElement("p", {
        className: "collection-description"
      }, this.props.categorySubtitle))), this.renderListings());
    }
  }]);

  return AppCategory;
}(_react.Component);

AppCategory.propTypes = {
  categoryTitle: _propTypes.default.any.isRequired,
  categorySubtitle: _propTypes.default.any.isRequired,
  listings: _propTypes.default.array.isRequired,
  isLoggedIn: _propTypes.default.bool.isRequired,
  location: _propTypes.default.object
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRouter.withRouter)(AppCategory));

exports.default = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1355);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _nuiIntl = __webpack_require__(3);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(250) : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://eng.wealthfront.com/2015/06/30/implementing-netflix-redesign/
// If we want slide: http://codepen.io/dangvanthanh/pen/BsDbg
// more slide: http://jsfiddle.net/jkneb/9uRKt/
var MiniListing = function MiniListing(_ref) {
  var listing = _ref.listing,
      isLoggedIn = _ref.isLoggedIn;
  var miniImage = listing.images.miniImage,
      _listing$localized = listing.localized,
      name = _listing$localized.name,
      summary = _listing$localized.summary,
      title = _listing$localized.title,
      _listing$core = listing.core,
      isUserConnected = _listing$core.isUserConnected,
      icon = _listing$core.icon;
  return _react.default.createElement("div", {
    className: "mini-listing"
  }, _react.default.createElement("img", {
    src: icon || miniImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg',
    className: "card-image",
    alt: "".concat(name, " icon")
  }), _react.default.createElement("div", {
    className: "card-text card-title"
  }, name), !isUserConnected ? _react.default.createElement("div", {
    className: "card-text card-headline"
  }, title) : null, isLoggedIn && isUserConnected ? _react.default.createElement("span", {
    className: "is-connected-check"
  }, _react.default.createElement("span", {
    className: "is-connected-check-details icon-check icon-size-sm"
  }), "\xA0", _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Connected"
  })) : null, _react.default.createElement("div", {
    className: "overlay"
  }, summary));
};

MiniListing.propTypes = {
  listing: _propTypes.default.object.isRequired,
  isLoggedIn: _propTypes.default.bool
};
var _default = MiniListing;
exports.default = _default;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Arrow = function Arrow(_ref) {
  var direction = _ref.direction,
      onClick = _ref.onClick,
      areSlideFeaturesVisible = _ref.areSlideFeaturesVisible;
  var arrowIconDirection = direction === 'next' ? 'icon-arrow-2-e' : 'icon-arrow-2-w';
  return _react.default.createElement("div", {
    onClick: onClick,
    className: "ac-collection-".concat(direction, " ").concat(areSlideFeaturesVisible, " ").concat(arrowIconDirection)
  });
};

Arrow.propTypes = {
  direction: _propTypes.default.string,
  onClick: _propTypes.default.func,
  areSlideFeaturesVisible: _propTypes.default.string
};
var _default = Arrow;
exports.default = _default;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ListingContainer = _interopRequireDefault(__webpack_require__(253));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ListingContainer.default;
exports.default = _default;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactHelmet = _interopRequireDefault(__webpack_require__(20));

var _reactRedux = __webpack_require__(5);

var _reactRouter = __webpack_require__(8);

var _has2 = _interopRequireDefault(__webpack_require__(25));

var listingActions = _interopRequireWildcard(__webpack_require__(6));

var termsActions = _interopRequireWildcard(__webpack_require__(14));

var _ListingDetails = _interopRequireDefault(__webpack_require__(254));

var _userProfileModule = __webpack_require__(24);

var _Header = _interopRequireDefault(__webpack_require__(27));

var _LoadingIndicator = _interopRequireDefault(__webpack_require__(76));

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Listing =
/*#__PURE__*/
function (_Component) {
  _inherits(Listing, _Component);

  function Listing() {
    _classCallCheck(this, Listing);

    return _possibleConstructorReturn(this, _getPrototypeOf(Listing).apply(this, arguments));
  }

  _createClass(Listing, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _has2.default)(this.props, "listing[".concat(this.props.params.id, "].data.core.clientOptInType"))) {
        if (this.props.listing[this.props.params.id].data.core.clientOptInType === 'ADMIN') {
          if (this.props.userPrefs.userId && (0, _has2.default)(this.props, 'profile.Role') && this.props.profile.Role === 1) {
            this.props.fetchLOAStatus(this.props.userPrefs.userId);
          }

          this.props.fetchLOAContent();
        }

        if (this.context.isPublic) {
          if ((0, _utils.canUseDOM)() && window.utag) {
            (0, _utils.sendPublicView)();
          }
        }

        if (this.props.userPrefs && this.props.userPrefs.userId) {
          this.props.fetchTermsStatus(this.props.userPrefs.userId);
        }
      }
    }
  }, {
    key: "getListing",
    value: function getListing() {
      return this.props.listing[this.props.params.id];
    }
  }, {
    key: "getPageTitle",
    value: function getPageTitle() {
      var listing = this.getListing();

      if (!listing || listing.readyState !== listingActions.LISTING_FETCHED) {
        return 'Listing';
      }

      return listing.data.localized.name;
    }
  }, {
    key: "renderListing",
    value: function renderListing() {
      var _this$props = this.props,
          userPrefs = _this$props.userPrefs,
          terms = _this$props.terms,
          offerings = _this$props.offerings;
      var _this$props$listing = this.props.listing,
          localizedRegions = _this$props$listing.localizedRegions,
          localizedCountries = _this$props$listing.localizedCountries;
      var listing = this.getListing().data;
      return _react.default.createElement(_ListingDetails.default, {
        terms: terms,
        listing: listing,
        userPrefs: userPrefs,
        offerings: offerings,
        localizedRegions: localizedRegions,
        localizedCountries: localizedCountries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var readyState = this.getListing() ? this.getListing().readyState : listingActions.LISTING_FETCHING;
      var listingIsLoaded = readyState === listingActions.LISTING_FETCHED || readyState === listingActions.LISTING_NOT_FOUND;
      var listingTitle = readyState === listingActions.LISTING_FETCHED ? this.getListing().data.localized.title : ''; // TODO: figure out why the details page won't update canonical, then re-enable
      // const links = [];
      // const listingID = listingIsLoaded ? this.getListing().data.ID : '';
      // if (isPublic(this.props.location.pathname) && listingIsLoaded) {
      //   links.push({
      //     href: `https://www.concur.com/app-center/listing/${listingID}`,
      //     rel: 'canonical',
      //   });
      // }

      var metaTags = [{
        name: 'description',
        content: listingIsLoaded ? listingTitle : 'App Center Listing'
      }];
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactHelmet.default, {
        meta: metaTags,
        title: this.props.context.getTitle(this.getPageTitle())
      }), _react.default.createElement(_Header.default, {
        listingId: this.props.params.id
      }), _react.default.createElement("div", {
        style: {
          minHeight: '550px'
        }
      }, _react.default.createElement(_LoadingIndicator.default, {
        isLoaded: listingIsLoaded,
        beta: this.props.profile && this.props.profile.betas['concur-ui-spinner']
      }, readyState === listingActions.LISTING_FETCHED && (0, _utils.canUseDOM)() && this.renderListing())));
    }
  }]);

  return Listing;
}(_react.Component);

Listing.propTypes = {
  dispatch: _propTypes.default.func,
  params: _propTypes.default.any,
  listing: _propTypes.default.object,
  isAppCenterEnabledCheck: _propTypes.default.func.isRequired,
  fetchListingIfNeeded: _propTypes.default.func.isRequired,
  fetchTermsStatus: _propTypes.default.func.isRequired,
  fetchLOAStatus: _propTypes.default.func.isRequired,
  fetchLOAContent: _propTypes.default.func.isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }),
  userPrefs: _propTypes.default.object
};

function mapStateToProps(state) {
  return {
    listing: state.listing,
    userPrefs: state.userPrefs,
    terms: state.terms,
    offerings: state.userProfile.offeringsEnabled,
    profile: state.userProfile.profile
  };
}

var mapDispatchToProps = {
  fetchListingIfNeeded: listingActions.fetchListingIfNeeded,
  fetchTermsStatus: termsActions.fetchTermsStatus,
  fetchLOAStatus: termsActions.fetchLOAStatus,
  fetchLOAContent: termsActions.fetchLOAContent,
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck
};

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Listing)));

exports.default = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListingDetails = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(255));

var _reactRedux = __webpack_require__(5);

var _find2 = _interopRequireDefault(__webpack_require__(78));

var _uniq2 = _interopRequireDefault(__webpack_require__(256));

var _nuiIntl = __webpack_require__(3);

var _reactRouter = __webpack_require__(8);

var _Carousel = _interopRequireDefault(__webpack_require__(257));

var _LogoLinksAndDesc = _interopRequireDefault(__webpack_require__(258));

var _termsModule = __webpack_require__(14);

var _terms = _interopRequireDefault(__webpack_require__(265));

var _EnrollModal = _interopRequireDefault(__webpack_require__(269));

var _UnenrollModal = _interopRequireDefault(__webpack_require__(270));

var _DisconnectModal = _interopRequireDefault(__webpack_require__(271));

var _ConfirmationModal = _interopRequireDefault(__webpack_require__(272));

var _trackClick = __webpack_require__(11);

var _utils = __webpack_require__(4);

var _offeringTypes = _interopRequireDefault(__webpack_require__(273));

var _regions = _interopRequireDefault(__webpack_require__(274));

var _withAppContext = __webpack_require__(9);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(79) : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ListingDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListingDetails, _React$Component);

  function ListingDetails() {
    var _this;

    _classCallCheck(this, ListingDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListingDetails).call(this));
    _this.state = {
      detailsExpanded: false,
      regionIsDisplayed: false
    };
    _this._toggleDetails = _this._toggleDetails.bind(_assertThisInitialized(_this));
    _this._toggleRegionDisplay = _this._toggleRegionDisplay.bind(_assertThisInitialized(_this));
    _this.launchTandCinfoOnly = _this.launchTandCinfoOnly.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ListingDetails, [{
    key: "_toggleDetails",
    value: function _toggleDetails() {
      // if this ever needs to be re-used or gets ugly, we can consider:
      // https://github.com/craigambrose/react-more/blob/master/lib/index.js
      this.setState({
        detailsExpanded: !this.state.detailsExpanded
      });
    }
  }, {
    key: "launchTandCinfoOnly",
    value: function launchTandCinfoOnly() {
      this.props.launchTaCModal({
        tAndCLinkClicked: true,
        ID: this.props.listing.ID,
        v1ListingId: this.props.listing.core.v1ID
      });
    }
  }, {
    key: "renderDisabledWarning",
    value: function renderDisabledWarning() {
      var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var hasOfferings = arguments.length > 1 ? arguments[1] : undefined;
      var isAdminListing = arguments.length > 2 ? arguments[2] : undefined;

      if (isDisabled) {
        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ListingDisabledByCompany",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }

      if (!hasOfferings && !isAdminListing) {
        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ListingNotCompatibleWithOfferings",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }

      return null;
    }
  }, {
    key: "renderOfferings",
    value: function renderOfferings() {
      var offerings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _react.default.createElement("ul", null, offerings.map(function (offering) {
        return _react.default.createElement("li", {
          key: offering
        }, _react.default.createElement("p", null, _offeringTypes.default[offering]));
      }));
    }
  }, {
    key: "_toggleRegionDisplay",
    value: function _toggleRegionDisplay() {
      this.setState({
        regionIsDisplayed: !this.state.regionIsDisplayed
      });
    }
  }, {
    key: "renderRegions",
    value: function renderRegions(regions) {
      var _this2 = this;

      var localizedRegionsAndCountries;

      if (this.props.localizedRegions && this.props.localizedCountries) {
        localizedRegionsAndCountries = Object.entries(regions).map(function (region) {
          var localizedRegionName = (0, _find2.default)(_this2.props.localizedRegions, function (localizedRegion) {
            return localizedRegion.code === _regions.default[region[0]];
          });
          var localizedCountries = [];
          region[1].map(function (countryCode) {
            var localizedCountryName = (0, _find2.default)(_this2.props.localizedCountries, function (localizedCountry) {
              return localizedCountry.code === countryCode;
            });
            return localizedCountries.push(localizedCountryName.description);
          });
          return {
            region: localizedRegionName.description,
            countries: localizedCountries
          };
        });
      }

      var output;

      if (localizedRegionsAndCountries) {
        output = localizedRegionsAndCountries.filter(function (region) {
          return region.countries.length !== 0;
        }).map(function (i) {
          return _react.default.createElement("div", {
            onClick: _this2._toggleRegionDisplay,
            key: i.region
          }, _react.default.createElement(_reactCollapsible.default, {
            key: i.region,
            trigger: _react.default.createElement("div", null, _react.default.createElement("a", {
              className: "region-list-element",
              tabIndex: "0"
            }, i.region), _react.default.createElement("span", {
              id: "country-list",
              className: "".concat(_this2.state.regionIsDisplayed ? 'region-opened' : 'region-closed', " icon-arrow-1-n icon-size-sm")
            })),
            classParentString: "regions-collapse"
          }, _react.default.createElement("ul", null, Object.values((0, _uniq2.default)(i.countries)).map(function (country) {
            return _react.default.createElement("li", {
              key: country
            }, _react.default.createElement("p", null, country));
          }))));
        });
      }

      return _react.default.createElement("ul", null, output);
    }
  }, {
    key: "renderBackToAppCenter",
    value: function renderBackToAppCenter(ID, listingName) {
      var _this3 = this;

      return _react.default.createElement(_trackClick.Tracked, {
        event: "CLICK",
        additional: {
          context: 'LISTING_DETAILS',
          type: 'LINK',
          value: 'BACK_TO_APP_CENTER',
          v2_listing_id: ID,
          app_name: listingName,
          domain: window.location.hostname
        }
      }, _react.default.createElement("span", null, _react.default.createElement(_reactRouter.Link, {
        to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
        onClick: function onClick() {
          return document.title = _this3.props.context.getTitle(_utils.HOME);
        }
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "BackToAppCenter"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          listing = _this$props.listing,
          _this$props$offerings = _this$props.offerings,
          offerings = _this$props$offerings === void 0 ? [] : _this$props$offerings;
      var ID = listing.ID,
          _listing$core = listing.core,
          listingDisabled = _listing$core.listingDisabled,
          regions = _listing$core.regions,
          listingName = _listing$core.listingName,
          oAuthWorkflowType = _listing$core.oAuthWorkflowType,
          clientOptInType = _listing$core.clientOptInType,
          v1ID = _listing$core.v1ID,
          _listing$core$offerin = _listing$core.offerings,
          listingOfferings = _listing$core$offerin === void 0 ? [] : _listing$core$offerin;
      var userId = this.props.userPrefs.userId;
      var hasOfferings = !userId || userId && offerings.filter(function (offering) {
        return listingOfferings.indexOf(offering) !== -1;
      }).length > 0;
      var isAdminListing = clientOptInType === 'ADMIN';

      var areRegionsPopulated = function areRegionsPopulated() {
        if (regions.asia.length > 0 || regions.emea.length > 0 || regions.latinAmerica.length > 0 || regions.northAmerica.length > 0) {
          return true;
        }

        return false;
      };

      return _react.default.createElement("div", {
        className: "details-container"
      }, _react.default.createElement(_EnrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_UnenrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_DisconnectModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_ConfirmationModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement("div", {
        className: "row standard-font"
      }, _react.default.createElement("div", {
        className: "col-xs-12"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12 back-link-row"
      }, this.renderBackToAppCenter(ID, listingName), this.renderDisabledWarning(listingDisabled, hasOfferings, isAdminListing))), _react.default.createElement(_LogoLinksAndDesc.default, {
        listing: listing,
        toggleDetails: this._toggleDetails,
        detailsExpanded: this.state.detailsExpanded,
        listingDisabled: listingDisabled || !hasOfferings && !isAdminListing
      })), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-12 details-lower-row"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12 margin-top-lg"
      }, this.props.listing.core.webScreenshots && this.props.listing.core.webScreenshots.length ? _react.default.createElement(_Carousel.default, {
        images: this.props.listing.core.webScreenshots
      }) : null)), listing.core && listing.core.offerings.length > 0 && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg"
      }, _react.default.createElement("h4", {
        id: "ac-offerings"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "WorksWithTheseConcurOfferings"
      })), listing.core && this.renderOfferings(listing.core.offerings))), listing.core && areRegionsPopulated() && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg",
        style: {
          marginBottom: !userId && '16px'
        }
      }, _react.default.createElement("h4", {
        id: "ac-listing-regions"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "RegionsAvailable"
      })), listing.core && regions && this.renderRegions(regions))), userId && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg"
      }, _react.default.createElement("h4", null, _react.default.createElement("a", {
        href: "#",
        className: "ac-details-link",
        id: "ac-terms-link",
        onClick: this.launchTandCinfoOnly
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "TermsTitle"
      }))), (0, _utils.canUseDOM)() ? _react.default.createElement(_terms.default, {
        listingId: ID,
        v1ListingId: v1ID,
        publisher: this.props.listing.localized.publisher,
        partnerAppScopes: this.props.listing.core.partnerAppScopes,
        flow: oAuthWorkflowType,
        clientOptInType: this.props.listing.core.clientOptInType
      }) : ''))))));
    }
  }]);

  return ListingDetails;
}(_react.default.Component);

exports.ListingDetails = ListingDetails;
ListingDetails.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1Data: _propTypes.default.object
  }).isRequired,
  localizedRegions: _propTypes.default.array,
  localizedCountries: _propTypes.default.array,
  enroll: _propTypes.default.func,
  toggleTaCModal: _propTypes.default.func,
  launchTaCModal: _propTypes.default.func,
  isTaCModalOpen: _propTypes.default.bool,
  updateTermsStatus: _propTypes.default.func,
  postTerms: _propTypes.default.func,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }).isRequired,
  userPrefs: _propTypes.default.shape({
    userId: _propTypes.default.string
  }),
  location: _propTypes.default.object
};

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(null, {
  launchTaCModal: _termsModule.launchTaCModal,
  toggleTaCModal: _termsModule.toggleTaCModal,
  postTerms: _termsModule.postTerms,
  updateTermsStatus: _termsModule.updateTermsStatus
})(ListingDetails)));

exports.default = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(0))(1272);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(30);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = function Carousel(_ref) {
  var images = _ref.images,
      maxHeight = _ref.maxHeight,
      _ref$altText = _ref.altText,
      altText = _ref$altText === void 0 ? 'Screenshot' : _ref$altText;
  var maxHeightValue = maxHeight ? "".concat(maxHeight, "px") : '450px';
  return _react.default.createElement("div", {
    className: "carousel-container-outer",
    style: {
      maxWidth: '100%',
      overflowX: 'hidden'
    }
  }, _react.default.createElement("div", {
    className: "carousel-container-inner",
    style: {
      maxHeight: maxHeightValue,
      overflowX: 'scroll',
      overflowY: 'hidden',
      whiteSpace: 'nowrap'
    }
  }, images && images.map(function (el, i) {
    return !!el && _react.default.createElement("div", {
      className: "carousel-image-container",
      key: i,
      style: {
        display: 'inline-block',
        verticalAlign: 'bottom'
      }
    }, _react.default.createElement("img", {
      alt: "".concat(altText, " - ").concat(i),
      className: "carousel-image",
      src: el,
      style: {
        maxHeight: maxHeightValue
      }
    }));
  })));
};

Carousel.propTypes = {
  altText: _propTypes.default.string,
  images: _propTypes.default.arrayOf(_propTypes.default.string),
  maxHeight: _propTypes.default.string
};
var _default = Carousel;
exports.default = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoLinksAndDescDisconnected = exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _ReadMore = _interopRequireDefault(__webpack_require__(259));

var _ConnectButton = _interopRequireDefault(__webpack_require__(261));

var _trackClick = __webpack_require__(11);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(264) : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoLinksAndDesc = function LogoLinksAndDesc(_ref) {
  var listing = _ref.listing,
      toggleDetails = _ref.toggleDetails,
      userPrefs = _ref.userPrefs,
      detailsExpanded = _ref.detailsExpanded,
      listingDisabled = _ref.listingDisabled;
  var _userPrefs$userId = userPrefs.userId,
      userId = _userPrefs$userId === void 0 ? '' : _userPrefs$userId;
  var ID = listing.ID,
      _listing$core = listing.core,
      icon = _listing$core.icon,
      listingName = _listing$core.listingName,
      _listing$localized = listing.localized;
  _listing$localized = _listing$localized === void 0 ? {} : _listing$localized;
  var partnerListingURL = _listing$localized.partnerListingURL,
      _listing$localized$na = _listing$localized.name,
      name = _listing$localized$na === void 0 ? '' : _listing$localized$na,
      _listing$localized$ti = _listing$localized.title,
      title = _listing$localized$ti === void 0 ? '' : _listing$localized$ti,
      demonstrationURL = _listing$localized.demonstrationURL,
      brochureURL = _listing$localized.brochureURL,
      contactURL = _listing$localized.contactURL,
      details = _listing$localized.details,
      partnerImage = listing.images.partnerImage;
  var links = {
    partnerListingURL: partnerListingURL,
    demonstrationURL: demonstrationURL,
    brochureURL: brochureURL,
    contactURL: contactURL
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'LINK',
        v2_listing_id: ID,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  var renderLinks = function renderLinks(linksObj) {
    var output = [];

    if (linksObj.partnerListingURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.partnerListingURL,
        className: "ac-details-link",
        id: "ac-partner-listing-url",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "VisitOurWebsite"
      })), {
        value: 'PARTNER_LISTING_URL'
      }));
    }

    if (linksObj.demonstrationURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.demonstrationURL,
        id: "ac-demonstration-url",
        className: "ac-details-link",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "WatchDemo"
      })), {
        value: 'DEMONSTRATION_URL'
      }));
    }

    if (linksObj.brochureURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.brochureURL,
        className: "ac-details-link",
        target: "_blank",
        id: "ac-brochure-url"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Brochure"
      })), {
        value: 'BROCHURE_URL'
      }));
    }

    if (linksObj.contactURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.contactURL,
        id: "ac-contact-url",
        className: "ac-details-link",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Support"
      })), {
        value: 'CONTACT_URL'
      }));
    }

    return output.map(function (el, i, arr) {
      return _react.default.createElement("span", {
        key: "".concat(i, "links")
      }, el, i < arr.length - 1 && ' | ');
    });
  };

  var renderReadMore = function renderReadMore() {
    return trackClicked(_react.default.createElement(_ReadMore.default, {
      text: details,
      isExpanded: detailsExpanded,
      expand: toggleDetails
    }), {
      value: 'READ_MORE'
    });
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-sm-9 col-xs-12"
  }, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-md-2 col-xs-3 imgDiv"
  }, _react.default.createElement("img", {
    alt: "Partner Image",
    className: "icon-image",
    src: icon || partnerImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg'
  })), _react.default.createElement("div", {
    className: "col-sm-6 col-xs-6 partner-name-and-title"
  }, _react.default.createElement("h1", {
    className: "ac-listing-name"
  }, name), _react.default.createElement("p", {
    className: "ac-listing-title"
  }, title))), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-10 read-more-area"
  }, renderReadMore(), renderLinks(links, ID, listingName)))), _react.default.createElement("div", {
    className: "clearfix visible-xs"
  }), _react.default.createElement("div", {
    className: "col-sm-3 col-xs-3"
  }, _react.default.createElement(_ConnectButton.default, {
    listing: listing,
    isDisabled: listingDisabled,
    userPrefs: userPrefs
  }))));
};

exports.LogoLinksAndDescDisconnected = LogoLinksAndDesc;

var mapStateToProps = function mapStateToProps(state) {
  return {
    userPrefs: state.userPrefs
  };
};

LogoLinksAndDesc.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object
  }).isRequired,
  toggleDetails: _propTypes.default.func.isRequired,
  userPrefs: _propTypes.default.shape({
    userId: _propTypes.default.string
  }),
  detailsExpanded: _propTypes.default.bool.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(LogoLinksAndDesc);

exports.default = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _nuiIntl = __webpack_require__(3);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(260) : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadMore = function ReadMore(_ref) {
  var text = _ref.text,
      isExpanded = _ref.isExpanded,
      expand = _ref.expand;

  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    expand();
  };

  var renderExpandLink = function renderExpandLink() {
    return _react.default.createElement("a", {
      href: "#",
      className: "cnqr-muted",
      onClick: clickHandler
    }, isExpanded ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ReadLess"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ReadMore"
    }));
  };

  var lines = text && text.split(/\r\n|\r|\n/g).length;

  var getMaxHeight = function getMaxHeight() {
    if (text && text.length < 293) {
      if (lines > 3) {
        return {
          maxHeight: "".concat(lines * 18.5714, "px") // 18.5714 is the computed linehieght

        };
      }
    }
  };

  var renderButton = function renderButton() {
    if (text && (text.length > 293 || lines > 3)) {
      return _react.default.createElement("div", {
        className: "ac-read-more ".concat(isExpanded ? 'ac-read-more-expanded' : '')
      }, renderExpandLink());
    }

    return null;
  };

  return _react.default.createElement("div", {
    className: "ac-read-more-container"
  }, _react.default.createElement("div", {
    className: "ac-read-more-text ".concat(isExpanded ? 'ac-read-more-text-expanded' : ''),
    style: getMaxHeight()
  }, text, renderButton()));
};

ReadMore.propTypes = {
  text: _propTypes.default.string.isRequired,
  isExpanded: _propTypes.default.bool.isRequired,
  expand: _propTypes.default.func.isRequired
};
var _default = ReadMore;
exports.default = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectButton = exports.default = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _nuiWidgets = __webpack_require__(28);

var _reactLoader = _interopRequireDefault(__webpack_require__(77));

var _AutoConnectInput = _interopRequireDefault(__webpack_require__(262));

var _listingModule = __webpack_require__(6);

var termsModule = _interopRequireWildcard(__webpack_require__(14));

var analyticsModule = _interopRequireWildcard(__webpack_require__(16));

var _trackClick = __webpack_require__(11);

var _config = _interopRequireDefault(__webpack_require__(13));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(79) : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(263) : void 0;

var _analytics = __webpack_require__(12);

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = 1;
exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
var SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = 2;
exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;

var ConnectButton = function ConnectButton(_ref) {
  var listing = _ref.listing,
      inquire = _ref.inquire,
      userId = _ref.userId,
      isDisabled = _ref.isDisabled,
      launchTaCModal = _ref.launchTaCModal,
      launchModal = _ref.launchModal,
      modalNames = _ref.modalNames,
      connectToListing = _ref.connectToListing,
      terms = _ref.terms,
      isConnecting = _ref.isConnecting,
      trackLinkClick = _ref.trackLinkClick,
      trackButtonClick = _ref.trackButtonClick,
      companyUUID = _ref.companyUUID,
      _ref$userProfile = _ref.userProfile,
      userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile,
      trackInteractionEvent = _ref.trackInteractionEvent;
  var ID = listing.ID,
      _listing$core = listing.core,
      flow = _listing$core.oAuthWorkflowType,
      isUserConnected = _listing$core.isUserConnected,
      supportNewEnrollment = _listing$core.supportNewEnrollment,
      isConnectionPending = _listing$core.isConnectionPending,
      listingName = _listing$core.listingName,
      listingType = _listing$core.listingType,
      triplinkLoyaltyNumber = _listing$core.triplinkLoyaltyNumber,
      clientOptInType = _listing$core.clientOptInType,
      canUserConnect = _listing$core.canUserConnect,
      v1ID = _listing$core.v1ID,
      _listing$localized = listing.localized,
      connectURL = _listing$localized.connectURL,
      inquireURL = _listing$localized.inquireURL;
  var CON_REQ_FLOW = 'CONREQFLOW';
  var AUTO_CON_FLOW = 'AUTOCONFLOW';
  var ADMIN = 'ADMIN';
  var btnStyle = {
    width: '98%',
    minWidth: '150px',
    marginTop: '16px'
  };
  var spinnerOpts = {
    lines: 8,
    length: 0,
    width: 5,
    radius: 6,
    scale: 0.8,
    corners: 1,
    color: '#2379BF',
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    shadow: false,
    top: '50%',
    left: '50%',
    position: 'relative',
    padding: '10px',
    hwaccel: false,
    height: '20px'
  };

  function isCompanyAdminOrWSAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
  }

  function isSystemAdminOrConcurAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;
  }

  function canConnectToEnterpriseApp() {
    return isCompanyAdminOrWSAdmin() || isSystemAdminOrConcurAdmin();
  }

  function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        v2_listing_id: ID,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  }

  function handleLaunchTaC(options) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.connect],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    launchTaCModal(_objectSpread({
      tAndCLinkClicked: false,
      flow: flow,
      listingId: listing.ID,
      v1ListingId: v1ID,
      needAnAccountClicked: false
    }, options));
  }

  function connectBtn(btnDisabled) {
    var formatConnect = btnDisabled ? _react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    });
    return canUserConnect && trackClicked(_react.default.createElement("button", {
      id: "listing-appcenter-flow-connect-button",
      className: "btn btn-default btn-lg ".concat(isDisabled ? 'disabled' : ''),
      onClick: handleLaunchTaC,
      style: btnStyle,
      disabled: btnDisabled || (flow === AUTO_CON_FLOW && !listing.loyaltyNumber || isConnecting) && !triplinkLoyaltyNumber
    }, isConnecting ? _react.default.createElement(_reactLoader.default, {
      loaded: !isConnecting,
      options: spinnerOpts,
      className: "connect-loader"
    }) : formatConnect), {
      value: 'CONNECT',
      type: 'BUTTON'
    });
  }

  function disconnectBtn() {
    var launchDisconnectModal = function launchDisconnectModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.disconnect],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.disconnect);
    }; // this removes the ability to disconnect from mobile


    if (connectURL && connectURL.indexOf('profile/profile_mobile.asp') !== -1) {
      return null;
    }

    return (clientOptInType === 'USER' || canConnectToEnterpriseApp()) && trackClicked(_react.default.createElement("button", {
      className: "btn btn-lg btn-default",
      onClick: launchDisconnectModal,
      style: btnStyle
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Disconnect"
    })), {
      value: 'DISCONNECT',
      type: 'BUTTON'
    });
  }

  function connectOrDisconnectBtn(btnDisabled) {
    return !isUserConnected ? connectBtn(btnDisabled) : disconnectBtn();
  }

  function handleInquireClicked(elementType) {
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    window.open(inquireURL, 'Inquire');
    return inquire(listing.ID, userId);
  }

  var renderConnectedCheck = function renderConnectedCheck() {
    return userId && isUserConnected && _react.default.createElement("span", null, _react.default.createElement("span", {
      className: "is-connected-check-details icon-check icon-size-md"
    }), _react.default.createElement("h4", {
      className: "connection-message"
    }, listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Enrolled"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connected"
    })));
  };

  function requestInfoBtnAndDescription() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };

    return _react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, !isUserConnected && _react.default.createElement("div", null, trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.button);
      }
    }, _react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformation"
    }))), {
      value: 'REQUEST_INFORMATION',
      type: 'BUTTON'
    }), _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformationDescription"
    }), connectURL && _react.default.createElement("div", null, _react.default.createElement("br", null), _react.default.createElement(_nuiWidgets.Button, {
      type: "link",
      muted: userId && !canConnectToEnterpriseApp() || isDisabled,
      disabled: userId && !canConnectToEnterpriseApp() || isDisabled,
      style: {
        padding: '0px',
        textAlign: 'left'
      },
      onClick: function onClick() {
        if (userId) {
          return handleLaunchTaC();
        }

        return deeplinkToListing();
      }
    }, userId ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "LoginToConnect"
    })), _react.default.createElement("br", null), canConnectToEnterpriseApp() ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectBusinessApp"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "EndUserConnectBusinessApp"
    }))));
  }

  function requestInfoLinkAndDescription() {
    return _react.default.createElement("div", {
      style: {
        textAlign: 'left',
        paddingTop: '16px'
      }
    }, trackClicked(_react.default.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.link);
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformation"
    })), {
      value: 'REQUEST_INFORMATION',
      type: 'LINK'
    }), _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformationDescription"
    }));
  }

  function inquireBtn() {
    if (listingType === 'COCPAP') {
      if (canConnectToEnterpriseApp()) {
        return _react.default.createElement("div", {
          style: {
            textAlign: 'left'
          }
        }, !isUserConnected && _react.default.createElement("div", null, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ActivateBusinessApp"
        })), _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ConnectBusinessApp"
        })), connectOrDisconnectBtn(), requestInfoLinkAndDescription());
      }

      return _react.default.createElement("div", {
        style: {
          textAlign: 'left'
        }
      }, connectOrDisconnectBtn(true), !isUserConnected && _react.default.createElement("div", null, _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "EndUserConnectBusinessApp"
      })), requestInfoLinkAndDescription());
    }

    return requestInfoBtnAndDescription();
  }

  function enrollBtn() {
    var launchEnrollModal = function launchEnrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.enroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.enroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: launchEnrollModal,
      disabled: isConnecting
    }, isConnecting ? _react.default.createElement(_reactLoader.default, {
      loaded: !isConnecting,
      options: spinnerOpts,
      className: "connect-loader"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Enroll"
    })), {
      value: 'ENROLL',
      type: 'BUTTON'
    });
  }

  function unenrollBtn() {
    var launchUnenrollModal = function launchUnenrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.unenroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.unenroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: launchUnenrollModal
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Unenroll"
    })), {
      value: 'UNENROLL',
      type: 'BUTTON'
    });
  }

  function enrollOrUnenrollBtn() {
    return !isUserConnected ? enrollBtn() : unenrollBtn();
  }

  function loginToConnectBtn() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };

    return _react.default.createElement("div", null, trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: deeplinkToListing
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "LoginToConnect"
    })), {
      value: 'LOGIN_TO_CONNECT',
      type: 'BUTTON'
    }), inquireURL ? requestInfoLinkAndDescription() : null);
  }

  function showBtn() {
    if (userId) {
      if (isConnectionPending && !isUserConnected) {
        return;
      }

      if (clientOptInType === ADMIN) {
        return inquireBtn();
      }

      if (listingType === 'COCPAP') {
        return connectOrDisconnectBtn();
      }

      return enrollOrUnenrollBtn();
    }

    if (listingType === 'ADVISR') {
      return inquireBtn();
    }

    return loginToConnectBtn();
  }

  function showNeedAnAccountLink() {
    var launchTaC = function launchTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.launchTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      handleLaunchTaC({
        needAnAccountClicked: true
      });
    };

    var connectWithoutTaC = function connectWithoutTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.connectWithoutTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      connectToListing(ID, v1ID, {
        needAnAccountClicked: true
      });
    };

    var areTermsAccepted = function areTermsAccepted() {
      if (terms) {
        return terms.previouslyAccepted || terms.currentlyAccepted;
      }

      return false;
    };

    if (isConnectionPending || isUserConnected) {
      return null;
    }

    return !isDisabled && userId && supportNewEnrollment && !triplinkLoyaltyNumber && clientOptInType !== ADMIN && _react.default.createElement("p", {
      style: {
        textAlign: 'center',
        paddingBottom: '5px'
      }
    }, _react.default.createElement("a", {
      href: "#",
      onClick: areTermsAccepted() ? connectWithoutTaC : launchTaC
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "NeedAnAccount"
    })));
  }

  var renderAutoConnectInput = function renderAutoConnectInput() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && !isConnectionPending && !isUserConnected && _react.default.createElement(_AutoConnectInput.default, {
      listing: listing,
      isDisabled: isDisabled
    });
  };

  var showConnectionPendingMessage = function showConnectionPendingMessage() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && isConnectionPending && !isUserConnected && _react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectionPending"
    })), _react.default.createElement("br", null), _react.default.createElement("h4", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectionPendingMessage"
    })));
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW || clientOptInType === ADMIN) ? 'loyalty-box' : '',
    style: {
      textAlign: 'center'
    }
  }, false && _react.default.createElement("span", {
    style: {
      color: 'red',
      fontSize: '30px'
    }
  }, userProfile.profile && userProfile.profile.LoginID), renderAutoConnectInput(), renderConnectedCheck(), showNeedAnAccountLink(), showConnectionPendingMessage(), showBtn()));
};

exports.ConnectButton = ConnectButton;
ConnectButton.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object
  }).isRequired,
  modalNames: _propTypes.default.shape({
    confirmation: _propTypes.default.string,
    disconnect: _propTypes.default.string,
    enroll: _propTypes.default.string,
    unenroll: _propTypes.default.string
  }).isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }).isRequired,
  userId: _propTypes.default.string,
  connectToListing: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  inquire: _propTypes.default.func.isRequired,
  launchTaCModal: _propTypes.default.func.isRequired,
  launchModal: _propTypes.default.func.isRequired,
  isDisabled: _propTypes.default.bool.isRequired,
  isConnecting: _propTypes.default.bool.isRequired,
  trackLinkClick: _propTypes.default.func,
  trackButtonClick: _propTypes.default.func,
  trackInteractionEvent: _propTypes.default.func,
  companyUUID: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isConnecting: state.listing.isConnecting,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    terms: state.terms,
    companyUUID: state.userPrefs.companyUUID,
    userProfile: state.userProfile
  };
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  launchModal: _listingModule.toggleModal,
  inquire: _listingModule.inquireListing,
  connectToListing: _listingModule.connectListing,
  launchTaCModal: termsModule.launchTaCModal,
  checkForConnection: _listingModule.checkForConnection,
  unenrollListing: _listingModule.unenrollListing,
  disconnectListing: _listingModule.disconnectListing,
  trackLinkClick: analyticsModule.linkClickDispatch,
  trackButtonClick: analyticsModule.buttonClickDispatch,
  trackInteractionEvent: analyticsModule.interactionEventDispatch
})(ConnectButton));

exports.default = _default;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _nuiIntl = __webpack_require__(3);

var _reactRedux = __webpack_require__(5);

var actions = _interopRequireWildcard(__webpack_require__(6));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoConnectInput = function AutoConnectInput(_ref) {
  var listing = _ref.listing,
      isDisabled = _ref.isDisabled,
      updateLoyaltyNum = _ref.updateLoyaltyNum,
      formatter = _ref.formatter;
  var loyaltyNumber = listing.loyaltyNumber,
      ID = listing.ID;

  var handleFormUpdate = function handleFormUpdate(e) {
    updateLoyaltyNum(ID, e.target.value);
    updateLoyaltyNum(listing.core.v1ID, e.target.value);
  };

  var htmlMarkup = function htmlMarkup(html) {
    return {
      __html: html
    };
  };

  var renderLoyaltyInput = function renderLoyaltyInput() {
    if (!listing.core.triplinkLoyaltyNumber) {
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        style: {
          width: '100%'
        },
        type: "text",
        name: "loyaltyNumber",
        className: "form-control",
        disabled: isDisabled,
        "aria-label": formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        placeholder: formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        value: loyaltyNumber,
        onChange: handleFormUpdate
      }));
    }

    if (!listing.core.isConnectionPending) {
      return _react.default.createElement("div", null, _react.default.createElement("h4", {
        dangerouslySetInnerHTML: htmlMarkup(formatter.formattedMessage({
          id: 'ExistingLoyaltyNum'
        }))
      }));
    }
  };

  return _react.default.createElement("div", null, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Connect"
  })), _react.default.createElement("br", null), !listing.core.triplinkLoyaltyNumber && _react.default.createElement("div", null, _react.default.createElement("h4", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AddLoyaltyNumber"
  })), _react.default.createElement("br", null)), renderLoyaltyInput());
};

AutoConnectInput.propTypes = {
  listing: _propTypes.default.shape({
    loyaltyNumber: _propTypes.default.string
  }),
  updateLoyaltyNum: _propTypes.default.func.isRequired,
  formatter: _propTypes.default.object
};

var _default = (0, _reactRedux.connect)(null, {
  updateLoyaltyNum: actions.updateLoyaltyNum
})((0, _nuiIntl.withFormatter)(AutoConnectInput));

exports.default = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TermsContainer = _interopRequireDefault(__webpack_require__(266));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _TermsContainer.default;
exports.default = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = __webpack_require__(5);

var _TermsAndConditions = _interopRequireDefault(__webpack_require__(267));

var _termsModule = __webpack_require__(14);

var _listingModule = __webpack_require__(6);

var _AnalyticsModule = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    terms: state.terms,
    sharedInfo: state.sharedInfo,
    userId: state.userPrefs.userId,
    listing: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
}

var mapDispatchToProps = {
  toggleModal: _termsModule.toggleTaCModal,
  toggleNeedAnAccountClicked: _listingModule.toggleNeedAnAccountClicked,
  launchModal: _termsModule.launchTaCModal,
  updateTermsStatus: _termsModule.updateCurrentlyAccepted,
  postTerms: _termsModule.updateTerms,
  connect: _listingModule.connectListing,
  trackButtonClick: _AnalyticsModule.buttonClickDispatch,
  trackLinkClick: _AnalyticsModule.linkClickDispatch
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TermsAndConditions.default);

exports.default = _default;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiIntl = __webpack_require__(3);

var _reactRouter = __webpack_require__(8);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactModal = _interopRequireDefault(__webpack_require__(21));

var _find2 = _interopRequireDefault(__webpack_require__(78));

var _has2 = _interopRequireDefault(__webpack_require__(25));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(80) : void 0;

var _TermsPanel = _interopRequireDefault(__webpack_require__(268));

var _analytics = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TandC = function TandC(_ref) {
  var terms = _ref.terms,
      userId = _ref.userId,
      toggleModal = _ref.toggleModal,
      toggleNeedAnAccountClicked = _ref.toggleNeedAnAccountClicked,
      updateTermsStatus = _ref.updateTermsStatus,
      connect = _ref.connect,
      postTerms = _ref.postTerms,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      flow = _ref.flow,
      _ref$partnerAppScopes = _ref.partnerAppScopes,
      partnerAppScopes = _ref$partnerAppScopes === void 0 ? [] : _ref$partnerAppScopes,
      clientOptInType = _ref.clientOptInType,
      listing = _ref.listing,
      router = _ref.router,
      formatter = _ref.formatter,
      trackButtonClick = _ref.trackButtonClick,
      trackLinkClick = _ref.trackLinkClick,
      companyUUID = _ref.companyUUID;
  var isTaCModalOpen = terms.isTaCModalOpen,
      content = terms.content,
      appcenterStatus = terms.appcenterStatus,
      sharedInfoStatus = terms.sharedInfoStatus,
      sharedInfo = terms.sharedInfo,
      loa = terms.loa,
      tAndCLinkClicked = terms.tAndCLinkClicked;
  var _listing$data = listing[(0, _has2.default)(listing, listingId) ? listingId : v1ListingId].data;
  _listing$data = _listing$data === void 0 ? {} : _listing$data;
  var _listing$data$core = _listing$data.core;
  _listing$data$core = _listing$data$core === void 0 ? {} : _listing$data$core;
  var listingName = _listing$data$core.listingName,
      _listing$data$localiz = _listing$data.localized;
  _listing$data$localiz = _listing$data$localiz === void 0 ? {} : _listing$data$localiz;
  var partnerPolicyURL = _listing$data$localiz.partnerPolicyURL,
      partnerTermsURL = _listing$data$localiz.partnerTermsURL;
  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '600px',
      maxHeight: '80%',
      margin: '75px auto'
    }
  };
  var ADMIN = 'ADMIN';

  var handleClickTermsLearnMoreLink = function handleClickTermsLearnMoreLink(e) {
    trackLinkClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.learnMoreSharedInfoLink],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
  };

  var createHTMLMarkup = function createHTMLMarkup(html) {
    return {
      __html: html
    };
  };

  var handleCheckboxUpdate = function handleCheckboxUpdate(e) {
    updateTermsStatus(e.target.id, e.target.checked);
  };

  var AppCenterTerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "appcenterStatus",
    title: formatter.formattedMessage({
      id: 'TermsAppCenterTitle'
    }),
    description: formatter.formattedMessage({
      id: 'TermsAppCenterDescription'
    }),
    checked: appcenterStatus.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    showCheckbox: !tAndCLinkClicked
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: createHTMLMarkup((0, _find2.default)(content, {
      type: 'appcenter'
    }).content)
  }));

  var concurPrivacyPolicy = _react.default.createElement("a", {
    target: "_blank",
    href: "https://www.concur.com/en-us/processor-privacy-statement"
  }, formatter.formattedMessage({
    id: 'ProcessorPrivacyStatement'
  }));

  var linkToPartnerPolicy = partnerPolicyURL ? _react.default.createElement("a", {
    target: "_blank",
    href: partnerPolicyURL
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerPolicyURL"
  })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerPolicyURL"
  });

  var sharedInfoTerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "sharedInfoStatus",
    title: formatter.formattedMessage({
      id: 'TermsAccessAuthTitle'
    }),
    description: formatter.formattedMessage({
      id: 'TermsAccessAuthDescription'
    }),
    checked: sharedInfoStatus.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    showCheckbox: !tAndCLinkClicked
  }, _react.default.createElement("p", null, clientOptInType !== ADMIN ? _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "TermsAccessAuthSubtitle"
  }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "TermsAccessAuthSubtitleEnterprise"
  }), _react.default.createElement("span", null, _react.default.createElement("a", {
    target: "_blank",
    href: "https://developer.concur.com/api-reference/authentication/app-center-learn-more.html",
    onClick: handleClickTermsLearnMoreLink
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "LearnMoreAboutServiceFieldExposed"
  })))), _react.default.createElement("ul", null, sharedInfo.map(function (el, i) {
    return _react.default.createElement("li", {
      className: "shared-bullet",
      key: i
    }, el);
  })), _react.default.createElement("p", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "ConcurValuesPrivacy",
    values: {
      concurPrivacyPolicy: concurPrivacyPolicy,
      linkToPartnerPolicy: linkToPartnerPolicy
    }
  })));

  var LOATerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "loaStatus",
    showCheckbox: !tAndCLinkClicked,
    checked: loa && loa.status.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    title: formatter.formattedMessage({
      id: 'AccessAuthorization'
    }),
    description: formatter.formattedMessage({
      id: 'AccessAuthorizationDescription'
    })
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: createHTMLMarkup(loa && loa.content && loa.content.html)
  }));

  var isNUI = window.location.pathname.indexOf('nui') >= 0;
  var loaLink = "".concat(isNUI ? '/nui' : '', "/appcenter/terms/loa");
  var linkToPartnerTerms = partnerTermsURL ? _react.default.createElement("a", {
    target: "_blank",
    href: partnerTermsURL
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerTermsURL"
  })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerTermsURL"
  });

  var linkToLoaTerms = _react.default.createElement("a", {
    target: "_blank",
    href: loaLink
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AccessAuthorization"
  }));

  var getContent = function getContent() {
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, _react.default.createElement("h3", null, formatter.formattedMessage({
      id: 'TermsReview'
    })), _react.default.createElement("p", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: clientOptInType === ADMIN ? 'TermsByAcceptEnterprise' : 'TermsByAccept',
      values: {
        loaTermsURL: linkToLoaTerms,
        partnerTermsURL: linkToPartnerTerms
      }
    }))), _react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, tAndCLinkClicked || !appcenterStatus.previouslyAccepted ? AppCenterTerms : null, tAndCLinkClicked || flow !== 'WEBFLOW' ? sharedInfoTerms : null, clientOptInType === ADMIN && (tAndCLinkClicked || !loa.status.previouslyAccepted) ? LOATerms : null));
  };

  var handleCancelClick = function handleCancelClick(e) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.cancel],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    e.preventDefault();
    toggleNeedAnAccountClicked(false);
    updateTermsStatus('appcenterStatus', false);
    updateTermsStatus('sharedInfoStatus', false);
    updateTermsStatus('loaStatus', false);
    return toggleModal(false);
  };

  var renderButtons = function renderButtons() {
    // I wish these could be in Promise.all()
    // but connect has to be REALLY close to the user clicking
    // or else chrome blocks the popup
    var handleActpBtnClk = function handleActpBtnClk() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.accept],
        dimensions: {
          listingId: listingId,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      postTerms(userId, 'appcenter');

      if (clientOptInType === ADMIN) {
        postTerms(userId, 'loa');
      }

      toggleModal();
      updateTermsStatus('sharedInfoStatus', false);
      return connect(listingId, v1ListingId, userId);
    }; // Button is disabled unless appcenter terms are previously or currently
    // accepted and shared info is currently accepted


    var renderAcceptBtn = function renderAcceptBtn() {
      var disabledBtn = _react.default.createElement("button", {
        className: "btn btn-default btn-lg",
        disabled: true
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "IAgree"
      })); // TODO: do we even need to check previous if we set current = previous on fetch?


      if (!appcenterStatus.currentlyAccepted && !appcenterStatus.previouslyAccepted) {
        return disabledBtn;
      }

      if (!sharedInfoStatus.currentlyAccepted && flow !== 'WEBFLOW') {
        return disabledBtn;
      }

      if (!loa.status.currentlyAccepted && !loa.status.previouslyAccepted && clientOptInType === ADMIN) {
        return disabledBtn;
      }

      return _react.default.createElement("button", {
        className: "btn btn-default btn-lg",
        onClick: handleActpBtnClk
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "IAgree"
      }));
    };

    return _react.default.createElement("div", {
      className: "tandc-buttons"
    }, _react.default.createElement("a", {
      href: "#",
      onClick: handleCancelClick
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Cancel"
    })), renderAcceptBtn());
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", {
    className: "modal-container"
  }, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isTaCModalOpen,
    onRequestClose: toggleModal.bind(null, false),
    contentLabel: "Terms for connecting to listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: handleCancelClick
  }, "\xD7"), _react.default.createElement("h2", null, formatter.formattedMessage({
    id: 'TermsTitle'
  })), _react.default.createElement("hr", null), getContent(), _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "col-xs-12 tc-hr no-padding"
  }, !tAndCLinkClicked && _react.default.createElement("hr", null)), _react.default.createElement("div", {
    className: "col-xs-12 no-padding"
  }, !tAndCLinkClicked && renderButtons(appcenterStatus, sharedInfoStatus)))))));
};

TandC.propTypes = {
  terms: _propTypes.default.shape({
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    appcenterStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object,
    sharedInfo: _propTypes.default.array,
    tAndCLinkClicked: _propTypes.default.bool
  }).isRequired,
  flow: _propTypes.default.string,
  clientOptInType: _propTypes.default.string,
  listing: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  router: _propTypes.default.any,
  // eslint-disable-line react/forbid-prop-types
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  userId: _propTypes.default.string,
  toggleModal: _propTypes.default.func.isRequired,
  toggleNeedAnAccountClicked: _propTypes.default.func,
  updateTermsStatus: _propTypes.default.func.isRequired,
  connect: _propTypes.default.func.isRequired,
  postTerms: _propTypes.default.func.isRequired,
  partnerAppScopes: _propTypes.default.array,
  // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  trackButtonClick: _propTypes.default.func,
  trackLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string
};

var _default = (0, _reactRouter.withRouter)((0, _nuiIntl.withFormatter)(TandC));

exports.default = _default;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(80) : void 0;

var _nuiWidgets = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TermsPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsPanel, _React$Component);

  function TermsPanel() {
    _classCallCheck(this, TermsPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(TermsPanel).apply(this, arguments));
  }

  _createClass(TermsPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showCheckbox = _this$props.showCheckbox,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          title = _this$props.title,
          description = _this$props.description,
          checkboxId = _this$props.checkboxId;
      var showCheckboxStyle = {
        display: showCheckbox ? 'inline' : 'none'
      };

      var tAndCTitle = _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "t-and-c-title"
      }, title), _react.default.createElement("p", {
        className: "t-and-c-description"
      }, _react.default.createElement("span", null, description)));

      return _react.default.createElement("div", {
        className: "term-item-and-box checkbox"
      }, _react.default.createElement("input", {
        id: checkboxId,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        style: showCheckboxStyle
      }), _react.default.createElement(_nuiWidgets.SectionExpandable, {
        expanded: false,
        title: tAndCTitle,
        headingLevel: "h3"
      }, _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "terms-panel-children"
      }, this.props.children))));
    }
  }]);

  return TermsPanel;
}(_react.default.Component);

TermsPanel.propTypes = {
  showCheckbox: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  children: _propTypes.default.any,
  title: _propTypes.default.any,
  description: _propTypes.default.any,
  checkboxId: _propTypes.default.string
};
var _default = TermsPanel;
exports.default = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _reactModal = _interopRequireDefault(__webpack_require__(21));

var _config = _interopRequireDefault(__webpack_require__(13));

var _listingModule = __webpack_require__(6);

var _listingsModule = __webpack_require__(10);

var _utils = __webpack_require__(4);

var AnalyticsModule = _interopRequireWildcard(__webpack_require__(16));

var _analytics = __webpack_require__(12);

var _this = void 0;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnrollModal = function EnrollModal(_ref) {
  var isEnrollModalOpen = _ref.isEnrollModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      checkForConnection = _ref.checkForConnection,
      updateConnectionOnIndex = _ref.updateConnectionOnIndex,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID,
      listingData = _ref.listingData;

  /*
  * This function is a hack. Code in CTE looks for the existance of
  * this function. If it exists, the styles will work without us needing
  * to hack them in. If removed, all hell breaks loose. For the love
  * of God, do not remove.
  */
  window.otHidePopupDialog = function () {};

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.enroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.enroll);
  };

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "JavaScript is Required to Enroll");
  }

  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      overflow: 'scroll',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '90%',
      // ipm uses 835 x 565
      margin: '25px auto',
      overflow: 'scroll'
    }
  };

  var accessIframeEl = function accessIframeEl(selector) {
    var getIframeEl = function getIframeEl() {
      return document.getElementById('autoconnectframe').contentWindow.document;
    };

    var el = getIframeEl().querySelector(selector);

    var listener = function listener(element, cb) {
      element.addEventListener('click', function (event) {
        cb(element, event);
      });
      return {
        addEventListener: listener.bind(_this, element)
      };
    };

    var adjustElement = function adjustElement(element, cb) {
      cb(element);
    };

    return {
      addEventListener: listener.bind(_this, el),
      element: adjustElement.bind(_this, el)
    };
  };

  var keyPressed = function keyPressed(event) {
    if (event.keyCode === 13) {
      toggleThisModal();
    }
  };

  var toggleConnectedStatus = function toggleConnectedStatus() {
    checkForConnection(listingId, v1ListingId);
    updateConnectionOnIndex(listingId, true);
  };

  var counter = 0;

  var addDismissEventListener = function addDismissEventListener() {
    window.setTimeout(function () {
      if (counter < 5) {
        try {
          accessIframeEl('button.ui-button').addEventListener(toggleConnectedStatus).addEventListener(toggleThisModal).addEventListener('keydown', keyPressed);
        } catch (e) {
          addDismissEventListener(counter++);
        }
      }
    }, 500);
  };

  if (isEnrollModalOpen) {
    window.requestAnimationFrame(function () {
      if (document.getElementById('autoconnectframe')) {
        document.getElementById('autoconnectframe').onload = function () {
          accessIframeEl('#enrollbutton').addEventListener(addDismissEventListener);
          accessIframeEl('a.cnqr-connect-appcenter-autoconnect-button-cancel').addEventListener(function () {
            toggleThisModal();
          });
        };
      }
    });
  }

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", {
    className: "modal-container"
  }, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isEnrollModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Enroll in listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-10 col-xs-offset-1"
  }, _react.default.createElement("iframe", {
    name: "autoconnect",
    style: {
      border: 'none',
      overflow: 'scroll'
    },
    width: "100%",
    height: "580px",
    id: "autoconnectframe",
    src: "".concat(_config.default.enrollModalBase, "/UI/appcenter/AutoConnect?source=ipm")
  })), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7")))));
};

EnrollModal.propTypes = {
  isEnrollModalOpen: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.func.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  listingId: _propTypes.default.string.isRequired,
  v1ListingId: _propTypes.default.string.isRequired,
  updateConnectionOnIndex: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  trackButtonClick: _propTypes.default.func,
  userId: _propTypes.default.string,
  companyUUID: _propTypes.default.string,
  listingName: _propTypes.default.string,
  listingData: _propTypes.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnrollModalOpen: state.listing.isEnrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID,
    listingData: state.listing
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  toggle: _listingModule.toggleModal,
  checkForConnection: _listingModule.checkForConnection,
  updateConnectionOnIndex: _listingsModule.updateConnectedStatus,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(EnrollModal);

exports.default = _default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiIntl = __webpack_require__(3);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _reactModal = _interopRequireDefault(__webpack_require__(21));

var _listingModule = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _trackClick = __webpack_require__(11);

var AnalyticsModule = _interopRequireWildcard(__webpack_require__(16));

var _analytics = __webpack_require__(12);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var UnenrollModal = function UnenrollModal(_ref) {
  var isUnenrollModalOpen = _ref.isUnenrollModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      unenroll = _ref.unenroll,
      userId = _ref.userId,
      listingId = _ref.listingId,
      companyUUID = _ref.companyUUID,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData,
      trackButtonClick = _ref.trackButtonClick;
  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.unenroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.unenroll);
  };

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "Javascript is Required to Unenroll");
  }

  var handleUnenroll = function handleUnenroll() {
    toggleThisModal();
    return unenroll(listingId, v1ListingId);
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'BUTTON',
        v2_listing_id: listingId,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isUnenrollModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Unenroll from listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Confirmation"
  }))), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "icon-messaging-warning icon-size-lg"
  })), _react.default.createElement("div", {
    className: "col-xs-11",
    style: {
      paddingTop: '17px'
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "UnenrollAreYouSure"
  }))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: handleUnenroll
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Yes"
  })), {
    value: 'UNENROLL_MODAL_YES'
  }), trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px'
    },
    className: "btn btn-lg btn-default cnqr-muted pull-right",
    onClick: toggleThisModal
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "No"
  })), {
    value: 'UNENROLL_MODAL_NO'
  })))));
};

var mapStateToUnenrollProps = function mapStateToUnenrollProps(state) {
  return {
    isUnenrollModalOpen: state.listing.isUnenrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    options: state.listing.modalOptions,
    listingData: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
};

UnenrollModal.propTypes = {
  isUnenrollModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  unenroll: _propTypes.default.func.isRequired,
  toggle: _propTypes.default.func.isRequired,
  userId: _propTypes.default.string,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object,
  companyUUID: _propTypes.default.string,
  trackButtonClick: _propTypes.default.func
};

var _default = (0, _reactRedux.connect)(mapStateToUnenrollProps, {
  toggle: _listingModule.toggleModal,
  unenroll: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(UnenrollModal);

exports.default = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _reactModal = _interopRequireDefault(__webpack_require__(21));

var _listingModule = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _trackClick = __webpack_require__(11);

var AnalyticsModule = _interopRequireWildcard(__webpack_require__(16));

var _analytics = __webpack_require__(12);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var DisconnectModal = function DisconnectModal(_ref) {
  var isDisconnectModalOpen = _ref.isDisconnectModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      disconnect = _ref.disconnect,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.disconnect);
  };

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "JavaScript is Required to Disconnect");
  }

  var handleDisconnect = function handleDisconnect(buttonType) {
    if (buttonType === _analytics.button.yes) {
      disconnect(listingId, v1ListingId);
    }

    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.disconnect, buttonType],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggleThisModal();
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'BUTTON',
        v2_listing_id: listingId,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isDisconnectModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Disconnect from listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Confirmation"
  }))), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "icon-messaging-warning icon-size-lg"
  })), _react.default.createElement("div", {
    className: "col-xs-11",
    style: {
      paddingTop: '17px'
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "DisconnectAreYouSure"
  }))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: function onClick() {
      return handleDisconnect(_analytics.button.yes);
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Yes"
  })), {
    value: 'DISCONNECT_MODAL_YES'
  }), trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px'
    },
    className: "btn btn-lg btn-default cnqr-muted pull-right",
    onClick: function onClick() {
      return handleDisconnect(_analytics.button.no);
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "No"
  })), {
    value: 'DISCONNECT_MODAL_NO'
  })))));
};

var mapStateToDisconnectProps = function mapStateToDisconnectProps(state) {
  return {
    isDisconnectModalOpen: state.listing.isDisconnectModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID
  };
};

DisconnectModal.propTypes = {
  isDisconnectModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  disconnect: _propTypes.default.func.isRequired,
  toggle: _propTypes.default.func.isRequired,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object,
  trackButtonClick: _propTypes.default.func,
  userId: _propTypes.default.string,
  companyUUID: _propTypes.default.string
};

var _default = (0, _reactRedux.connect)(mapStateToDisconnectProps, {
  toggle: _listingModule.toggleModal,
  disconnect: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(DisconnectModal);

exports.default = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var _reactModal = _interopRequireDefault(__webpack_require__(21));

var _listingModule = __webpack_require__(6);

var _trackClick = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var isConfirmationModalOpen = _ref.isConfirmationModalOpen,
      modalNames = _ref.modalNames,
      toggle = _ref.toggle,
      options = _ref.options,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.confirmation);
  };

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var getModalHeader = function getModalHeader() {
    if (options.listingType === 'ACONCT') {
      return options.disconnectSuccess ? _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "UnenrollSuccessful"
      }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "UnenrollFail"
      });
    }

    return options.disconnectSuccess ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectSuccessful"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectFail"
    });
  };

  var getModalBody = function getModalBody() {
    return options.disconnectSuccess ? _react.default.createElement("div", {
      className: "row"
    }, _react.default.createElement("div", {
      className: "col-xs-1"
    }, _react.default.createElement("span", {
      className: "confirmation-icon icon-messaging-success icon-size-lg",
      style: {
        color: '#3A7827'
      }
    })), _react.default.createElement("div", {
      className: "col-xs-11",
      style: {
        paddingTop: '17px'
      }
    }, options.listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "UnenrollSuccessfulMessage"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectSuccessfulMessage"
    }))) : _react.default.createElement("div", {
      className: "row"
    }, _react.default.createElement("div", {
      className: "col-xs-1"
    }, _react.default.createElement("span", {
      className: "confirmation-icon icon-messaging-error icon-size-lg",
      style: {
        color: '#CE202D'
      }
    })), _react.default.createElement("div", {
      className: "col-xs-11",
      style: {
        paddingTop: '17px'
      }
    }, options.listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "UnenrollFailMessage"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectFailMessage"
    })));
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isConfirmationModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Confirmation Modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, getModalHeader())), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), getModalBody(), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement(_trackClick.Tracked, {
    event: "CLICK",
    additional: {
      context: 'LISTING_DETAILS',
      type: 'BUTTON',
      value: 'DISCONNECT_CONF_MODAL_OK',
      v2_listing_id: listingId,
      app_name: listingName,
      domain: window.location.hostname
    }
  }, _react.default.createElement("button", {
    style: {
      width: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: toggleThisModal
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Ok"
  })))))));
};

var mapStateToConfirmationProps = function mapStateToConfirmationProps(state) {
  return {
    isConfirmationModalOpen: state.listing.isConfirmationModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    options: state.listing.modalOptions
  };
};

ConfirmationModal.propTypes = {
  isConfirmationModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  options: _propTypes.default.object.isRequired,
  toggle: _propTypes.default.func.isRequired,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object
};

var _default = (0, _reactRedux.connect)(mapStateToConfirmationProps, {
  toggle: _listingModule.toggleModal
})(ConfirmationModal);

exports.default = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var OFFERING_TYPES = {
  EXPSTD: 'Expense - Standard',
  EXPPRO: 'Expense - Professional',
  INVSTD: 'Invoice - Standard',
  INVPRO: 'Invoice - Professional',
  TRVSTD: 'Travel - Standard',
  TRVPRO: 'Travel - Professional',
  TRQPRO: 'Travel Request - Professional',
  TRIPLINK: 'TripLink'
};
var _default = OFFERING_TYPES;
exports.default = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var REGIONS = {
  northAmerica: 'NA',
  latinAmerica: 'LA',
  emea: 'EMEA',
  asia: 'APA'
};
var _default = REGIONS;
exports.default = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Search = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactHelmet = _interopRequireDefault(__webpack_require__(20));

var _reactRedux = __webpack_require__(5);

var _nuiIntl = __webpack_require__(3);

var ListingsActions = _interopRequireWildcard(__webpack_require__(10));

var _Header = _interopRequireDefault(__webpack_require__(27));

var _CommonSections = _interopRequireDefault(__webpack_require__(75));

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Search =
/*#__PURE__*/
function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.dispatchSearch = _this.dispatchSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          params = _this$props.params,
          setAndFilter = _this$props.setAndFilter;

      if (this.props.context.isPublic) {
        if ((0, _utils.canUseDOM)() && window.utag) {
          (0, _utils.sendPublicView)();
        }
      }

      ListingsActions.setAndFilter((0, _utils.escapeHTML)(params.term));
    }
  }, {
    key: "dispatchSearch",
    value: function dispatchSearch(val) {
      this.props.dispatch(ListingsActions.fetchListingsIfNeeded());
      this.props.dispatch(ListingsActions.setAndFilter(val));
    }
  }, {
    key: "render",
    value: function render() {
      var term = this.props.params.term;
      var sanitizedTerm = (0, _utils.escapeHTML)(term);
      return _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12"
      }, _react.default.createElement(_reactHelmet.default, {
        title: this.props.context.getTitle("Search: ".concat(sanitizedTerm))
      }), _react.default.createElement(_Header.default, null), _react.default.createElement("h2", {
        id: "ac-search-results-for",
        style: {
          textTransform: 'none'
        }
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "ShowingResultsFor",
        values: {
          term: sanitizedTerm
        }
      })), _react.default.createElement("hr", null), _react.default.createElement(_CommonSections.default, null)));
    }
  }]);

  return Search;
}(_react.Component);

exports.Search = Search;
Search.propTypes = {
  dispatch: _propTypes.default.func,
  params: _propTypes.default.shape({
    term: _propTypes.default.string
  }),
  fetchListingsIfNeeded: _propTypes.default.func,
  setAndFilter: _propTypes.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

var mapDispatchToProps = {
  fetchListingsIfNeeded: ListingsActions.fetchListingsIfNeeded,
  setAndFilter: ListingsActions.setAndFilter
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search));

exports.default = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(5);

var _termsModule = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var createHTMLMarkup = function createHTMLMarkup(html) {
  return {
    __html: html
  };
};

var TermsPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsPage, _React$Component);

  function TermsPage() {
    _classCallCheck(this, TermsPage);

    return _possibleConstructorReturn(this, _getPrototypeOf(TermsPage).apply(this, arguments));
  }

  _createClass(TermsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.fetchLOAContent();
    }
  }, {
    key: "render",
    value: function render() {
      var loaHtml = this.props.loaHtml;
      var re = /<style>\s+(.*)\s+<\/style>/;
      loaHtml = loaHtml && loaHtml.replace(re, '$1');
      return _react.default.createElement("div", {
        style: {
          padding: '20px',
          fontSize: '1.2em',
          lineHeight: '1.6'
        },
        dangerouslySetInnerHTML: createHTMLMarkup(loaHtml)
      });
    }
  }]);

  return TermsPage;
}(_react.default.Component);

TermsPage.propTypes = {
  fetchLOAContent: _propTypes.default.func.isRequired
};

function mapStateToProps(state) {
  var _state$terms = state.terms;
  _state$terms = _state$terms === void 0 ? {} : _state$terms;
  var _state$terms$loa$cont = _state$terms.loa.content;
  _state$terms$loa$cont = _state$terms$loa$cont === void 0 ? {} : _state$terms$loa$cont;
  var loaHtml = _state$terms$loa$cont.html;
  return {
    loaHtml: loaHtml
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchLOAContent: _termsModule.fetchLOAContent
})(TermsPage);

exports.default = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(1));

var _nuiIntl = __webpack_require__(3);

var _reactRouter = __webpack_require__(8);

var _reactHelmet = _interopRequireDefault(__webpack_require__(20));

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

var _Header = _interopRequireDefault(__webpack_require__(27));

var _Help = _interopRequireDefault(__webpack_require__(278));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HelpContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(HelpContainer, _Component);

  function HelpContainer() {
    _classCallCheck(this, HelpContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(HelpContainer).apply(this, arguments));
  }

  _createClass(HelpContainer, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactHelmet.default, {
        title: this.props.context.getTitle('Help')
      }), _react.default.createElement(_Header.default, {
        listingId: "help"
      }), _react.default.createElement("div", {
        className: "details-container"
      }, _react.default.createElement("span", null, _react.default.createElement(_reactRouter.Link, {
        to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
        onClick: function onClick() {
          return document.title = _this.props.context.getTitle(_utils.HOME);
        }
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "BackToAppCenter"
      }))), _react.default.createElement(_Help.default, this.props)));
    }
  }]);

  return HelpContainer;
}(_react.Component);

var _default = (0, _withAppContext.withAppContext)(HelpContainer);

exports.default = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactRouter = __webpack_require__(8);

var _nuiIntl = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _withAppContext = __webpack_require__(9);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(279) : void 0;

var _confirm = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(280) : void 0);

var _enterpriseConnect = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(281) : void 0);

var _exampleApp = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(282) : void 0);

var _search = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(283) : void 0);

var _supportLink = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(284) : void 0);

var _userConnect = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? __webpack_require__(285) : void 0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Help =
/*#__PURE__*/
function (_Component) {
  _inherits(Help, _Component);

  function Help() {
    _classCallCheck(this, Help);

    return _possibleConstructorReturn(this, _getPrototypeOf(Help).apply(this, arguments));
  }

  _createClass(Help, [{
    key: "render",
    value: function render() {
      var _this = this;

      var linkToAppCenter = _react.default.createElement(_reactRouter.Link, {
        to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
        onClick: function onClick() {
          return document.title = _this.props.context.getTitle(_utils.HOME);
        }
      }, _react.default.createElement("span", null, "SAP ", _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "AppCenterHeader"
      })));

      return _react.default.createElement("div", {
        className: "help"
      }, _react.default.createElement("div", {
        className: "intro"
      }, _react.default.createElement("h1", null, "Need help?"), _react.default.createElement("p", null, "Use these FAQs to leverage the SAP Concur App Center effectively.")), _react.default.createElement("div", {
        className: "what-is-app-center"
      }, _react.default.createElement("h2", null, "What is the App Center?"), _react.default.createElement("div", null, _react.default.createElement("span", null, "The App Center offers pre-built partner integrations with SAP Concur core products to help solve challenges you and your business face. Whether you are looking for ways to enhance the traveler experience, streamline billing and financial processes, or ensure compliance with tax and immigration regulations around the globe \u2013 you'll find apps for individual employees and for company-wide use:")), _react.default.createElement("div", null, _react.default.createElement("ul", null, _react.default.createElement("li", null, _react.default.createElement("span", null, _react.default.createElement("b", null, "User Connections"), ": Individual travelers can link these to your SAP Concur account to receive e-receipts or to improve the travel experience. Popular apps include Lyft, United, TripLingo and more.")), _react.default.createElement("li", null, _react.default.createElement("span", null, _react.default.createElement("b", null, "Enterprise Applications"), ": These applications are enabled by an SAP Concur administrator at a site level to solve a variety of business needs, including regulatory compliance, spend management, and financial systems integration."))))), _react.default.createElement("div", {
        className: "partner-support"
      }, _react.default.createElement("h2", null, "Where do I go for support on partner applications?"), _react.default.createElement("div", null, _react.default.createElement("span", null, "Once you've deployed a partner integration, App Center partners provide first-level support for their integrations with SAP Concur. To contact App Center partners for application support, please follow these steps:")), _react.default.createElement("div", null, _react.default.createElement("ol", null, _react.default.createElement("li", null, _react.default.createElement("p", null, "Go to the ", linkToAppCenter, " or within the App Center tab in the SAP Concur product")), _react.default.createElement("li", null, _react.default.createElement("p", null, "Use the search bar to find the partner application"), _react.default.createElement("img", {
        src: _search.default
      })), _react.default.createElement("li", null, _react.default.createElement("p", null, "Click on the partner's App Center listing tile"), _react.default.createElement("img", {
        src: _exampleApp.default
      })), _react.default.createElement("li", null, _react.default.createElement("p", null, "Click on the blue \"Support\" link found in the middle of the page"), _react.default.createElement("img", {
        src: _supportLink.default
      })))), _react.default.createElement("div", null, _react.default.createElement("span", null, "The Support link will give you the App Center partner's contact information for support. If the App Center partner needs to work with SAP Concur to solve the issue, they will submit a case on your behalf. For SAP Concur support questions that do not relate to App Center partner applications, please contact SAP Concur support. You can find more information on ", _react.default.createElement("a", {
        href: "https://www.concur.com/en-us/support"
      }, "concur.com/en-us/support"), "."))), _react.default.createElement("div", {
        className: "how-to-connect"
      }, _react.default.createElement("h2", null, "How do I connect an app?"), _react.default.createElement("div", {
        className: "user-app-connect"
      }, _react.default.createElement("h3", null, _react.default.createElement("u", null, "User Connection Applications")), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-6 col-xs-6"
      }, _react.default.createElement("span", null, _react.default.createElement("b", null, "Connecting via the App Center"), ": Click \"Connect\" on the top right in the partner's App Center listing page, accept the Terms & Conditions, and then follow the instructions in the pop-up to login or create an account.")), _react.default.createElement("div", {
        className: "col-md-2 col-xs-3"
      }, _react.default.createElement("img", {
        src: _userConnect.default
      }))), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("b", null, "Connecting via the SAP Concur Mobile Application"), ": Certain applications are available to connect within the SAP Concur mobile application. To access this feature, select the \"settings\" menu in the top left, and then click \"Connect to Apps.\"")), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("b", null, "Note"), ": Administrators may disable user connection apps that are outside company policy. In the SAP Concur Administration menu, click \"Company\" >> \"Web Services\" >> \"Manage User Applications.\""))), _react.default.createElement("div", {
        className: "enterprise-app-connect"
      }, _react.default.createElement("h3", null, _react.default.createElement("u", null, "Enterprise Applications")), _react.default.createElement("div", null, _react.default.createElement("span", null, "Once you have contracted with a partner to utilize their service, an authorized administrator can enable the application. Depending on the app, it will be enabled in one of two ways:")), _react.default.createElement("div", null, _react.default.createElement("p", null, _react.default.createElement("b", null, "Enablement via the App Center Listing"))), _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-6 col-xs-6"
      }, _react.default.createElement("ol", null, _react.default.createElement("li", null, _react.default.createElement("p", null, "Click \"Connect\" on the partner's App Center listing page.", _react.default.createElement("sup", null, "*"))), _react.default.createElement("li", null, _react.default.createElement("p", null, "Check the boxes to accept the terms and click \"I agree.\"")), _react.default.createElement("li", null, _react.default.createElement("span", null, "In the resulting pop-up, enter in the activation code or login information provided by the partner after contracting with them. In some cases, you will be prompted to create a new login.")), _react.default.createElement("li", null, _react.default.createElement("span", null, "Follow the instructions provided by the partner to complete your activation in the following screens")), _react.default.createElement("li", null, _react.default.createElement("p", null, "Done! Data can now flow between the solutions")))), _react.default.createElement("div", {
        className: "col-md-2 col-xs-3"
      }, _react.default.createElement("img", {
        src: _enterpriseConnect.default
      })))), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("sup", null, "*"), _react.default.createElement("i", null, "Only SAP Concur Administrators with the \"Web Services Administrator\" role are able to click the \"Connect\" button on Enterprise Applications. The \"Connect\" button will be grayed out for any users without the correct role. To receive Web Services Administrator permissions, create a ticket with the SAP Concur Helpdesk or ask your authorized SAP Concur Administrator to assign the role to you."))), _react.default.createElement("div", null, _react.default.createElement("p", null, _react.default.createElement("b", null, "Enablement via the Enable Partner Applications Settings"))), _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-5 col-xs-5"
      }, _react.default.createElement("ol", null, _react.default.createElement("li", null, _react.default.createElement("span", null, "Work with the partner to sign a contract, submit a signed Letter of Authorization to link accounts, and plan your roll-out.")), _react.default.createElement("li", null, _react.default.createElement("span", null, "In the SAP Concur Administration menu, click Company >> Web Services >> Enable Partner Applications.")), _react.default.createElement("li", null, _react.default.createElement("span", null, "Select the partner app you are connecting and then click \"Enable\" at the top of the page, then \"Yes\" to confirm.")), _react.default.createElement("li", null, _react.default.createElement("span", null, "Inform the partner. They will need to take additional steps to complete your roll-out.")))), _react.default.createElement("div", {
        className: "col-md-2 col-xs-3"
      }, _react.default.createElement("img", {
        src: _confirm.default
      }))))), _react.default.createElement("div", {
        className: "application-disable"
      }, _react.default.createElement("h3", null, _react.default.createElement("u", null, "Application Disablement:")), _react.default.createElement("span", null, "If you need to disconnect an application, you can do that by returning to the same pages and then selecting the option to disconnect."))));
    }
  }]);

  return Help;
}(_react.Component);

var _default = (0, _withAppContext.withAppContext)(Help);

exports.default = _default;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/confirm.293dbfa6a853e949cfef7cd8f5bcbc82.png";

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/enterprise-connect.7a1aaf23e1a91b47a9baf27850bb2fb3.png";

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/example-app.13c07aca2951049b9748a805922507f3.png";

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/search.5283bf396e83d4f774825f094bd123a3.png";

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/support-link.20c0286266a82b8ccbf14138edcc9ec3.png";

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "static/styles/images/user-connect.611e0d5458f8f0c7bc39d111dbfef1de.png";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactHelmet = _interopRequireDefault(__webpack_require__(20));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundRedirect = function NotFoundRedirect() {
  return _react.default.createElement(_reactHelmet.default, {
    meta: [{
      'http-equiv': 'refresh',
      content: '0;URL="/404"'
    }]
  });
};

var _default = NotFoundRedirect;
exports.default = _default;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.529fb2e0876743225c62.js